/**
 * @file Generated by generate-resources.ts
 */

export const i18nResources = {
  "it": {
    "translation": {
      "array.max_one": "Il campo {{path}} deve avere al massimo {{count}} elemento",
      "array.max_many": "Il campo {{path}} deve avere al massimo {{count}} elementi",
      "array.max_other": "Il campo {{path}} deve avere al massimo {{count}} elementi",
      "array.min_one": "Il campo {{path}} deve avere almeno {{count}} elemento",
      "array.min_many": "Il campo {{path}} deve avere almeno {{count}} elementi",
      "array.min_other": "Il campo {{path}} deve avere almeno {{count}} elementi",
      "mixed.default": "Il campo ${path} non è valido",
      "mixed.defined": "Il campo ${path} è un campo richiesto",
      "mixed.notNull": "Il campo ${path} non può essere lasciato vuoto",
      "mixed.notOneOf": "Il campo ${path} non deve avere uno dei seguenti valori: ${values}",
      "mixed.oneOf": "Il campo ${path} deve avere uno dei seguenti valori: ${values}",
      "mixed.required": "Il campo ${path} è un campo richiesto",
      "notType.default": "Il campo {{path}} non è valido",
      "notType.number": "Il campo {{path}} deve essere un numero",
      "notType.string": "Il campo {{path}} deve essere una stringa",
      "number.integer": "Il campo ${path} deve essere un numero intero",
      "number.lessThan": "Il campo ${path} deve essere minore di ${less}",
      "number.max": "Il campo ${path} deve essere minore o uguale di ${max}",
      "number.min": "Il campo ${path} deve essere maggiore o uguale di ${min}",
      "number.moreThan": "Il campo ${path} deve essere maggiore di ${more}",
      "number.negative": "Il campo ${path} deve essere un numero negativo",
      "number.positive": "Il campo ${path} deve essere un numero positivo",
      "string.email": "Il campo ${path} deve essere una email valida",
      "string.length": "Il campo ${path} deve avere esattamente ${length} caratteri",
      "string.lowercase": "Il campo ${path} deve contenere solamente caratteri minuscoli",
      "string.matches": "Il campo ${path} deve seguire il seguente pattern: \"${regex}\"",
      "string.max": "Il campo ${path} deve avere al massimo ${max} caratteri",
      "string.min": "Il campo ${path} deve avere almeno ${min} caratteri",
      "string.trim": "Il campo ${path} deve essere un testo senza spazi iniziali o finali",
      "string.uppercase": "Il campo ${path} deve contenere solamente caratteri maiuscoli",
      "string.url": "Il campo ${path} deve essere un URL valido",
      "advanced-search.collapse-form-messagge": "risultati trovati in base ai filtri di ricerca.",
      "advanced-search.filtri": "Filtri",
      "advanced-search.remove-filters": "Rimuovi filtri",
      "advanced-search.tag-semantici": "Altri campi specializzati",
      "alert.alert-error-body.message": "Sì è verificato un errore nella richiesta.",
      "alert.error-result-body.message": "Sì è verificato un errore nella richiesta.",
      "alert.error-result-body.title": "Errore Network",
      "alert.forbidden-body.message": "Non si dispone dei permessi per visualizzare la pagina richiesta.",
      "alert.forbidden-body.title": "403 Non Autorizzato",
      "alert.internal-error-body.subtitle": "Si è verificato un errore non previsto del server. Si prega di riprovare o contattare l'assistenza.",
      "alert.internal-error-body.title": "500 Errore Interno del Server",
      "alert.not-found-body.subtitle": "Pagina Non Trovata.",
      "alert.not-found-body.title": "404 Non Trovato",
      "button.button-delete-confirm.content": "Elimina",
      "button.button-delete-confirm.icon-aria": "Elimina elemento",
      "button.button-delete-confirm.ok": "Elimina",
      "button.button-delete-confirm.title": "Sei sicuro di voler eliminare questo elemento?",
      "button.button-delete-confirm.tooltip": "Elimina elemento",
      "button.confirm-button.cancel": "Annulla",
      "button.confirm-button.confirm": "Conferma",
      "button.confirm-button.title": "Sei sicuro di voler continuare con l'operazione?",
      "button.content-hover-add": "Aggiungi",
      "button.content-hover-config": "Configura",
      "button.content-hover-delete": "Elimina",
      "button.content-hover-edit": "Modifica",
      "button.content-hover-edit-info-aria-label": "Informazioni aggiuntive",
      "button.content-hover-edit-info-dinamico": "Questo modulo si attiva in base alla compilazione di un altro modulo, nell'ordine configurato. Potrebbe non comparire nella compilazione della Domanda.",
      "button.content-hover-edit-info-dinamico-title": "Modulo ad attivazione dinamica",
      "button.content-hover-edit-info-principale": "È sempre richiesto e viene presentato per primo in compilazione.",
      "button.content-hover-edit-info-principale-title": "Modulo principale della Domanda",
      "button.content-hover-edit-info-secondario": "Viene presentato dopo il principale, nell'ordine configurato.",
      "button.content-hover-edit-info-secondario-title": "Modulo secondario",
      "card.network-responsive-card.error": "Errore",
      "collapse.collapsible-area.hidden-header": "Collapsible Area",
      "collapse.desktop-filter-panel.title": "Filtri di ricerca estesi",
      "collapse.filter-button.content": "Ricerca Estesa",
      "collapse.filter-button.tooltip": "Filtri di ricerca attivi",
      "collapse.filter-button.tooltip-aria": "Filtri di ricerca attivi",
      "collapse.filtri-di-ricerca": "Filtri di Ricerca",
      "collapse.ghost-collapse.header": "Ghost Extend Collapse",
      "column-picker.add-extra-column-button.label": "Altri campi specializzati",
      "column-picker.boxed-switch-text": "BOXED",
      "column-picker.config-drawer-tooltip": "Cambia larghezza tabella",
      "column-picker.drawer-title": "Configurazione Colonne",
      "column-picker.full-switch-text": "FULL",
      "column-picker.remove-extra-column-button.aria-label": "Rimuovi",
      "column-picker.remove-extra-column-button.tooltip": "Rimuovi campo specializzato",
      "column-picker.show-in-expanded-row.tooltip": "Mostra in riga espansa",
      "column-picker.switch-show-column.sr-only-text": "Visibilità Campo",
      "common.paginazione.aria-label": "Paginazione",
      "common.paginazione.precedente": "Vai alla pagina precedente",
      "common.paginazione.successiva": "Vai alla pagina successiva",
      "countdown-humanized.days": "giorni",
      "countdown-humanized.label": "Tempo rimanente",
      "countdown-humanized.more-months": "Più di due mesi",
      "countdown-humanized.more-years": "Più di un anno",
      "drawer.close-aria": "Chiudi Pannello",
      "dropdown.risultati-per-ricerca": "Risultati per \"{{search}}\"",
      "dropdown.search-dropdown.no-reseults": "Nessun risultato trovato",
      "dropdown.search-dropdown.search": "Scrivi per iniziare a cercare",
      "filter-bar.add-filter-button": "Filtri di Ricerca",
      "filter-bar.add-filter-chip": "Filtro",
      "filter-bar.apply": "Applica",
      "filter-bar.back": "Indietro",
      "filter-bar.cancel": "Annulla",
      "filter-bar.clear": "Pulisci",
      "filter-bar.field-type.custom": "lista",
      "filter-bar.field-type.date": "data",
      "filter-bar.field-type.date-range": "intervallo date",
      "filter-bar.field-type.number": "numero",
      "filter-bar.field-type.number-range": "intervallo numerico",
      "filter-bar.field-type.radio": "lista",
      "filter-bar.field-type.select": "lista",
      "filter-bar.field-type.switch": "booleano",
      "filter-bar.field-type.text": "testo",
      "filter-bar.filtered-results-message": "elementi trovati in base ai filtri di ricerca.",
      "filter-bar.no": "No",
      "filter-bar.no-field-found": "Nessun campo trovato",
      "filter-bar.range-from": "Dal {{value}}",
      "filter-bar.range-from-num": "Da {{value}}",
      "filter-bar.range-to": "Al {{value}}",
      "filter-bar.range-to-num": "A {{value}}",
      "filter-bar.read-only-value": "—",
      "filter-bar.refresh": "Aggiorna",
      "filter-bar.remove-all": "Rimuovi tutti",
      "filter-bar.remove-filter-aria": "Rimuovi filtro {{label}}",
      "filter-bar.search-field-placeholder": "Cerca campo…",
      "filter-bar.selected-count_one": "{{count}} selezionati",
      "filter-bar.selected-count_many": "{{count}} selezionati",
      "filter-bar.selected-count_other": "{{count}} selezionati",
      "filter-bar.sort.aria": "Ordinamento: {{field}}, {{direction}}. Premi per modificare.",
      "filter-bar.sort.aria-empty": "Ordinamento. Premi per scegliere.",
      "filter-bar.sort.direction-label": "Direzione ordinamento",
      "filter-bar.sort.field-label": "Campo da ordinare",
      "filter-bar.sort.field-placeholder": "Seleziona un campo…",
      "filter-bar.sort.label": "Ordinamento:",
      "filter-bar.yes": "Sì",
      "layout.page-layout-base.top-bar-aria": "Vai all’inizio della pagina",
      "layout.version-info.app": "Applicativo {{version}}",
      "layout.version-info.frontend": "Frontend {{version}}",
      "loader.loader-spin.icon-aria": "Caricamento...",
      "message-filtered-list.invisible.sr-default-message": "Nessun filtro applicato",
      "moddal.modal-confirm.delete": "Elimina",
      "route-announcer.nav-to-page": "Navigato a {{title}}",
      "router.breadcrumbs.home-aria": "Home",
      "search.advanced-search.filter-add.label": "Aggiungi Filtro",
      "search.advanced-search.filter-add.select-placeholder": "Aggiungi Filtro",
      "search.component.advanced-search-field.date.placeholder-fallback": "GG/MM/AAAA",
      "search.component.order-row.remove-order-button.aria-label": "Cambia Ordinamento",
      "search.component.order-row.remove-order-button.tooltips": "Click per cambiare Ordinamento",
      "search.component.order-row.select-direction.option.asc": "Ascendente",
      "search.component.order-row.select-direction.option.desc": "Discendente",
      "search.component.order-row.select-direction.placeholder": "Direzione ordinamento...",
      "search.component.order-row.select-field.placeholder": "Seleziona un campo per l'ordinamento...",
      "search.component.search-actions.reset-button.text": "Rimuovi filtri",
      "search.component.search-actions.save-filter-button.arial-label": "Salva Selezione Filtri",
      "search.component.search-actions.save-filter-button.tooltips": "Salva Selezione Filtri",
      "search.component.search-actions.submit-button.pristine-message": "Nessun filtro selezionato",
      "search.component.search-actions.submit-button.text": "Cerca",
      "search.component.search-row.remove-filter-button.aria-label": "Rimuovi Filtro",
      "search.component.search-row.remove-filter-button.tooltips": "Rimuovi Filtro",
      "skip-links.open-menu": "Apri il menu di navigazione Skip Link",
      "table.copyable-id.copied": "ID: {{id}} copiato!",
      "table.copyable-id.copy": "Copia ID: {{id}}",
      "table.copyable-id.no-id": "ID non presente!",
      "table.filter-dropdown-search.reset": "Reset",
      "table.filter-dropdown-search.search": "Cerca",
      "table.table-column-filter-buttons.reset": "Reset",
      "table.table-column-filter-buttons.search": "Cerca",
      "table.table-column-filter.date-range-from-placeholder": "Da: DD/MM/YYYY",
      "table.table-column-filter.date-range-to-placeholder": "A: DD/MM/YYYY",
      "table.table-column-filter.text-placeholder": "Cerca",
      "table.table-data-filter-panel.reset": "Pulisci",
      "table.table-data-filter-panel.search": "Cerca",
      "table.table-date-from.from": "Dal",
      "ui.ellipsis.collapse": "contrai",
      "ui.ellipsis.expand": "espandi",
      "use-pagination-a11y.current-page-sr-message-total": "Pagina corrente {{page}} di {{total}}.",
      "async-value-widget.error-message": "Si è verificato un errore, riprova più tardi",
      "divider-widget.new-divider-title": "Nuovo titolo divisore",
      "info-widget.collapse": "Contrai",
      "info-widget.expand": "Espandi",
      "info-widget.new-info-message": "Nuovo messaggio informativo",
      "inputs.rich-text-advanced-link-node.screen-reader-content": "(Si apre in una nuova finestra)",
      "paragraph-widget.new-paragraph": "Nuovo paragrafo",
      "payment-row-widget.base-unit-amount": "Importo Listino",
      "payment-row-widget.description": "Descrizione",
      "payment-row-widget.discount": "Sconto/Esenzione",
      "payment-row-widget.quantity": "Quantità",
      "payment-row-widget.taxable-amount": "Imponibile",
      "payment-row-widget.title": "Includi nel pagamento",
      "payment-row-widget.total": "Totale",
      "payment-row-widget.unit": "Unità di Misura",
      "payment-row-widget.unit-amount": "Importo Unitario",
      "payment-row-widget.vat": "IVA",
      "payment-row-widget.vat-amount": "IVA",
      "required-rule.boolean-message": "Il campo ${label} è un campo richiesto",
      "rules.confirm-widget-required.error": "È necessario confermare i dati mostrati oppure modificarli.",
      "rules.date-range.max-date": "La data deve essere precedente al {{to_date}}",
      "rules.date-range.min-date": "La data deve essere successiva al {{from_date}}",
      "rules.fraction-digits.max": "Il campo ${label} non può avere più di {{max}} cifre decimali",
      "rules.item-range.min": "Il campo ${label} deve contenere almeno {{min}} elementi",
      "rules.text-format.number": "Il campo ${label} non è un numero.",
      "rules.text-format.phone": "Il campo ${label} non è un numero di telefono.",
      "rules.total-digits.max": "Il campo ${label} non può avere più di {{max}} cifre",
      "rules.unique-field-rule.error": "La combinazione dei campi {{labels}} deve essere univoca",
      "rules.value-range.max": "Il campo ${label} deve essere minore o uguale a {{max}}",
      "rules.value-range.max-exclusive": "Il campo ${label} deve essere minore di {{max}}",
      "rules.value-range.min": "Il campo ${label} deve essere maggiore o uguale a {{min}}",
      "rules.value-range.min-exclusive": "Il campo ${label} deve essere maggiore di {{min}}",
      "subsection.drawer.button.back": "Indietro",
      "ui.info-icon.content": "Testo informativo aggiuntivo",
      "widgets.add-row-buttton.add": "Aggiungi",
      "widgets.add-row-buttton.max-options-reached": "Numero massimo di opzioni raggiunte",
      "widgets.advanced-multi-select.modal-select-option-title": "Seleziona Opzioni",
      "widgets.advanced-multi-select.selection-counter": "{{selectedCount}} selezionati / {{totalCount}} totali",
      "widgets.advanced-select.cancel-changes-button": "Annulla",
      "widgets.advanced-select.cancel-changes-confirm-cancel": "Continua",
      "widgets.advanced-select.cancel-changes-confirm-content": "La selezione verrà ripristinata al valore precedente all'apertura del popup.",
      "widgets.advanced-select.cancel-changes-confirm-ok": "Annulla modifiche",
      "widgets.advanced-select.cancel-changes-confirm-title": "Annullare le modifiche?",
      "widgets.advanced-select.confirm-button-text": "Conferma",
      "widgets.advanced-select.delete-selection": "Cancella",
      "widgets.advanced-select.delete-selection-confirm-cancel": "Indietro",
      "widgets.advanced-select.delete-selection-confirm-content": "La selezione corrente verrà rimossa.",
      "widgets.advanced-select.delete-selection-confirm-ok": "Cancella",
      "widgets.advanced-select.delete-selection-confirm-title": "Cancellare la selezione?",
      "widgets.advanced-select.search-label": "Cerca",
      "widgets.advanced-select.search-placeholder": "Cerca...",
      "widgets.advanced-select.show-only-selected": "Mostra solo selezionate",
      "widgets.advanced-select.validation.invalid-option": "L'opzione non è valida per il campo ${path}",
      "widgets.advanced-single-select.change-button-text": "Cambia",
      "widgets.advanced-single-select.modal-select-option-title": "Seleziona Opzione",
      "widgets.advanced-single-select.select-button-text": "Scegli",
      "widgets.async-select-widget-component.invalid-data-format": "Il servizio \"{{service}}\" ha restituito dati in un formato non valido.",
      "widgets.async-select-widget-component.invalid-data-format-no-service": "Il servizio ha restituito dati in un formato non valido.",
      "widgets.async-select-widget-component.not-found": "Nessun elemento trovato.",
      "widgets.async-select-widget-component.service-not-responding": "Impossibile recuperare i dati dal servizio {{service}}. Riprovare più tardi.",
      "widgets.async-select-widget-component.type-to-search": "Digita per iniziare a cercare",
      "widgets.async-select.select-text": "Scegli",
      "widgets.confirm-widget-layout-component.cancel": "Annulla Modifiche",
      "widgets.confirm-widget-layout-component.confirm": "Confermato",
      "widgets.confirm-widget-layout-component.edit": "Modifica",
      "widgets.multi-select-select-component.placeholder": "Placeholder",
      "widgets.remove-row-buttton.min-options-reached": "Numero minimo di opzioni raggiunto",
      "widgets.repeatable-content.alert-sr.added": "Elemento {{index}} aggiunto alla lista {{labelText}}.",
      "widgets.repeatable-content.alert-sr.removed": "Elemento {{index}} rimosso dalla lista {{labelText}}. Gli elementi successivi sono stati riordinati.",
      "widgets.select-widget.select-text": "Scegli",
      "widgets.subsection-drawer-component.expand-aria": "Espandi",
      "widgets.subsection-drawer-component.open": "Apri",
      "widgets.use-exec-async-service-action.error-during-loading": "Si è verificato un errore durante l'esecuzione del servizio asincrono",
      "widgets.use-exec-async-service-action.no-handle-function": "Attesa caricamento del servizio asincrono. Riprovare.",
      "widgets.use-repeat-controller-confirm-modal.cancel": "Annulla",
      "widgets.use-repeat-controller-confirm-modal.content": "Riducendo il numero di elementi, rimuoverai le righe in eccesso dalla lista. Continuare?",
      "widgets.use-repeat-controller-confirm-modal.continue": "Continua",
      "widgets.use-repeat-controller-confirm-modal.title": "Rimuovere elementi dalla lista?",
      "address-book.already-selected": "Selezionato",
      "address-book.button.apri-rubrica": "Apri rubrica",
      "address-book.columns.codice-fiscale": "Codice Fiscale",
      "address-book.columns.cognome": "Cognome",
      "address-book.columns.nome": "Nome",
      "address-book.columns.nome-completo": "Nome",
      "address-book.columns.pec": "PEC",
      "address-book.company.company-name": "Ragione Sociale",
      "address-book.company.detail.business-name": "Ragione sociale",
      "address-book.company.detail.fiscal-code": "Codice Fiscale",
      "address-book.company.detail.fiscal-code-invalid": "Il codice fiscale o la partita IVA non sono validi",
      "address-book.company.detail.legal-headquarters-address": "Indirizzo sede legale",
      "address-book.company.detail.legal-headquarters-hamlet": "Frazione sede legale",
      "address-book.company.detail.legal-headquarters-municipality": "Comune sede legale",
      "address-book.company.detail.legal-headquarters-number": "Numero civico sede legale",
      "address-book.company.detail.legal-headquarters-province": "Provincia sede legale",
      "address-book.company.detail.legal-headquarters-zip": "CAP sede legale",
      "address-book.company.detail.legal-headquarters-zip-validation": "Il CAP della sede legale deve avere esattamente 5 caratteri",
      "address-book.company.detail.operational-headquarters-address": "Indirizzo sede operativa",
      "address-book.company.detail.operational-headquarters-fraction": "Frazione sede operativa",
      "address-book.company.detail.operational-headquarters-municipality": "Comune sede operativa",
      "address-book.company.detail.operational-headquarters-number": "Numero civico sede operativa",
      "address-book.company.detail.operational-headquarters-province": "Provincia sede operativa",
      "address-book.company.detail.operational-headquarters-same": "La sede operativa coincide con la sede legale",
      "address-book.company.detail.operational-headquarters-zip": "CAP sede operativa",
      "address-book.company.detail.operational-headquarters-zip-validation": "Il CAP della sede operativa deve avere esattamente 5 caratteri",
      "address-book.company.detail.pec": "PEC",
      "address-book.company.detail.pec-invalid": "Inserisci un indirizzo PEC valido",
      "address-book.company.detail.vat": "Partita IVA",
      "address-book.company.fiscal-code": "Codice Fiscale",
      "address-book.company.pec": "PEC",
      "address-book.company.searchable-fields.fiscal-code": "Codice Fiscale",
      "address-book.company.searchable-fields.fiscal-code-placeholder": "Codice Fiscale...",
      "address-book.company.searchable-fields.ragione-sociale": "Ragione sociale",
      "address-book.company.searchable-fields.ragione-sociale-placeholder": "Ragione sociale...",
      "address-book.company.searchable-fields.vat": "Partita IVA",
      "address-book.company.searchable-fields.vat-placeholder": "Partita IVA...",
      "address-book.company.vat": "Partita IVA",
      "address-book.duplicate-modal.alert-description": "Scegli se aggiornare il più recente, crearne uno nuovo o seleziona dalla lista dei contatti.",
      "address-book.duplicate-modal.alert-description-single": "Scegli se aggiornare il contatto esistente o crearne uno nuovo.",
      "address-book.duplicate-modal.alert-message-company-many_one": "Esistono già {{count}} contatti con la stessa Partita IVA {{value}}.",
      "address-book.duplicate-modal.alert-message-company-many_many": "Esistono già {{count}} contatti con la stessa Partita IVA {{value}}.",
      "address-book.duplicate-modal.alert-message-company-many_other": "Esistono già {{count}} contatti con la stessa Partita IVA {{value}}.",
      "address-book.duplicate-modal.alert-message-company-one": "Esiste già un contatto con la stessa Partita IVA {{value}}.",
      "address-book.duplicate-modal.alert-message-person-many_one": "Esistono già {{count}} contatti con lo stesso Codice Fiscale {{value}}.",
      "address-book.duplicate-modal.alert-message-person-many_many": "Esistono già {{count}} contatti con lo stesso Codice Fiscale {{value}}.",
      "address-book.duplicate-modal.alert-message-person-many_other": "Esistono già {{count}} contatti con lo stesso Codice Fiscale {{value}}.",
      "address-book.duplicate-modal.alert-message-person-one": "Esiste già un contatto con lo stesso Codice Fiscale {{value}}.",
      "address-book.duplicate-modal.create-new": "Crea nuovo",
      "address-book.duplicate-modal.diff-table.compare-info": "Confronta i dati inseriti nel modulo con i dati presenti in rubrica per selezionare il contatto da sovrascrivere. I campi evidenziati in giallo saranno sovrascritti.",
      "address-book.duplicate-modal.diff-table.contact-value": "Dati in rubrica",
      "address-book.duplicate-modal.diff-table.field": "Campo",
      "address-book.duplicate-modal.diff-table.form-value": "Dati modulo",
      "address-book.duplicate-modal.diff-table.group-legal-representative": "Legale Rappresentante",
      "address-book.duplicate-modal.diff-table.group-main-company": "Persona Giuridica",
      "address-book.duplicate-modal.diff-table.group-main-person": "Persona Fisica",
      "address-book.duplicate-modal.diff-table.no-differences": "Nessuna differenza",
      "address-book.duplicate-modal.diff-table.select-placeholder": "Seleziona un contatto",
      "address-book.duplicate-modal.diff-table.show-all-values": "Mostra tutti i valori",
      "address-book.duplicate-modal.diff-table.show-only-differences": "Mostra solo i valori che saranno sovrascritti",
      "address-book.duplicate-modal.hide-comparison-table": "Nascondi tabella di confronto",
      "address-book.duplicate-modal.select-contact-hint": "Seleziona un contatto da aggiornare",
      "address-book.duplicate-modal.show-comparison-table": "Mostra tabella di confronto",
      "address-book.duplicate-modal.title": "Inserimento contatto in rubrica",
      "address-book.duplicate-modal.update-contact": "Aggiorna Contatto",
      "address-book.duplicate-modal.update-most-recent": "Aggiorna più recente",
      "address-book.import-modal.certificato-warning.cancel": "Annulla",
      "address-book.import-modal.certificato-warning.content": "I dati di questa persona giuridica non sono certificati. Vuoi procedere con l'importazione?",
      "address-book.import-modal.certificato-warning.ok": "Procedi",
      "address-book.import-modal.certificato-warning.title": "Dati non certificati",
      "address-book.import-modal.error": "Errore durante il caricamento della rubrica",
      "address-book.import-modal.select": "Seleziona",
      "address-book.import-modal.title.persona-fisica": "Seleziona persona fisica",
      "address-book.import-modal.title.persona-giuridica": "Seleziona persona giuridica",
      "address-book.modal.empty-list.description1.nessuna-persona-vai-alla": "Nessuna persona fisica presente nella rubrica. Vai alla",
      "address-book.modal.empty-list.description2.link.rubrica": "Rubrica",
      "address-book.modal.empty-list.description3.per-aggiungerne-di-nuovi": "per aggiungerne di nuovi.",
      "address-book.modal.empty-list.message.rubrica-vuota": "Rubrica vuota",
      "address-book.modal.error.errore-caricamento-rubrica": "Errore durante il caricamento della rubrica",
      "address-book.modal.title.seleziona-persona-fisica": "Seleziona persona fisica",
      "address-book.person.detail.address": "Indirizzo",
      "address-book.person.detail.born-in-italy": "Nato/a in Italia",
      "address-book.person.detail.cap": "CAP",
      "address-book.person.detail.cap.validation": "CAP deve avere esattamente 5 caratteri",
      "address-book.person.detail.date-of-birth": "Data di Nascita",
      "address-book.person.detail.date-of-registration": "Data di Iscrizione",
      "address-book.person.detail.email": "Email",
      "address-book.person.detail.entered-in-register": "Iscritto all'Albo",
      "address-book.person.detail.fiscal-code": "Codice Fiscale",
      "address-book.person.detail.fixed-phone": "Telefono Fisso",
      "address-book.person.detail.foreign-address": "Indirizzo Estero",
      "address-book.person.detail.foreign-municipality-of-residence": "Comune Estero di Residenza",
      "address-book.person.detail.gender": "Sesso",
      "address-book.person.detail.mobile-phone": "Telefono Cellulare",
      "address-book.person.detail.municipality-of-birth": "Comune di Nascita",
      "address-book.person.detail.municipality-of-registration": "Comune di Iscrizione",
      "address-book.person.detail.municipality-of-residence": "Comune di Residenza",
      "address-book.person.detail.name": "Nome",
      "address-book.person.detail.other-information": "Altre Informazioni",
      "address-book.person.detail.pec": "PEC",
      "address-book.person.detail.profession": "Professione",
      "address-book.person.detail.province-of-birth": "Provincia di Nascita",
      "address-book.person.detail.province-of-registration": "Provincia di Iscrizione",
      "address-book.person.detail.province-of-residence": "Provincia di Residenza",
      "address-book.person.detail.register": "Albo/Ordine",
      "address-book.person.detail.residence-state": "Stato di Residenza",
      "address-book.person.detail.resident-in-italy": "Residente in Italia",
      "address-book.person.detail.state-of-birth": "Stato di Nascita",
      "address-book.person.detail.surname": "Cognome",
      "address-book.person.input.fiscal-code.aria-label": "Ricerca Codice Fiscale",
      "address-book.person.input.fiscal-code.placeholder": "Codice Fiscale",
      "address-book.person.input.surname.aria-label": "Ricerca per altri campi",
      "address-book.person.input.surname.placeholder": "Cognome...",
      "address-book.person.searchable-fields.cognome": "Cognome",
      "address-book.person.searchable-fields.cognome-placeholder": "Cognome...",
      "address-book.person.searchable-fields.fiscal-code": "Codice Fiscale",
      "address-book.person.searchable-fields.fiscal-code-placeholder": "Codice Fiscale...",
      "address-book.person.searchable-fields.nome": "Nome",
      "address-book.person.searchable-fields.nome-placeholder": "Nome...",
      "address-book.save.error": "Errore durante il salvataggio",
      "address-book.save.success-created": "Contatto creato in rubrica",
      "address-book.save.success-updated": "Contatto aggiornato in rubrica",
      "address-book.save.tooltip-more-errors_one": "...e un altro errore",
      "address-book.save.tooltip-more-errors_many": "...e altri {{count}} errori",
      "address-book.save.tooltip-more-errors_other": "...e altri {{count}} errori",
      "address-book.save.validation-error": "Si è verificato un errore durante la validazione e il controllo dei duplicati.",
      "address-book.select": "Seleziona",
      "cmmunication-state-tag.default": "N/A",
      "cmmunication-state-tag.error": "Invio Fallito",
      "cmmunication-state-tag.processing": "In Lavorazione",
      "cmmunication-state-tag.success": "Inviata",
      "common.cancel": "Annulla",
      "communication-attachment-group-editor.download-after-save": "Il download degli allegati appena caricati sarà disponibile dopo il salvataggio della comunicazione.",
      "communication-attachment-group-editor.title-generic-fallback": "Allegato",
      "communication-attachment-group-editor.upload-file": "Carica file {{maxCount}}",
      "communication-attachments.attachments": "Allegati",
      "communication-attachments.error-attachment-group": "Errore: gruppo allegati non trovato",
      "communication-attachments.error-type": "Errore: tipo comunicazione non trovato",
      "communication-attachments.title": "Allegati",
      "communication-button.edit-comm": "Modifica Comunicazione",
      "communication-button.load-comm": "Carica Comunicazione",
      "communication-button.new-comm": "Nuova Comunicazione",
      "communication-details.receiver": "Destinatari",
      "communication-details.sender": "Mittente",
      "communication-error.upload-no-id": "Errore: Allegato creato senza ID.",
      "communication-extend-search-form.communication-type": "Tipo Comunicazione",
      "communication-extend-search-form.creation-date": "Data Creazione",
      "communication-extend-search-form.last-modification": "Ultima Modifica",
      "communication-extend-search-form.message": "Messaggio",
      "communication-extend-search-form.read-state": "Lettura",
      "communication-extend-search-form.read-state-read": "Lette",
      "communication-extend-search-form.read-state-unread": "Non lette",
      "communication-extend-search-form.recipient": "Destinatario",
      "communication-extend-search-form.recipient-type": "Tipo Destinatario",
      "communication-extend-search-form.recipient-type-altro-ufficio": "Altro ufficio",
      "communication-extend-search-form.recipient-type-delegati-compilazione": "Delegati alla Compilazione",
      "communication-extend-search-form.recipient-type-delegati-firma": "Delegati alla Firma",
      "communication-extend-search-form.recipient-type-endoprocedimento-primo-livello": "Endoprocedimento Primo Livello",
      "communication-extend-search-form.recipient-type-impresa-titolare": "Impresa Titolare",
      "communication-extend-search-form.recipient-type-procuratore": "Procuratore",
      "communication-extend-search-form.recipient-type-responsabile-procedimento": "Responsabile Procedimento",
      "communication-extend-search-form.recipient-type-richiedente": "Richiedente",
      "communication-extend-search-form.recipient-type-titolare": "Titolare",
      "communication-extend-search-form.search-in-message": "Cerca nel messaggio...",
      "communication-extend-search-form.search-recipient": "Nominativo destinatario...",
      "communication-extend-search-form.search-sender": "Nominativo mittente...",
      "communication-extend-search-form.send-date": "Data di Invio",
      "communication-extend-search-form.sender": "Mittente",
      "communication-extend-search-form.sender-type": "Tipo Mittente",
      "communication-extend-search-form.sender-type-altro-ufficio": "Altro ufficio",
      "communication-extend-search-form.sender-type-endoprocedimento-primo-livello": "Endoprocedimento Primo Livello",
      "communication-extend-search-form.sender-type-responsabile-procedimento": "Responsabile Procedimento",
      "communication-extend-search-form.sender-type-richiedente": "Richiedente",
      "communication-extend-search-form.sender-type-titolare": "Titolare",
      "communication-extend-search-form.sent": "Inviata il",
      "communication-extend-search-form.sent-after": "Inviata dopo il",
      "communication-extend-search-form.sent-before": "Inviata prima del",
      "communication-extend-search-form.subject": "Oggetto",
      "communication-extend-search-form.subprocedure": "Endoprocedimento",
      "communication-extend-search-form.write-or-select-date": "Scrivi o seleziona la data...",
      "communication-forward.title": "Comunicazione Inoltrata",
      "communication-header.receivers": "Destinatari",
      "communication-header.sender": "Mittente",
      "communication-item.edit": "Modifica",
      "communication-item.edit-and-send": "Modifica e Invia",
      "communication-item.forward": "Inoltra",
      "communication-item.forward.error": "Errore: impossibile inoltrare la comunicazione",
      "communication-item.mark-as-read": "Segna come letta",
      "communication-item.mark-as-read-error": "Impossibile segnare la comunicazione come letta",
      "communication-item.signature-book-detail": "Dettaglio Libro Firma",
      "communication-list.no-comms-to-show": "Non ci sono comunicazioni da mostrare",
      "communication-procedure-attachment.error-loading-files": "Si è verificato un errore durante il caricamento dell'elenco dei file del procedimento",
      "communication-procedure-attachment.error-no-attachment-group-id": "Errore: gruppo allegati non trovato",
      "communication-procedure-attachment.error-no-communication-id": "Errore: comunicazione non trovata",
      "communication-procedure-attachment.error-no-file-selected": "Errore: nessun file selezionato",
      "communication-procedure-attachment.error-no-result": "Errore: si è verificato un errore durante il caricamento del file",
      "communication-receiver-input.error-loading-subprocedures": "Errore durante il caricamento degli endoprocedimenti",
      "communication-receiver-input.receiver-description": "Includere almeno un ente terzo tra i destinatari",
      "communication-recipient.protocol-number": "Protocollo",
      "communication-recipient.read": "Letta",
      "communication-recipient.registration-date": "Data protocollo",
      "communication-recipient.send-date": "Data invio",
      "communication-recipient.unread": "Non letta",
      "communication-request-schema.attachment": "Allegato",
      "communication-request-schema.attachment-id": "ID Allegato",
      "communication-request-schema.attachment-name": "Nome Allegato",
      "communication-request-schema.attachment-type": "Tipo Allegato",
      "communication-request-schema.dataProtocollo": "Data Protocollo",
      "communication-request-schema.destinatari": "Destinatari",
      "communication-request-schema.destinatario": "Destinatario",
      "communication-request-schema.destinatario-required": "È richiesto selezionare almeno un destinatario",
      "communication-request-schema.flMessaggioModificato": "Messaggio Modificato",
      "communication-request-schema.flOggettoModificato": "Oggetto Modificato",
      "communication-request-schema.idComunicazione": "ID Comunicazione",
      "communication-request-schema.idDestinatario": "Tipo Destinatario",
      "communication-request-schema.idEndoprocedimento": "Endoprocedimento",
      "communication-request-schema.idProcedimentoMittente": "Endoprocedimento Mittente",
      "communication-request-schema.idTipoComunicazione": "Tipo Comunicazione",
      "communication-request-schema.inoltro.allegati": "Allegati Comunicazione",
      "communication-request-schema.inoltro.idComunicazione": "ID Comunicazione",
      "communication-request-schema.inoltro.messaggio": "Messaggio",
      "communication-request-schema.message-required": "È obbligatorio compilare almeno uno tra messaggio e oggetto",
      "communication-request-schema.messaggio": "Messaggio",
      "communication-request-schema.noteAddizionali": "Note Addizionali",
      "communication-request-schema.numeroProtocollo": "Numero Protocollo",
      "communication-request-schema.oggetto": "Oggetto",
      "communication-search-schema.sent-after": "Inviata dopo il",
      "communication-search-schema.sent-before": "Inviata prima del",
      "communication-searchable.search-by-type": "Cerca per tipo...",
      "communication-tag-option-holder": "TITOLARE",
      "communication-tag-option.applicant": "RICHIEDENTE",
      "communication-tag-option.company-holder": "IMPRESA TITOLARE",
      "communication-tag-option.delegate-for-comp": "DELEGATO ALLA COMPILAZIONE",
      "communication-tag-option.delegate-for-sign": "DELEGATO ALLA FIRMA",
      "communication-tag-option.legal-subject": "SOGGETTO GIURIDICO",
      "communication-tag-option.manager": "GESTORE",
      "communication-tag-option.no-type": "N/D",
      "communication-tag-option.other-variable-office": "UFFICIO REFERENTE",
      "communication-tag-option.prosecutor": "PROCURATORE",
      "communication-tag-option.requesting-office": "UFFICIO RICHIEDENTE",
      "communication-tag-option.responsible-office": "UFFICIO RESPONSABILE",
      "communication-tag-option.secondary-competence-office": "UFFICIO COMPETENZA SECONDARIA",
      "communication-tag-option.system": "SISTEMA",
      "communication-tag-option.third-organization": "ENTE TERZO",
      "communication-type.receivers": "Destinatari",
      "communication-type.sender": "Mittente",
      "communication-type.subprocedure-sender": "Endoprocedimento mittente",
      "communication-type.subprocedure-sender.placeholder": "Seleziona endoprocedimento mittente...",
      "communication.draft": "BOZZA",
      "communication.sent": "INVIATA",
      "communication.unread-count_one": "{{count}} comunicazione non letta",
      "communication.unread-count_many": "{{count}} comunicazioni non lette",
      "communication.unread-count_other": "{{count}} comunicazioni non lette",
      "communications-sender-protocol.protocol-date": "Data protocollo",
      "communications-sender-protocol.protocol-number": "Protocollo",
      "communications-sender-protocol.tag.errore": "ERRORE",
      "communications-sender-protocol.tag.processing": "IN LAVORAZIONE",
      "communications-sender-protocol.tooltip-title.error-protocolling": "Errore nella protocollazione della comunicazione",
      "communications-sender-protocol.tooltip-title.processing-protocolling": "Protocollo in lavorazione",
      "communications.additional-notes": "Note addizionali",
      "communications.additional-notes-placeholder": "Note addizionali alla comunicazione",
      "communications.communication-title": "Comunicazione",
      "communications.error-in-communication": "Errore nella comunicazione",
      "communications.error-in-sending-communication": "Errore nell'invio della comunicazione",
      "communications.error-protocolling-communication": "Errore nella protocollazione della comunicazione",
      "communications.error-saving-communication-on-send": "Si è verificato un errore durante l'invio della comunicazione",
      "communications.error-sending-communication": "Si è verificato un errore durante l'invio della comunicazione",
      "communications.forward.input.attachments.help": "Seleziona gli allegati da inoltrare",
      "communications.forward.input.attachments.label": "Allegati della comunicazione inoltrata",
      "communications.forward.input.message.label": "Comunicazione Inoltrata",
      "communications.forward.input.message.placeholder": "Comunicazione inoltrata",
      "communications.hydrate-error": "Si è verificato un errore durante il recupero dell'anteprima della comunicazione. Riprovare.",
      "communications.in-working": "Comunicazione in lavorazione",
      "communications.message": "Messaggio",
      "communications.message-placeholder": "Messaggio della comunicazione",
      "communications.protocol-date": "Data Protocollo",
      "communications.protocol-number": "Numero Protocollo",
      "communications.protocol-row-label": "Protocollo",
      "communications.receiver-label": "Destinatari",
      "communications.select": "Selezione...",
      "communications.select-receiver-subprocedure": "Seleziona endoprocedimento destinatario",
      "communications.sent-successfully": "Comunicazione inviata con successo",
      "communications.subject": "Oggetto",
      "communications.subject-placeholder": "Oggetto della comunicazione",
      "communications.type-label": "Tipo Comunicazione",
      "communications.type-row": "Tipo Comunicazione",
      "communications.type-title": "Tipo di Comunicazione",
      "competence-widget.error-fetching-competences": "Impossibile recuperare i dati delle Competenze. Riprovare più tardi.",
      "competence-widget.no-element-found": "Nessun elemento trovato.",
      "comunicazioni.invia": "Invia",
      "confirm-update-modal.added-new-module-activation": "È stata aggiunta una nuova attivazione modulo:",
      "confirm-update-modal.added-new-multiple-modules-activation": "Sono state aggiunte {{length}} nuove attivazioni moduli:",
      "confirm-update-modal.changes-will-be-applied-to-inquiries": "Le modifiche saranno apportate a {{inquiriesLength}} domand{{oneOrMore}}:",
      "confirm-update-modal.removed-module-activation": "È stata rimossa una attivazione modulo:",
      "confirm-update-modal.removed-multiple-modules-activation": "Sono state rimosse {{length}} attivazioni moduli:",
      "domanda.copertina.categorie": "Categorie",
      "domanda.copertina.destinatari": "Destinatari",
      "domanda.copertina.scadenza": "Scadenza",
      "dossier-searchable.a-data-avvio": "A Data di Avvio",
      "dossier-searchable.anno-richiesta": "Anno richiesta",
      "dossier-searchable.anno-richiesta-placeholder": "Anno richiesta...",
      "dossier-searchable.da-data-avvio": "Da Data di Avvio",
      "dossier-searchable.data-avvio": "Data di Avvio",
      "dossier-searchable.data-protocollo-documento": "Data protocollo Documento",
      "dossier-searchable.data-protocollo-richiesta": "Data protocollo Richiesta",
      "dossier-searchable.numero": "Numero",
      "dossier-searchable.numero-placeholder": "Numero...",
      "dossier-searchable.numero-protocollo-documento": "Numero protocollo Documento",
      "dossier-searchable.numero-protocollo-richiesta": "Numero protocollo Richiesta",
      "dossier-searchable.numero-richiesta": "Numero richiesta",
      "dossier-searchable.numero-richiesta-placeholder": "Numero richiesta...",
      "dossier-searchable.oggetto": "Oggetto",
      "dossier-searchable.oggetto-placeholder": "Oggetto...",
      "dossier-searchable.proc-avvio-a-data-invio": "A Data Invio",
      "dossier-searchable.proc-avvio-da-data-invio": "Da Data Invio",
      "dossier-searchable.procedimento-avvio-data-invio": "Procedimento di avvio: Data Invio",
      "dossier-searchable.procedimento-avvio-denominazione": "Procedimento di avvio: Denominazione",
      "dossier-searchable.procedimento-avvio-denominazione-placeholder": "Denominazione procedimento avvio...",
      "dossier-searchable.ricerca-estesa": "Ricerca Estesa",
      "dossier-searchable.ricerca-estesa-placeholder": "Ricerca Estesa...",
      "dossier-searchable.richiesta-avvio-a-data-invio": "A Data Invio",
      "dossier-searchable.richiesta-avvio-da-data-invio": "Da Data Invio",
      "dossier-searchable.richiesta-avvio-data-invio": "Richiesta Avvio: Data Invio",
      "dossier-searchable.richiesta-avvio-numero-richiesta": "Richiesta di avvio: Numero",
      "dossier-searchable.richiesta-avvio-numero-richiesta-placeholder": "Numero...",
      "dossier-searchable.richiesta-avvio-tipo-domanda": "Richiesta di avvio: Tipo Domanda",
      "dossier-searchable.soggetto-richiesta-codice-fiscale": "Soggetto Richiesta: Codice Fiscale",
      "dossier-searchable.soggetto-richiesta-codice-fiscale-placeholder": "Codice Fiscale...",
      "dossier-searchable.soggetto-richiesta-cognome": "Soggetto Richiesta: Cognome",
      "dossier-searchable.soggetto-richiesta-cognome-placeholder": "Cognome...",
      "dossier-searchable.soggetto-richiesta-nome": "Soggetto Richiesta: Nome",
      "dossier-searchable.soggetto-richiesta-nome-placeholder": "Nome...",
      "dossier-searchable.stato-pratica": "Stato Pratica",
      "dossier-searchable.tipo-pratica": "Tipo Pratica",
      "dossier-searchable.titolare-principale-codice-fiscale": "Titolare Persona Fisica: Codice Fiscale",
      "dossier-searchable.titolare-principale-codice-fiscale-impresa": "Titolare Impresa: Codice Fiscale",
      "dossier-searchable.titolare-principale-codice-fiscale-impresa-placeholder": "Codice Fiscale...",
      "dossier-searchable.titolare-principale-codice-fiscale-placeholder": "Codice Fiscale...",
      "dossier-searchable.titolare-principale-codice-rea-impresa": "Titolare Impresa: Codice REA",
      "dossier-searchable.titolare-principale-codice-rea-impresa-placeholder": "Codice REA...",
      "dossier-searchable.titolare-principale-cognome": "Titolare Persona Fisica: Cognome",
      "dossier-searchable.titolare-principale-cognome-placeholder": "Cognome...",
      "dossier-searchable.titolare-principale-denominazione-impresa": "Titolare Impresa: Denominazione",
      "dossier-searchable.titolare-principale-denominazione-impresa-placeholder": "Impresa...",
      "dossier-searchable.titolare-principale-nome": "Titolare Persona Fisica: Nome",
      "dossier-searchable.titolare-principale-nome-placeholder": "Nome...",
      "dossier-searchable.titolare-principale-partita-iva": "Titolare Impresa: Partita IVA",
      "dossier-searchable.titolare-principale-partita-iva-placeholder": "Partita IVA...",
      "download-file-button.error-download-file": "Si è verificato un problema durante il download del file",
      "download-file.error-downloading-file": "Si è verificato un problema durante il download del file",
      "download-file.no-filename-from-header": "Documento",
      "download-file.p7m-extraction-failed": "Impossibile estrarre il contenuto dal file firmato. Utilizzare la funzionalità di download.",
      "download-file.p7m-not-pdf": "Il file firmato non contiene un PDF. Utilizzare la funzionalità di download.",
      "download-widget.error": "Si è verificato un problema durante il download del file. Riprovare.",
      "download-widget.file-not-found": "File non trovato",
      "email-verification-rule.message": "È necessario verificare l'email per proseguire",
      "email-verification-widget.check-mail-box-to-confirm": "Ti è stata inviata una email di verifica alla tua casella di posta. Controlla la tua posta elettronica per confermare la tua email.",
      "email-verification-widget.confirm-reception": "Conferma Ricezione",
      "email-verification-widget.error-in-sending-verification-mail": "Errore durante l'invio dell'email di verifica",
      "email-verification-widget.invalid-email": "L'email inserita non è valida",
      "email-verification-widget.verified": "Verificata",
      "email-verification-widget.verify-email": "Verifica Email",
      "engine.async-services.load-error": "Si è verificato un errore durante il caricamento dei servizi esterni. Riprovare.",
      "error": "Errore",
      "error-while-resetting-notification-flag": "Errore durante il reset del flag di notifica",
      "export-field-select.max-selectable-fields": "Puoi selezionare al massimo {{max}} campi.",
      "export-field-select.require-fields-warning": "Seleziona almeno un campo per esportare.",
      "export-field-select.select-fields-to-export": "Seleziona i campi da esportare",
      "export-field-select.select-fields-to-export-title.line-a": "Seleziona i campi da esportare.",
      "export-field-select.select-fields-to-export-title.line-b": "Se non indichi nessun campo, l'esportazione conterrà tutti i dati.",
      "export-file-button.cancel-text": "Annulla",
      "export-file-button.confirm-export-final-text": "Stai per esportare i dati trovati dai filtri di ricerca attualmente attivi. A seconda dei filtri utilizzati questa operazione potrebbe richiedere diverso tempo. Continuare?",
      "export-file-button.download-current-page-checkbox": "Scarica solo elementi presenti nella pagina corrente (pag. {{page}}) (max. {{pageSize}} {{entity}})",
      "export-file-button.error.export": "Si è verificato un errore durante l'esportazione.",
      "export-file-button.error.save-template": "Si è verificato un errore durante il salvataggio del template.",
      "export-file-button.export-entity": "Esportazione {{typeTitle}} {{entityTitle}}",
      "export-file-button.export-title": "Esporta {{typeTitle}}",
      "export-file-button.max-selectable-exceeded": "Il limite massimo è cambiato. Sono stati mantenuti i primi {{max}} campi.",
      "export-file-button.ok-text": "Esporta",
      "export-file-button.remember-fields": "Ricorda i campi per la prossima esportazione",
      "export-file-button.save-action-select.aggiorna-template": "Aggiorna il Template",
      "export-file-button.save-action-select.input-nuovo-template.placeholder": "Nome del nuovo Template",
      "export-file-button.save-action-select.non-salvare-template": "Non salvare il Template",
      "export-file-button.save-action-select.placeholder.update-template-to-export": "Aggiornamento Template",
      "export-file-button.save-action-select.salva-nuovo-template": "Salva come nuovo Template",
      "export-template-modal-button.chiudi": "Chiudi",
      "export-template-modal-button.elimina": "Elimina",
      "export-template-modal-button.elimina-il-template": "Elimina questo Template",
      "export-template-modal-button.error.errore-nel-eliminazione-del-template": "Si è verificato un errore durante l'eliminazione del template'.",
      "export-template-modal-button.errore-nel-eliminazione-del-template": "Errore nell'eliminazione il template",
      "export-template-modal-button.sei-sicuro-di-voler-eliminare-il-template": "Sei sicuro di voler eliminare il template?",
      "export-template-modal-button.template-eliminato-correttamente": "Template eliminato correttamente.",
      "export-template-modal-button.unsaved-template-miss-id": "Il Template deve essere salvato per poter essere eliminato.",
      "export-template-select.select-template-to-export": "Carica campi da Template",
      "export.default-errore": "Si è verificato un problema durante il download del file. Riprovare.",
      "export.file-non-trovato": "File non trovato",
      "interazioni.annulla": "Annulla",
      "interazioni.salva": "Salva",
      "loading": "Caricamento...",
      "map-catalog.merge.cadastral-skipped_one": "{{count}} preset catastale ignorato (ne è ammesso uno solo)",
      "map-catalog.merge.cadastral-skipped_many": "{{count}} preset catastali ignorati (ne è ammesso uno solo)",
      "map-catalog.merge.cadastral-skipped_other": "{{count}} preset catastali ignorati (ne è ammesso uno solo)",
      "map-catalog.merge.groups-added_one": "{{count}} gruppo aggiunto",
      "map-catalog.merge.groups-added_many": "{{count}} gruppi aggiunti",
      "map-catalog.merge.groups-added_other": "{{count}} gruppi aggiunti",
      "map-catalog.merge.groups-skipped_one": "{{count}} gruppo duplicato ignorato",
      "map-catalog.merge.groups-skipped_many": "{{count}} gruppi duplicati ignorati",
      "map-catalog.merge.groups-skipped_other": "{{count}} gruppi duplicati ignorati",
      "map-catalog.merge.layers-added_one": "{{count}} livello aggiunto",
      "map-catalog.merge.layers-added_many": "{{count}} livelli aggiunti",
      "map-catalog.merge.layers-added_other": "{{count}} livelli aggiunti",
      "map-catalog.merge.no-entries": "Nessuna voce da importare",
      "map-catalog.merge.replaced": "Catalogo sostituito con successo",
      "map-restore-default.aria": "Ripristina valore originale",
      "map-restore-default.cancel": "Annulla",
      "map-restore-default.description": "Le modifiche correnti alla mappa verranno sostituite con il valore originale.",
      "map-restore-default.ok": "Ripristina",
      "map-restore-default.title": "Ripristina valore originale",
      "map-restore-default.tooltip": "Ripristina il valore originale",
      "map-upload-geometries.chiudi": "Chiudi",
      "map-widget.competence-not-attributed-warning": "Non è stato possibile attribuire automaticamente la competenza per una o più aree selezionate.",
      "map-widget.draw.shape.aria-label": "Tipo di geometria da disegnare",
      "map-widget.draw.shape.line.label": "Linea",
      "map-widget.draw.shape.point.label": "Punto",
      "map-widget.draw.shape.polygon.label": "Poligono",
      "map-widget.drawn-geometries": "Geometrie disegnate",
      "map-widget.extended-view.close": "Riduci mappa",
      "map-widget.extended-view.open": "Visualizzazione estesa",
      "map-widget.extended-view.placeholder": "Mappa aperta in visualizzazione estesa",
      "map-widget.extended-view.title": "Mappa",
      "map-widget.geometries.go-to-geometry": "Vai alla geometria",
      "map-widget.geometries.measure-column": "Misura",
      "map-widget.geometries.type-column": "Tipologia",
      "map-widget.geometries.type.line": "Linea",
      "map-widget.geometries.type.point": "Punto",
      "map-widget.geometries.type.polygon": "Poligono",
      "map-widget.intersections-truncated-error": "Sono state trovate {{found}} intersezioni ma ne possono essere mostrate al massimo {{max}}. Le eccedenti non verranno visualizzate: riduci l'area disegnata.",
      "map-widget.no-geometries": "Nessuna geometria presente",
      "map-widget.search-address.aria-label": "Cerca indirizzo",
      "map-widget.search-address.load-address-error-mpe-002": "Errore durante il caricamento dell'indirizzo (MPE-002)",
      "map-widget.search-address.no-result-found-no-extent-mpe-0001": "Nessun risultato trovato per l'indirizzo selezionato. (MPE-0001)",
      "map-widget.search-address.not-found-text.loading": "Caricamento...",
      "map-widget.search-address.not-found-text.no-result": "Nessun risultato",
      "map-widget.search-address.not-found-text.write-to-search": "Scrivi per cercare",
      "map-widget.search-address.placeholder": "Cerca indirizzo...",
      "map-widget.title": "Centra mappa sulle geometrie",
      "map-widget.upload-warning-message": "Nessuna geometria presente nel file.",
      "map-widget.zoom-level": "Zoom: {{zoom}}",
      "mappa.controlli.cerca-particella.modale.form-button.cerca": "Cerca",
      "mappa.controlli.cerca-particella.modale.form-button.seleziona": "Seleziona",
      "mappa.controlli.cerca-particella.modale.form-label.allegato-catastale": "Allegato",
      "mappa.controlli.cerca-particella.modale.form-label.comune": "Comune",
      "mappa.controlli.cerca-particella.modale.form-label.foglio-catastale": "Foglio",
      "mappa.controlli.cerca-particella.modale.form-label.particella-catastale": "Particella",
      "mappa.controlli.cerca-particella.modale.form-label.provincia": "Provincia",
      "mappa.controlli.cerca-particella.modale.form-label.sezione-catastale": "Sezione",
      "mappa.controlli.cerca-particella.modale.form-label.sviluppo-catastale": "Sviluppo",
      "mappa.controlli.cerca-particella.modale.form.errore.durante-la-ricerca": "Si è verificato un errore durante la ricerca",
      "mappa.controlli.cerca-particella.modale.form.errore.nessun-risultato": "Nessun risultato trovato",
      "mappa.controlli.cerca-particella.modale.form.errore.nessuna-geometria-valida": "Errore durante la ricerca. Nessuna geometria valida trovata",
      "mappa.controlli.cerca-particella.modale.titolo": "Cerca per particella catastale",
      "mappa.controlli.cerca-particella.pulsante.testo": "Particella",
      "mappa.controlli.disegna": "Disegna",
      "mappa.controlli.elimina": "Elimina",
      "mappa.controlli.interroga": "Interroga",
      "mappa.controlli.visualizza": "Visualizza",
      "mappa.identify.annuncio-risultati_one": "Interrogazione completata: {{count}} risultato trovato",
      "mappa.identify.annuncio-risultati_many": "Interrogazione completata: {{count}} risultati trovati",
      "mappa.identify.annuncio-risultati_other": "Interrogazione completata: {{count}} risultati trovati",
      "mappa.identify.nessun-risultato": "Nessun risultato trovato",
      "mappa.identify.poligono": "Poligono",
      "mappa.identify.punto": "Punto",
      "mappa.identify.rettangolo": "Rettangolo",
      "mappa.identify.risultati": "Risultati interrogazione",
      "mappa.identify.risultati-trovati_one": "Trovato {{count}} risultato",
      "mappa.identify.risultati-trovati_many": "Trovati {{count}} risultati",
      "mappa.identify.risultati-trovati_other": "Trovati {{count}} risultati",
      "mappa.livelli.gruppo.altri": "Altri",
      "mappa.livelli.popover.form-item-label.visibilita-livelli": "Visibilità dei livelli",
      "mappa.livelli.popover.pulsante-chiudi": "Chiudi",
      "mappa.livelli.popover.titolo.visibilita-dei-livelli": "Visibilità dei Livelli",
      "mappa.livelli.pulsante": "Livelli",
      "mappa.suggerimenti.disegna-linea": "Clicca per aggiungere punti · doppio clic per terminare la linea.",
      "mappa.suggerimenti.disegna-modifica": "Trascina un vertice per modificarlo o l'intera geometria per spostarla.",
      "mappa.suggerimenti.disegna-poligono": "Clicca per aggiungere punti · doppio clic per chiudere l'area.",
      "mappa.suggerimenti.disegna-punto": "Clicca sulla mappa per posizionare un punto.",
      "mappa.suggerimenti.disegna-punto-sposta": "Trascina un punto esistente per spostarlo.",
      "mappa.suggerimenti.elimina": "Clicca su una geometria per eliminarla.",
      "mappa.suggerimenti.interroga-poligono": "Clicca per aggiungere punti · doppio clic per chiudere l'area da interrogare.",
      "mappa.suggerimenti.interroga-punto": "Clicca sulla mappa per interrogare i livelli in quel punto.",
      "mappa.suggerimenti.interroga-rettangolo": "Clicca e trascina per definire l'area da interrogare.",
      "notification-drawer.priority-tag.alta": "ALTA",
      "notification-drawer.priority-tag.bassa": "BASSA",
      "notification-drawer.priority-tag.normale": "NORMALE",
      "notification-drawer.priority-tag.priorita": "Priorità:",
      "notification-drawer.priority-tag.urgente": "URGENTE",
      "notification-drawer.title": "Notifiche",
      "notification-filter-switch.all": "Tutte",
      "notification-filter-switch.to-read": "Da Leggere",
      "notification-type-icon.warning": "Attenzione",
      "notification.error": "Si è verificato un errore, riprovare.",
      "notifiche-campo-data-lettura": "Data Lettura",
      "notifiche-campo-data-lettura-a": "A Data Lettura",
      "notifiche-campo-data-lettura-da": "Da Data Lettura",
      "notifiche-campo-data-notifica": "Data Notifica",
      "notifiche-campo-data-notifica-a": "A Data Notifica",
      "notifiche-campo-data-notifica-da": "Da Data Notifica",
      "notifiche-campo-letta": "Letta",
      "notifiche-campo-non-letta": "Non Letta",
      "notifiche-campo-numero-istanza": "Numero Istanza",
      "notifiche-campo-oggetto": "Oggetto",
      "notifiche-campo-priorita": "Priorità",
      "notifiche-campo-tipo-domanda": "Tipo Domanda",
      "notifiche-campo-tipo-domanda-placeholder": "Tipo Domanda...",
      "notifiche-titolo-colonna.data-lettura": "Data Lettura",
      "notifiche-titolo-colonna.data-notifica": "Data Notifica",
      "notifiche-titolo-colonna.letta": "Letta",
      "notifiche-titolo-colonna.messaggio": "Messaggio",
      "notifiche-titolo-colonna.oggetto": "Oggetto",
      "notifiche-titolo-colonna.priorita": "Priorità",
      "notifiche.alt-image-notifica-da-leggere ": "Notifica da leggere",
      "notifiche.alt-image-notifica-letta": "Notifica Letta",
      "notifiche.da-leggere ": "Da leggere",
      "notifiche.letta": "Letta",
      "notifiche.letta-il": "Letta il",
      "notifiche.nessuna-notifica-da-leggere": "Nessuna notifica da leggere",
      "notifiche.non-letta": "Non letta",
      "notifiche.segna-come-letta": "Segna come letta",
      "notifiche.segna-tutte-come-lette": "Segna tutte come lette",
      "province-widget-schema.mun-belfiore.code": "Codice Belfiore comune",
      "province-widget-schema.mun-cap": "Cap comune",
      "province-widget-schema.mun-istat": "Codice Istat comune",
      "province-widget-schema.mun-lat": "Latitudine comune",
      "province-widget-schema.mun-lng": "Longitudine comune",
      "province-widget-schema.mun-name": "Nome comune",
      "province-widget-schema.mun-province": "Provincia comune",
      "province-widget-schema.mun-region": "Regione comune",
      "province-widget-schema.prov-belfiore-code": "Codice Belfiore",
      "province-widget-schema.prov-lat": "Latitudine provincia",
      "province-widget-schema.prov-lng": "Longitudine provincia",
      "province-widget-schema.prov-name": "Nome provincia",
      "province-widget-schema.prov-region": "Regione provincia",
      "province-widget.error": "Errore",
      "province-widget.error-description": "Errore durante il caricamento dei dati delle province. Riprovare più tardi.",
      "recipient-type.dipendente": "Dipendente",
      "recipient-type.ente-pubblico": "Ente Pubblico",
      "recipient-type.persona-fisica": "Persona Fisica",
      "recipient-type.persona-giuridica": "Persona Giuridica",
      "rules.map-calculation-up-to-date.error": "Il calcolo delle intersezioni della mappa non è completo: attendere che termini oppure rimuovere e reinserire le geometrie.",
      "semantic-tag-searchable-field.from": "Da",
      "semantic-tag-searchable-field.to": "A",
      "stato.pratica.aperta": "APERTA",
      "stato.pratica.chiusa": "CHIUSA",
      "stato.tipo-domanda.annullata": "ANNULLATA",
      "stato.tipo-domanda.aperta": "APERTA",
      "stato.tipo-domanda.bozza": "BOZZA",
      "stato.tipo-domanda.chiusa": "CHIUSA",
      "stato.tipo-domanda.collaudo": "COLLAUDO",
      "stato.tipo-domanda.in-corso": "IN CORSO",
      "stato.tipo-domanda.pronta": "PRONTA",
      "stato.tipo-domanda.pubblicata": "PUBBLICATA",
      "stato.tipo-domanda.sola-lettura": "SOLA LETTURA",
      "stato.tipo-domanda.sospesa": "SOSPESA",
      "submission-searchable-fields.tipo-domanda": "Tipo Domanda",
      "submission.altri-titolari": "Altri titolari",
      "triggerable-modules-confirm-update.generic-error": "Si è verificato un errore generico, riprovare più tardi",
      "upload-widget.file-must-be-uploaded": "Il file ${label} deve essere caricato",
      "upload-widget.public-doc": "Documento pubblico",
      "user.login.external-user-email": "Email",
      "user.login.external-user-password": "Password",
      "user.login.login-button": "Accedi",
      "user.login.password-forgot-link": "Reimposta password.",
      "user.login.password-forgot-question": "Hai dimenticato la password?",
      "user.login.sign-in-link": "Vai al modulo di registrazione.",
      "user.login.sign-in-question": "Non sei ancora registrato sul portale?",
      "burden-payment-state-tag.attesa-pagamento": "Attesa Pagamento",
      "burden-payment-state-tag.da-pagare": "Da Pagare",
      "burden-payment-state-tag.pagato": "Pagato",
      "burden-payment-state-tag.pagato-parzialmente": "Pagato Parzialmente",
      "burden-selection-table.errore-in-creazione-pagamento": "Si è verificato un errore durante la creazione del pagamento. Riprovare.",
      "burden-selection-table.seleziona-onere": "Seleziona onere ",
      "burden-selection-table.seleziona-oneri": "Seleziona tutti gli oneri",
      "burden-table.crea-pagamento": "Crea Pagamento",
      "burden-table.totale": "Totale",
      "burdens-columns.da-pagare-dopo-invio": "Da pagare dopo l'invio",
      "burdens-columns.descrizione": "Descrizione",
      "burdens-columns.facoltativo": "Facoltativo",
      "burdens-columns.importo": "Importo",
      "burdens-columns.obbligatorio": "Obbligatorio",
      "burdens-columns.stato-onere": "Stato Onere",
      "burdens-columns.tipo": "Tipo",
      "download-receipt.errore-in-download": "Si è verificato un problema durante il download del file",
      "error-submit-module-form.error-saving": "Errore durante il salvataggio",
      "error-submit-module-form.errore-salvataggio-modulo": "Errore durante il salvataggio, ID Modulo non presente",
      "error-submit-module-form.errore-salvataggio-richiesta": "Errore durante il salvataggio, ID Richiesta non presente",
      "fillable-form.sezione-della-compilazione": "Sezione della compilazione",
      "form.applicazione-marca-da-bollo": "Applicando la marca da bollo, la richiesta verrà congelata e non sarà possibile effettuare modifiche.",
      "form.avanti": "Avanti",
      "form.avviso-non-ancora-disponibile": "Documento non ancora disponibile, riprovare tra qualche minuto",
      "form.back-to-inquiries": "Annulla",
      "form.button.paga-il-bollo": "Paga il Bollo",
      "form.conferma": "Conferma",
      "form.conferma-di-procedere": "Confermi di voler procedere?",
      "form.elenco-pagamenti": "Elenco Pagamenti",
      "form.errore-in-download": "Si è verificato un problema durante il download del file",
      "form.indietro": "Indietro",
      "form.non-ci-sono-modifiche": "Non ci sono modifiche da salvare",
      "form.oneri-della-domanda": "Oneri della Domanda",
      "form.procedi-al-pagamento": "Procedi al pagamento",
      "form.procedi-al-pagamento-bollo": "Procedi al pagamento del Bollo",
      "form.procedi-al-pagamento-link-esterno": "Procedi al pagamento (apre un link esterno)",
      "form.salva": "Salva",
      "form.salva-modulo-download-pdf": "Salva il modulo almeno una volta per scaricare il documento PDF",
      "form.scarica-avviso": "Scarica Avviso",
      "form.scarica-ricevuta": "Scarica Ricevuta",
      "form.seleziona-gli-oneri": "Seleziona gli oneri per procedere al pagamento",
      "menu-items.guida-alla-compilazione": "Guida alla compilazione",
      "menu-items.pagamenti": "Pagamenti",
      "menu-items.riepilogo": "Riepilogo",
      "menu-items.riepilogo-e-invio": "Riepilogo e Invio",
      "module-attachments.anchor": "Allegati del modulo",
      "module-attachments.conteggio-file_one": "{{count}} file",
      "module-attachments.conteggio-file_many": "{{count}} file",
      "module-attachments.conteggio-file_other": "{{count}} file",
      "module-attachments.titolo": "Riepilogo Allegati del Modulo",
      "module-form.avviso-rimozione-moduli": "Attenzione, una volta rimossi, i dati compilati dei moduli andranno perduti. Se riattivati in seguito, sarà necessario ricompilare i moduli.",
      "module-form.confermare-le-modifiche-ai-moduli": "Confermare le modifiche ai moduli?",
      "module-form.moduli-da-compilare-in-aggiunta": "Saranno aggiunti {{length}} nuovi moduli da compilare:",
      "module-form.rimozione-del-modulo-corrente": "Sarà rimosso il seguente modulo:",
      "module-form.rimozione-moduli": "Saranno rimossi {{length}} moduli:",
      "module-form.salvando-le-richieste-verranno-apportate-le-modifiche": "Salvando la richiesta verranno apportate le seguenti modifiche:",
      "module-form.un-modulo-da-compilare-in-aggiunta": "Verrà aggiunto il seguente modulo da compilare:",
      "module-title.altro-modulo": "Altro Modulo",
      "module-tooltip-text.completato": "Completato",
      "module-tooltip-text.in-attesa-della-firma": "In attesa della firma",
      "module-tooltip-text.in-fase-di-compilazione": "In fase di compilazione",
      "module-tooltip-text.modulo-non-valido": "Modulo non valido",
      "module-validation-state-text.compila": "Compila",
      "module-validation-state-text.completato": "Completato",
      "module-validation-state-text.firma": "Firma",
      "module.state-progress-bar.stato-del-modulo": "Stato del Modulo",
      "payment-burden-type-tag.bollo": "",
      "payment-burden-type-tag.modello-1": "",
      "payment-burden-type-tag.modello-3": "",
      "payment-columns.codice": "Codice",
      "payment-columns.importo": "Importo",
      "payment-columns.stato-pagamento": "Stato Pagamento",
      "payment-state-tag.completato": "COMPLETATO",
      "payment-state-tag.da-pagare": "DA PAGARE",
      "payment-state-tag.errore-pagamento": "ERRORE PAGAMENTO",
      "payment-state-tag.pendente": "PENDENTE",
      "payment-table.azioni": "Azioni",
      "payment-table.tipi": "Tipo",
      "payment.da-pagare-dopo-invio": "Da Pagare dopo l'invio",
      "quote-columns.data": "Data",
      "quote-columns.descrizione": "Descrizione",
      "quote-columns.imponibile": "Imponibile",
      "quote-columns.importo": "Importo",
      "quote-columns.iva": "IVA",
      "quote-columns.numero": "Numero",
      "quote-columns.stato": "Stato",
      "quote-state-tag.attesa-approvazione": "Attesa Approvazione",
      "quote-state-tag.attesa-pagamento": "Attesa Pagamento",
      "quote-state-tag.pagato": "Pagato",
      "quote-state-tag.rifiutato": "Rifiutato",
      "quote-table.azioni": "Azioni",
      "quote-table.azioni.button-confirm.accept.message.accetta-preventivo-prima-riga": "Confermi di aver scaricato e letto il il preventivo nella sua interezza.",
      "quote-table.azioni.button-confirm.accept.message.accetta-preventivo-seconda-riga": "Confermi di voler accettare il preventivo?",
      "quote-table.azioni.button-confirm.accept.text": "ACCETTA",
      "quote-table.azioni.button-confirm.refuse.message.rifiuto-preventivo": "Sei sicuro di voler rifiutare il Preventivo?",
      "quote-table.azioni.button-confirm.refuse.text": "RIFIUTA",
      "quote-table.azioni.button.aria-label.scarica-preventivo": "Scarica Preventivo",
      "quote-table.azioni.button.tooltips.scarica-preventivo": "Scarica Preventivo",
      "quote-table.errore-in-accettazione-preventivo": "Si è verificato un problema durante l'accettazione del preventivo",
      "quote-table.errore-in-download-file": "Si è verificato un problema durante il download del file",
      "riepilogo-firmato.annulla-e-ricarica-file-firmato": "Annulla e Ricarica file firmato",
      "riepilogo-firmato.documento-firmato": "Riepilogo Firmato",
      "riepilogo-firmato.download-riepilogo-richiesta": "Download del Riepilogo della Richiesta",
      "riepilogo-firmato.errore-in-upload": "Si è verificato un problema durante il caricamento del riepilogo firmato",
      "riepilogo-firmato.errore-verifica-firmato": "Non è stato possibile verificare la presenza del riepilogo firmato. Ricaricare la pagina per riprovare.",
      "riepilogo-firmato.procedura-firma-riepilogo": "Procedura di Firma del Riepilogo della Richiesta",
      "riepilogo-firmato.riepilogo-firmato-caricato": "Il riepilogo firmato è stato caricato. È possibile procedere con l'invio della richiesta.",
      "riepilogo-firmato.scarica-firma-ricarica-desc": "Scaricare il documento di Riepilogo della Richiesta, procedere alla firma digitale e ricaricare il documento firmato.",
      "riepilogo-firmato.scarica-pdf-firmato": "Scarica Riepilogo Firmato",
      "riepilogo-firmato.scarica-pdf-riepilogo": "Scarica Riepilogo",
      "riepilogo-firmato.scarica-riepilogo-desc": "È possibile scaricare il documento di Riepilogo della Richiesta.",
      "riepilogo-firmato.upload-completato": "Riepilogo firmato caricato con successo",
      "riepilogo-firmato.visualizza-pdf-firmato": "Visualizza Riepilogo Firmato",
      "riepilogo-firmato.visualizza-pdf-riepilogo": "Visualizza Riepilogo",
      "shared-section.editable-label": "SEZIONE DATI CONDIVISA",
      "shared-section.editable-tooltip": "La sezione è condivisa con altri moduli della domanda. Modificando i dati di questa sezione modificherai anche i dati degli altri moduli, invalidandoli qualora siano già conclusi o firmati.",
      "shared-section.info-tooltip": "Informazioni sulla sezione condivisa",
      "shared-section.navigate-to-source": "Modifica nel modulo di origine",
      "shared-section.readonly-label": "SEZIONE DATI CONDIVISA — SOLA LETTURA",
      "shared-section.readonly-tooltip": "Questa sezione proviene da un altro modulo e non può essere modificata qui.",
      "signer.carica-e-completa": "Carica e Completa",
      "signer.certificato": "Certificato",
      "signer.certificato-in-validita": "In validità",
      "signer.certificato-non-ancora-valido": "Non ancora valido",
      "signer.certificato-non-disponibile": "N/D",
      "signer.certificato-scaduto": "Scaduto",
      "signer.data-firma": "Data firma",
      "signer.ente-cert": "Ente cert.",
      "signer.firma-autografa": "Firma autografa",
      "signer.firma-autografa-info": "Firma autografa — non sono disponibili dati di certificato o marca temporale.",
      "signer.firma-digitale": "Firma digitale",
      "signer.firmatario-sconosciuto": "Firmatario sconosciuto",
      "signer.formato-file-non-valido": "Formato file non valido. Estensioni accettate: {{extensions}}",
      "signer.modifica-file-firmato": "Cambia file firmato...",
      "signer.nessun-file-selezionato": "Nessun file selezionato",
      "signer.seleziona-file-firmato": "Seleziona file firmato...",
      "signer.seriale": "Seriale",
      "signer.validita": "Validità",
      "signer.verifica-firma": "Verifica Firma",
      "stamp-duty-payment.avvio-pagamento": "Avvio del pagamento...",
      "stamp-duty-payment.errore-avvio-pagamento": "Si è verificato un errore durante l'avvio del pagamento",
      "stamp-duty-payment.errore-modifica-stato-pagamento": "Si è verificato un errore durante la modifica dello stato del pagamento",
      "start-payment-button.avvio-pagamento": "Avvio del pagamento...",
      "start-payment-button.errore-avvio-pagamento": "Si è verificato un errore durante l'avvio del pagamento",
      "submission-confirm-update.conferma-aggiornamento-modulo": "Confermi di voler aggiornare il modulo?",
      "submission-confirm-update.conferma-modifiche": "Conferma modifiche attivazioni moduli",
      "submission-list.unknown-applicant": "non identificato",
      "submission-menu-item.bolli": "Bolli",
      "submission-menu-item.pagamenti": "Pagamenti",
      "submission-menu-item.preventivi": "Preventivi",
      "submission-menu-item.scheda-domanda": "Scheda Domanda",
      "submission-menu-item.sezione-disabilitata": "Sezione disabilitata",
      "submission-menu-items.altro-modulo": "Altro Modulo",
      "submission-menu-items.modulo-principale": "Modulo Principale",
      "submission-menu-items.sezione": "Sezione {{index}}",
      "submission-menu-label.aria-label.name-prefix": "sezione",
      "submission-menu.count-badge.aria_one": "{{count}} allegato",
      "submission-menu.count-badge.aria_many": "{{count}} allegati",
      "submission-menu.count-badge.aria_other": "{{count}} allegati",
      "submission-menu.navigazione-richiesta": "Navigazione della richiesta",
      "submission-menu.section.dirty-badge.dirty.sezione-da-salvare": "Sezione da salvare",
      "submission-menu.section.dirty-badge.error.sezione-non-valida": "Sezione non valida",
      "submission-menu.selezionato": "selezionato",
      "submission-module-button.errore-in-download": "Si è verificato un problema durante il download del file",
      "submission-module-button.richiesta-non-pubblica": "Impossibile scaricare il PDF con Omissis: la Richiesta non è pubblica",
      "submission-module-button.scarica-pdf": "Scarica PDF",
      "submission-module-button.scarica-pdf-firmato": "Scarica PDF",
      "submission-module-button.scarica-pdf-omissis": "Scarica PDF Omissis",
      "submission-module-button.visualizza-pdf": "Visualizza PDF",
      "submission-module-button.visualizza-pdf-omissis": "Visualizza PDF Omissis",
      "submission-payment-form.errore-richiesta": "Si è verificato un errore durante il caricamento della richiesta. La richiesta non è definita.",
      "submission-payment-form.errore-richiesta-titolo": "Richiesta non definita",
      "submission-payment-form.oneri-bolli-da-pagare-dopo-invio": "Di seguito trovi i pagamenti da effettuare a seguito dell’invio",
      "submission-payment-form.pagamento-annullato": "Pagamento annullato",
      "submission-payment-form.pagamento-completato": "Il pagamento è stato completato con successo",
      "submission-payment-form.pagamento-completato-con-successo": "Pagamento completato con successo",
      "submission-payment-form.pagamento-errore": "Si è verificato un errore durante il pagamento",
      "submission-payment-form.seleziona-bolli": "Seleziona i bolli per procedere al pagamento",
      "submission-payment-form.seleziona-oneri": "Seleziona gli oneri per procedere al pagamento",
      "submission-state-tag.annullamento-in-corso": "ANNULLAMENTO IN CORSO",
      "submission-state-tag.annullata": "ANNULLATA",
      "submission-state-tag.bozza": "BOZZA",
      "submission-state-tag.cancellata": "CANCELLATA",
      "submission-state-tag.conclusa": "CONCLUSA",
      "submission-state-tag.creata": "CREATA",
      "submission-state-tag.in-invio": "IN INVIO",
      "submission-state-tag.integrata": "INTEGRATA",
      "submission-state-tag.integrata-dopo-richiesta-integrazione": "Integrata dopo richiesta di integrazione",
      "submission-state-tag.inviata": "INVIATA",
      "submission-state-tag.pagamento": "IN PAGAMENTO",
      "submission-state-tag.ricevuta": "RICEVUTA",
      "submission-state-tag.richiesta-accettazione-preventivo": "È richiesta l'accettazione del Preventivo",
      "submission-state-tag.richiesta-integrazione": "È richiesta l'integrazione",
      "submission-state-tag.richiesta-pagamento-preventivo": "È richiesto il pagamento del Preventivo",
      "submission-state-tag.sono-presenti-preventivi": "Sono presenti preventivi",
      "submission-summary.allegato-non-disponibile": "File non disponibile",
      "submission-summary.azioni": "Azioni",
      "submission-summary.cf-piva": "C.F. / P. IVA",
      "submission-summary.codice": "Codice",
      "submission-summary.comune-prevalente": "Comune prevalente",
      "submission-summary.copia-json": "Copia JSON",
      "submission-summary.dati-anagrafici": "Dati Anagrafici",
      "submission-summary.dati-generali": "Dati Generali",
      "submission-summary.delegato": "Delegato",
      "submission-summary.descrizione": "Descrizione",
      "submission-summary.elenco-allegati": "Elenco degli Allegati",
      "submission-summary.elenco-moduli": "Elenco dei Moduli",
      "submission-summary.email": "Email",
      "submission-summary.email-aria": "Invia email a {{email}}",
      "submission-summary.errore-download-allegato": "Si è verificato un problema durante il download del file",
      "submission-summary.fattispecie": "Fattispecie",
      "submission-summary.json-copiato": "JSON copiato!",
      "submission-summary.modulo-json-errore": "Si è verificato un problema durante il caricamento dei dati del modulo",
      "submission-summary.modulo-json-vuoto": "Il modulo non contiene dati di compilazione",
      "submission-summary.nome-file": "Nome del file",
      "submission-summary.nome-modulo": "Modulo",
      "submission-summary.oggetto-richiesta": "Oggetto richiesta",
      "submission-summary.pec": "PEC",
      "submission-summary.pec-aria": "Invia PEC a {{pec}}",
      "submission-summary.responsabile-procedimento": "Responsabile del procedimento",
      "submission-summary.scarica": "Scarica",
      "submission-summary.stato": "Stato",
      "submission-summary.stato-oneri": "Stato Oneri",
      "submission-summary.tag-altro-soggetto": "Altro soggetto",
      "submission-summary.tag-legale-rappresentante": "Legale Rappresentante",
      "submission-summary.tag-procuratore": "Procuratore",
      "submission-summary.tag-supporto": "Supporto",
      "submission-summary.tag-titolare": "Titolare",
      "submission-summary.tipo-domanda": "Tipo domanda",
      "submission-summary.tipologia": "Tipologia",
      "submission-summary.titolo": "Titolo",
      "submission-summary.type-persona-fisica": "Persona Fisica",
      "submission-summary.type-persona-giuridica": "Persona Giuridica",
      "submission-summary.ufficio-competente": "Sportello",
      "submission-summary.vai-al-modulo": "Vai al modulo",
      "submission-summary.versione-pubblica-omissis": "Versione pubblica con Omissis",
      "submission-summary.visualizza": "Visualizza",
      "submission-summary.visualizza-json": "Visualizza JSON",
      "submission.richiesta": "Richiesta",
      "summary-payments.allegato": "Allegato",
      "summary-payments.azioni": "Azioni",
      "summary-payments.data-creazione": "Data creazione",
      "summary-payments.data-pagamento": "Data pagamento",
      "summary-payments.importo": "Importo",
      "summary-payments.onere": "Onere",
      "summary-payments.oneri": "Oneri",
      "summary-payments.pagamenti": "Pagamenti",
      "summary-payments.tipo": "Tipo",
      "summary-payments.totale": "Totale",
      "summary-payments.ufficio-destinatario": "Ufficio destinatario",
      "summary-payments.vincolo": "Vincolo",
      "alert-message.error.close-icon-label": "Chiudi",
      "filter-bar.value-selected": "Valore selezionato",
      "form.alert-message.content": "Sono presenti errori di compilazione ({{errors_count}})",
      "form.error-list.hide": "Nascondi {{errorCount}} errori",
      "form.error-list.hide_one": "Nascondi 1 errore",
      "form.error-list.show-more": "Mostra altri {{errorCount}} errori",
      "form.error-list.show-more_one": "Mostra 1 altro errore",
      "form.prevent-navigation.prompt": "Sei sicuro di voler abbandonare la pagina? Tutte le modifiche non salvate andranno perse",
      "form.reset-button.cancel": "Annulla",
      "form.reset-button.tooltip-not-dirty": "Non ci sono modifiche da annullare",
      "form.submit-button.save": "Salva",
      "form.submit-button.tooltip-not-dirty": "Non ci sono modifiche da salvare",
      "inputs.async-select-input-meta.content": "Mostrati {{shown}} di {{total}}.",
      "inputs.async-select-input-meta.filter": "Filtrare la ricerca digitando per migliorare i risultati.",
      "inputs.async-select.caricamento-opzioni": "Caricamento...",
      "inputs.async-select.errore-caricamento-opzioni": "Errore durante il caricamento dei dati",
      "inputs.async-select.nessun-risultato": "Nessun risultato trovato",
      "inputs.date-input.clear-button": "Pulisci il campo",
      "inputs.date-input.error": "La data inserita non è valida",
      "inputs.dragger-input-body.title": "Fare clic o trascinare il file in quest’area per caricarlo",
      "inputs.dragger-input.info": "Formati consentiti: {{formats}}",
      "inputs.dragger-input.title": "Fare click o trascinare il file in quest’area per caricarlo",
      "inputs.file-extension-select-input.placeholder": "Scrivi e premi invio per aggiungere un nuovo formato",
      "inputs.info-icon-row": "Fai click sull’icona {{content}} di anteprima",
      "inputs.rich-text-link-button.label": "URL",
      "inputs.rich-text-link-button.placeholder": "Inserisci l'URL del link",
      "inputs.rich-text-menu-bar.align-center": "Allinea al centro",
      "inputs.rich-text-menu-bar.align-left": "Allinea a sinistra",
      "inputs.rich-text-menu-bar.align-right": "Allinea a destra",
      "inputs.rich-text-menu-bar.bold": "Grassetto",
      "inputs.rich-text-menu-bar.color": "Colore",
      "inputs.rich-text-menu-bar.hard-break": "Accapo",
      "inputs.rich-text-menu-bar.heading-1": "H1",
      "inputs.rich-text-menu-bar.heading-2": "H2",
      "inputs.rich-text-menu-bar.heading-3": "H3",
      "inputs.rich-text-menu-bar.heading-4": "H4",
      "inputs.rich-text-menu-bar.heading-5": "H5",
      "inputs.rich-text-menu-bar.heading-6": "H6",
      "inputs.rich-text-menu-bar.heading-group": "Intestazioni",
      "inputs.rich-text-menu-bar.italic": "Corsivo",
      "inputs.rich-text-menu-bar.justify-text": "Giustifica testo",
      "inputs.rich-text-menu-bar.omissis": "Omissis",
      "inputs.rich-text-menu-bar.ordered-list": "Elenco ordinato",
      "inputs.rich-text-menu-bar.strikethrough": "Barrato",
      "inputs.rich-text-menu-bar.text-extra-small": "Molto piccolo",
      "inputs.rich-text-menu-bar.text-large": "Grande",
      "inputs.rich-text-menu-bar.text-normal": "Normale",
      "inputs.rich-text-menu-bar.text-sizes": "Dimensioni",
      "inputs.rich-text-menu-bar.text-small": "Piccolo",
      "inputs.rich-text-menu-bar.title": "Titolo",
      "inputs.rich-text-menu-bar.underline": "Sottolineato",
      "inputs.rich-text-menu-bar.unordered-list": "Elenco",
      "inputs.select.nessuna-opzione-disponibile": "(Nessuna opzione disponibile)",
      "inputs.upload-input.aria": "Carica",
      "inputs.upload-input.title": "Carica file",
      "utils.decorate-with-form.submit": "Invia",
      "actor-permission-icon.permesso-firmare-modulo": "{{canSign}} firmare il modulo.",
      "actor-permission-icons.can": "Puoi",
      "actor-permission-icons.cannot": "Non puoi",
      "actor-permission-icons.permesso-compilare-modulo": "{{canCompile}} compilare il modulo.",
      "actor-permission-icons.permesso-visualizzazione-modulo": "{{canView}} visualizzare il modulo.",
      "actor-role-tag.tipo-utente-delegato": "Sei {{tagOption}} della Richiesta.",
      "address-book.action.delete.success": "Contatto eliminato con successo",
      "address-book.company.action.delete": "Elimina Contatto",
      "address-book.company.action.edit": "Modifica Persona Giuridica",
      "address-book.company.action.view": "Visualizza Persona Giuridica",
      "address-book.company.certification.certified": "Dati Certificati dal Registro Imprese",
      "address-book.company.certification.certified-desc": "I dati anagrafici sono stati importati e certificati. Modificandoli manualmente perderanno la certificazione.",
      "address-book.company.certification.certified-desc-fallback": "Aggiornando dal Registro Imprese, eventuali modifiche manuali verranno sovrascritte.",
      "address-book.company.certification.enable-edit-button": "Modifica manualmente",
      "address-book.company.certification.not-certified": "I dati inseriti non sono certificati.",
      "address-book.company.certification.not-certified-fallback": "Aggiorna dal Registro Imprese per certificarli - eventuali modifiche manuali verranno sovrascritte.",
      "address-book.company.certification.not-certified-title": "Dati non certificati",
      "address-book.company.certification.update-button": "Aggiorna da Registro Imprese",
      "address-book.company.certification.update-error": "Aggiornamento non riuscito. Riprova più tardi.",
      "address-book.company.create.import-info.description": "Inserisci il Codice Fiscale per importare automaticamente i dati.",
      "address-book.company.create.import-info.description-fallback": "Se l'importazione non va a buon fine, sarà possibile compilare i campi manualmente.",
      "address-book.company.create.import-info.title": "Importazione dati dal Registro Imprese",
      "address-book.company.detail.address": "Indirizzo",
      "address-book.company.detail.cap": "CAP",
      "address-book.company.detail.duplicate-fiscal-code-vat.body": "La coppia codice fiscale e partita IVA inserita è già presente nel sistema.",
      "address-book.company.detail.duplicate-fiscal-code-vat.title": "Attenzione: codice fiscale e partita IVA duplicati",
      "address-book.company.detail.fraction": "Frazione",
      "address-book.company.detail.house-number": "Numero Civico",
      "address-book.company.detail.operational-legal-headquarters-same": "Sede Operativa coincide con la Sede Legale",
      "address-book.company.detail.operational-legal-headquarters-same.false": "No",
      "address-book.company.detail.operational-legal-headquarters-same.true": "Sì",
      "address-book.company.import-button.import-error": "Si è verificato un errore durante l'importazione. Riprova più tardi.",
      "address-book.company.import-button.import-from-registry": "Importa da Registro Imprese",
      "address-book.company.import-button.import-success": "Importazione avvenuta con successo",
      "address-book.company.import-button.tooltip-disabled": "Inserisci un Codice Fiscale per abilitare la ricerca",
      "address-book.company.import-button.tooltip-enabled": "Importa da Registro Imprese",
      "address-book.company.import-button.update-success": "Aggiornamento avvenuto con successo",
      "address-book.company.import-company-failed.body.line1": "Importazione dal Registro Imprese non riuscita.",
      "address-book.company.import-company-failed.body.line2": "Non è stato possibile recuperare i dati in questo momento.",
      "address-book.company.import-company-failed.body.line3": "È possibile procedere con la compilazione manuale della scheda e riprovare l'importazione automatica in un secondo momento per certificare i dati.",
      "address-book.company.import-company-failed.title": "Importazione non riuscita",
      "address-book.company.list.errors.unable-to-load": "Impossibile caricare l'elenco delle persone giuridiche",
      "address-book.company.list.persone-giuridiche-trovate-in-base-ai-filtri": "Persone Giuridiche trovate in base ai filtri di ricerca.",
      "address-book.company.list.rimuovi-filtri": "Rimuovi filtri",
      "address-book.company.page.company-data": "Dati Ragione Sociale",
      "address-book.company.page.legal-headquarters": "Dati Sede Legale",
      "address-book.company.page.legal-representative": "Dati Rappresentante Legale",
      "address-book.company.page.legal-representative.error": "Errore nel recupero dei dati del rappresentante legale: {{errorMessage}}",
      "address-book.company.page.legal-representative.select-legal-representative": "Seleziona un rappresentante legale",
      "address-book.company.page.legal-representative.use-legal-representative-data": "Recupera dati di un' entità fisica esistente per il legale rappresentante",
      "address-book.company.page.operational-headquarters": "Dati Sede Operativa",
      "address-book.country.unknown": "Sconosciuto",
      "address-book.menu": "Rubrica",
      "address-book.navigation-button.cancel-edit": "Annulla Modifiche",
      "address-book.navigation-button.edit": "Modifica",
      "address-book.navigation-button.exit-edit": "Esci dalla Modifica",
      "address-book.new-company": "Nuova Azienda",
      "address-book.new-contact": "Nuovo Contatto",
      "address-book.new-contact.company": "Persona Giuridica",
      "address-book.new-contact.person": "Persona Fisica",
      "address-book.page.errors.unable-to-load": "Impossibile caricare il contatto",
      "address-book.pagina.briciole.rubrica": "Rubrica",
      "address-book.pagina.tab.company": "Persone Giuridiche",
      "address-book.pagina.tab.person": "Persone Fisiche",
      "address-book.pagina.titolo": "Rubrica",
      "address-book.person.action.delete": "Elimina Contatto",
      "address-book.person.action.edit": "Modifica Persona",
      "address-book.person.action.view": "Visualizza Persona",
      "address-book.person.detail.born-in-italy.false": "Nato/a all'estero",
      "address-book.person.detail.born-in-italy.true": "Nato/a in Italia",
      "address-book.person.detail.country": "Stato",
      "address-book.person.detail.duplicate-fiscal-code": "Attenzione: il codice fiscale inserito è già presente nel sistema.",
      "address-book.person.detail.entered-in-register.no": "No",
      "address-book.person.detail.entered-in-register.yes": "Sì",
      "address-book.person.detail.fraction": "Frazione",
      "address-book.person.detail.gender.female": "Femmina",
      "address-book.person.detail.gender.male": "Maschio",
      "address-book.person.detail.resident-in-italy.false": "Residente all'estero",
      "address-book.person.detail.resident-in-italy.true": "Residente in Italia",
      "address-book.person.detail.telephone": "Telefono Fisso",
      "address-book.person.list.errors.unable-to-load": "Impossibile caricare l'elenco delle persone fisiche",
      "address-book.person.list.found": "Persone trovate in base ai filtri di ricerca.",
      "address-book.person.list.remove-filter": "Rimuovi filtri",
      "address-book.person.page.anagraphic-data": "Dati Anagrafici",
      "address-book.person.page.birth-data": "Dati di Nascita",
      "address-book.person.page.contact-data": "Dati di Contatto",
      "address-book.person.page.register-data": "Dati di Iscrizione all'Albo",
      "address-book.person.page.residence-data": "Dati di Residenza",
      "advanced-search.data-deve-essere-successiva": "La data deve essere successiva al campo ${path}",
      "alert-message.warning.close-icon-label": "Chiudi",
      "annulla-modifiche": "Annulla modifiche",
      "change-submission-manager-button.help-description.gestore": "L'utente gestore ha la possibilità di compilare i moduli e delegarne la compilazione e la visualizzazione. L'invio è riservato al titolare o al procuratore in sua vece. Rimuovendoti dal ruolo di gestore, potresti perdere la possibilità di accedere alla richiesta.",
      "change-submission-manager-button.help-description.procuratore": "L'utente procuratore ha la possibilità di visualizzare la richiesta, delegare i singoli moduli e cambiare il gestore della stessa, facendo le veci del titolare. Solo se viene concesso il permesso, potrà anche inoltrare la richiesta.",
      "change-submission-manager-button.input.can-submit.checkbox-text.assegna-procuratore-come-gestore": "Vuoi indicare il Procuratore come Gestore della Richiesta?",
      "change-submission-manager-button.input.can-submit.checkbox-text.permesso-di-invio": "Permesso di invio",
      "change-submission-manager-button.input.can-submit.help.assegna-come-gestore-help": "Il Procuratore potrà procedere alla compilazione della richiesta, all’assegnazione di eventuali delegati o all’inoltro, se abilitato. Può essere modificato anche in seguito.",
      "change-submission-manager-button.input.can-submit.help.permetti-al-procuratore-indicato-di-inviare-la-richiesta": "Permetti al procuratore indicato di inviare la richiesta",
      "change-submission-manager-button.input.can-submit.label.assegna-come-gestore": "Assegna come Gestore",
      "change-submission-manager-button.input.can-submit.label.cognome": "Cognome",
      "change-submission-manager-button.input.can-submit.label.email": "E-mail",
      "change-submission-manager-button.input.can-submit.label.invio-richiesta": "Invio richiesta",
      "change-submission-manager-button.input.can-submit.label.nome": "Nome",
      "change-submission-manager-button.input.file.label.documento-di-delega": "Documento di Delega",
      "change-submission-manager-button.input.file.upload-button.icon-aria-label.carica": "Carica",
      "change-submission-manager-button.input.file.upload-button.title.carica-documento-di-delega": "Carica Documento di Delega",
      "change-submission-manager-button.input.fiscal-code.label.codice-fiscale": "Codice Fiscale o E-Mail",
      "change-submission-manager-button.input.fiscal-code.placeholder.codice-fiscale": "Codice Fiscale o E-Mail",
      "change-submission-manager-button.message.error.nessun-id-della-richiesta-trovato": "Nessun ID della richiesta trovato",
      "change-submission-manager-button.message.error.si-e-verificato-un-errore-riprovare": "Si è verificato un errore. Riprovare.",
      "change-submission-manager-button.message.success.aggiornato-con-successo": "aggiornato con successo",
      "change-submission-manager-button.subject-name.gestore": "Gestore",
      "change-submission-manager-button.subject-name.procuratore": "Procuratore",
      "change-submission-manager-button.title-prexix.assegna-un": "Assegna un",
      "change-submission-manager-button.title-prexix.cambia": "Cambia",
      "change-submission-manager.conferma-cambio-gestore": "Conferma cambio gestore",
      "change-submission-manager.sicuro-di-voler-sostituire-il-gestore": "Sei sicuro di voler sostituire il gestore della richiesta? Una volta completata l'operazione potresti perdere la possibilità di accedere alla richiesta.",
      "common.annulla": "Annulla",
      "compilation-guide.avvia": "Avvia",
      "compilation-guide.domanda-non-trovata-in-archivio": "Domanda non trovata in archivio: id {{submissionId}}",
      "compilation-guide.impossibile-caricare-la-guida-alla-compilazione": "Impossibile caricare la guida alla compilazione della domanda",
      "compilation-module.impossibile-caricare-i-moduli": "Impossibile caricare i Moduli della Domanda",
      "compilation-module.modulo-salvato-con-successo": "Modulo salvato con successo",
      "create-request-button.error": "Errore durante la creazione della richiesta",
      "delegate-username.nessuno": "Nessuno",
      "delegati-differenti-o-mancanti": "I moduli presentano delegati differenti o mancanti",
      "delegation-column-base.delegati": "Delegati",
      "delegation-column-base.lettura": "Lettura",
      "delegation-column-base.moduli": "Moduli",
      "delegation-data-schema.abilita-compilazione": "Abilita Compilazione",
      "delegation-data-schema.abilita-firma": "Abilita Firma",
      "delegation-data-schema.abilita-invio": "Abilita Invio",
      "delegation-data-schema.codice-fiscale": "Codice Fiscale",
      "delegation-page.attorney": "Procuratore",
      "delegation-page.azioni": "Azioni",
      "delegation-page.manager": "Gestore",
      "delegation-page.title": "Gestione Deleghe",
      "delegation-page.torna-alla-richiesta": "Torna alla richiesta",
      "delegation-schema.documento-di-delega": "Documento di Delega",
      "delegation.errore": "Si è verificato un errore. Riprovare.",
      "delegation.modifica-deleghe-moduli-drawer.delega-di-compilazione": "Delega di Compilazione",
      "delegation.modifica-deleghe-moduli-drawer.delega-di-firma": "Delega di Firma",
      "delegation.modifica-deleghe-moduli-drawer.delegati": "Delegati",
      "delegation.modifica-deleghe-moduli-drawer.deleghe-aggiornate": "Deleghe aggiornate con successo",
      "delegation.modifica-deleghe-moduli-drawer.deleghe-di-visualizzazione": "Deleghe di Visualizzazione",
      "delegation.modifica-deleghe-moduli-drawer.moduli-selezionati": "Moduli Selezionati",
      "delegation.modifica-deleghe-moduli-drawer.titolo": "Gestione Deleghe Moduli",
      "delegation.page.breadcrumb.gestione-deleghe": "Gestione Deleghe",
      "delegation.page.breadcrumb.richieste": "Richieste",
      "delegation.page.button.gestisci-selezionati": "Gestisci Selezionati",
      "delegation.page.delegation-table.button.gestisci": "Gestisci",
      "delegation.page.delegation-table.checkbox.seleziona-modulo": "Seleziona modulo",
      "delegation.page.delegation-table.checkbox.seleziona-tutti-i-moduli": "Seleziona tutti i moduli",
      "delegation.page.divider-title.deleghe-dei-moduli": "Deleghe dei Moduli",
      "delegation.page.error.impossibile-caricare-le-deleghe-della-richiesta": "Impossibile caricare le deleghe della richiesta",
      "domanda-copertina.accedi": "Accedi",
      "domanda.bottone-compilare-una-richiesta-per-titolare": "È possibile compilare una sola richiesta per titolare per questa domanda",
      "domanda.bottone-crea-richiesta.vai-alla-compilazione": "Vai alla compilazione",
      "domanda.bottone-crea-richiesta.visualizza-anteprima": "Visualizza anteprima",
      "domande-secondarie.lista.elemento.etichetta.avviabile-dal": "Avviabile dal",
      "domande-secondarie.lista.elemento.etichetta.scadenza-invio": "Scadenza invio",
      "domande.lista.elemento.alt-immagine.copertina-domanda": "copertina domanda",
      "domande.lista.elemento.etichetta.scadenza": "Scadenza",
      "domande.lista.elemento.pulsante.vai-alla-domanda": "Vai alla Domanda",
      "domande.lista.pulsante.rimuovi-filtri": "Rimuovi filtri",
      "dossier-card-cover.dossier-link-button": "Vai alla Pratica",
      "dossier-page.errore-caricamento-pratica": "Si è verificato un errore durante il caricamento della pratica.",
      "dossier-permission.delete-confirm-description": "Una volta rimosso, il soggetto non avrà più accesso alla pratica.",
      "dossier-permission.delete-confirm-title": "Rimuovere il permesso?",
      "dossier-permission.gestione-permessi-creazione.errore": "Errore durante il salvataggio",
      "dossier-permission.gestione-permessi-creazione.successo": "Permesso creato con successo",
      "dossier-permission.gestione-permessi-drawer.titolo": "Aggiungi nuovo soggetto",
      "dossier-permission.ruolo.editor": "Intermediario",
      "dossier-permission.ruolo.titolare": "Titolare",
      "dossier-permission.ruolo.viewer": "Visualizzatore",
      "dossier-permissions.get-list.generic-error": "Si è verificato un errore. Riprovare.",
      "dossier-permissions.remove.error": "Si è verificato un errore durante l'eliminazione del soggetto",
      "dossier-permissions.remove.success": "Permesso rimosso con successo",
      "dossier.list.errors.unable-to-load": "Impossibile caricare l'elenco delle pratiche",
      "dossiers-list.dossierss-list-title": "Elenco Pratiche",
      "dossiers-list.richieste": "Pratiche",
      "edit-modules-delegation-schema.delegati-alla-visualizzazione": "Delegati alla visualizzazione",
      "edit-modules-delegation-schema.delegato-alla-compilazione": "Delegato alla compilazione",
      "edit-modules-delegation-schema.delegato-alla-firma": "Delegato alla firma",
      "errors-default.403.messaggio.non-autorizzato": "Non si dispone dei permessi per visualizzare la pagina richiesta.",
      "errors-default.403.titolo.non-autorizzato": "403 Non Autorizzato",
      "errors-default.404.messaggio.non-trovata": "Pagina Non Trovata.",
      "errors-default.404.titolo.non-trovato": "404 Non Trovato",
      "errors-default.500.messaggio.errore-interno-server": "Si è verificato un errore non previsto del server. Si prega di riprovare o contattare l'assistenza.",
      "errors-default.500.titolo.errore-interno-server": "500 Errore Interno Server",
      "errors-default.generico.messaggio.errore-network": "Sì è verificato un errore nella richiesta.",
      "errors-default.generico.titolo.errore-network": "Errore Network",
      "export.file": "Richieste_{{data}}.{{fileExtension}}",
      "extended-filters-schema.categorie": "Categorie",
      "extended-filters-schema.codice-fiscale-titolare": "Codice Fiscale Titolare",
      "extended-filters-schema.cognome-titolare": "Cognome Titolare",
      "extended-filters-schema.data-avvio-compilazione-a": "Data Avvio Compilazione A",
      "extended-filters-schema.data-avvio-compilazione-da": "Data Avvio Compilazione Da",
      "extended-filters-schema.data-invio-compilazione-a": "Data Invio Compilazione A",
      "extended-filters-schema.data-invio-compilazione-da": "Data Invio Compilazione Da",
      "extended-filters-schema.email-titolare": "Email Titolare",
      "extended-filters-schema.nome-titolare": "Nome Titolare",
      "extended-filters-schema.stato-delega": "Stato Delega",
      "extended-filters-schema.stato-richiesta": "Stato Richiesta",
      "extended-filters-schema.stato-tipo-domanda": "Stato Tipo Domanda",
      "extended-filters-schema.tipo-domanda": "Tipo Domanda",
      "extended-filters-schema.titolo-tipo-domanda": "Titolo Tipo Domanda",
      "extended-filters-schema.valori-ricerca-estesa": "Valori Ricerca Estesa",
      "folder.data": "Data",
      "folder.data-documento": "Data Documento",
      "folder.descrizione": "Descrizione",
      "folder.nome": "Nome",
      "folder.protocollo": "Protocollo",
      "folder.tipo": "Tipo",
      "form.alert-message.summary.content": "Sono presenti errori nella Verifica Formale dell'invio Richiesta ({{errors_count}})",
      "form.disable-submit-tooltip": "L'invio è abilitato solo per il titolare o il procuratore.",
      "form.errore-durante-invio": "Si è verificato un errore durante l'invio",
      "form.errore-durante-validazione": "Si è verificato un errore durante la validazione",
      "form.form-cannot-send-as-delegate-tooltip": "Non puoi inviare questa richiesta in quanto la delega non permette l'invio",
      "form.form-not-completed-tooltip": "Compilazione incompleta",
      "form.form-not-payed-tooltip": "Pagamenti mancanti",
      "form.invia-la-domanda": "Invia la domanda",
      "form.invio-con-violazioni-avviso-annulla": "Annulla",
      "form.invio-con-violazioni-avviso-ok": "Invia comunque",
      "form.invio-con-violazioni-avviso-titolo": "Attenzione",
      "form.invio-effettuato-con-successo": "Invio effettuato con successo",
      "form.valida-istanza": "Valida Istanza",
      "form.validazione-agid-errore-titolo": "Errori di validazione",
      "form.validazione-card-descrizione": "Fare click sul pulsante dedicato per avviare la validazione formale dell'istanza.",
      "form.validazione-card-titolo": "Procedura di Verifica Formale dell'Istanza della Richiesta",
      "form.validazione-errore-sconosciuto": "Errore sconosciuto",
      "form.validazione-successo-titolo": "Validazione Istanza completata con successo",
      "frontoffice.menu.profile.label": "Profilo",
      "frontoffice.menu.profile.title": "Accedi al Profilo",
      "frontoffice.menu.settings.label": "Impostazioni",
      "frontoffice.menu.settings.title": "Accedi alle Impostazioni",
      "handle-modules-delegation-submit.id-richiesta-non-valido": "ID richiesta non valido. Riprovare.",
      "inquiry-cover.errore-caricamento-copertina-domanda": "Impossibile caricare la copertina della domanda",
      "inquiry-cover.titolo-non-presente": "Titolo non presente",
      "inquiry.ambito": "Ambito",
      "inquiry.area-filter": "Amministrazione",
      "inquiry.categorie": "Categorie",
      "inquiry.cerca": "Cerca",
      "inquiry.competenza-territoriale": "Competenza Territoriale",
      "inquiry.destinatari": "Destinatari",
      "inquiry.filtri": "Filtri",
      "inquiry.filtri-di-ricerca": "Filtri di ricerca",
      "inquiry.in-collaudo": "In Collaudo",
      "inquiry.lista.briciole.domanda": "Domanda",
      "inquiry.lista.briciole.domande": "Domande",
      "inquiry.lista.errori.impossibile-caricare-la-sezione": "Impossibile caricare l'elenco delle domande",
      "inquiry.lista.filtri-applicati.domande-mostrate-in-base-ai-filtri-di-ricerca": "domande trovate in base ai filtri di ricerca.",
      "inquiry.lista.vuota.nessuna-domanda-da-mostrare": "Nessuna domanda da mostrare.",
      "inquiry.pubblicata": "Pubblicata",
      "inquiry.solo-attive": "Solo Attive",
      "inquiry.sotto-ambito": "Sotto Ambito",
      "inquiry.stato": "Stato",
      "inquiry.stato.aperta": "Aperta",
      "inquiry.stato.chiusa": "Chiusa",
      "inquiry.stato.in_corso": "In corso",
      "inquiry.stato.pubblicata": "Pubblicata",
      "inquiry.tipo-pubblicazione": "Tipo Pubblicazione",
      "inquiry.tipo-pubblicazione-filtro": "Pubblicazione",
      "inquiry.titolo": "Titolo",
      "inquiry.tutte-le-domande": "Tutte le Domande",
      "inserisci-cf-or-email-delegato": "Inserisci il Codice Fiscale o l'E-Mail per l'utente estero",
      "inserisci-codici-fiscali-o-email-delegati": "Inserisci i Codici Fiscali o le E-Mail per gli utenti esteri",
      "integration-rows.nessuna-richiesta-attiva": "Nessuna richiesta attiva",
      "integration-rows.nessuna-richiesta-precedente": "Nessuna richiesta precedente",
      "integration-rows.richieste-integrate": "Richieste Integrate (elenco richieste precedenti)",
      "integration-rows.ultima-integrazione-della-richiesta": "Ultima integrazione della richiesta",
      "integration.data-creazione": "Data Creazione:",
      "integration.data-invio": "Data Invio:",
      "integration.stato": "Stato:",
      "integration.vai-alla-richiesta": "Vai alla richiesta",
      "integration.vai-alla-richiesta-originale": "Vai alla richiesta originale",
      "integration.vai-elenco-integrazioni": "Vai all'elenco delle integrazioni",
      "layout.footer.vai-all-inizio-pagina": "Vai all’inizio della pagina",
      "layout.header.menu-di.scelta-lingua": "Menu di scelta lingua",
      "layout.header.pulsante-notifiche_one": "{{count}} notifica da leggere",
      "layout.header.pulsante-notifiche_many": "{{count}} notifiche da leggere",
      "layout.header.pulsante-notifiche_other": "{{count}} notifiche da leggere",
      "layout.skip-links.vai-al-contenuto-principale": "Vai al contenuto principale",
      "layout.skip-links.vai-al-footer": "Vai al footer",
      "layout.skip-links.vai-al-menu-principale": "Vai al menu principale",
      "login-button.accedi": "Accedi",
      "main-menu.mobile.aria-label": "Menu Principale",
      "main-menu.mobile.loading.aria-label": "Caricamento",
      "menu.le-mie-pratiche": "Le mie Pratiche",
      "menu.le-mie-pratiche.sr-title": "Vai a Le mie Pratiche",
      "menu.le-mie-richieste": "Le mie Richieste",
      "menu.le-mie-richieste.sr-title": "Vai a Le mie Richieste",
      "menu.notifiche": "Notifiche",
      "menu.notifiche.sr-title": "Vai a Notifiche",
      "menu.principal-menu": "Menu Principale",
      "menu.tutte-le-domande": "Tutte le Domande",
      "menu.tutte-le-domande.sr-title": "Vai a Tutte le Domande",
      "modifica-tutti": "Modifica tutti",
      "module-listname.da-firmare": "Da firmare",
      "modules-delegations.view.abilita-deleghe": "Abilita deleghe",
      "modules-previous-delegations-summary.delegati-precedenti": "Delegati precedenti:",
      "notification-drawer.button.badge": "Notifiche da leggere",
      "notification-list.pagina.titolo": "Elenco Notifiche",
      "notifiche-titolo-colonna.azioni": "Azioni",
      "notifiche-titolo-colonna.numero-istanza": "Numero Istanza",
      "observation-details.allegato-del-procedimento": "Allegato del Procedimento",
      "observation-details.allegato-della-richiesta": "Allegato della Richiesta",
      "observation-details.altri-titolari": "Altri Titolari",
      "observation-details.apri-cartella": "Apri cartella {{recordName}}",
      "observation-details.apri-documento": "Apri Documento {{record}}",
      "observation-details.azioni": "Azioni",
      "observation-details.chiudi-cartella": "Chiudi cartella {{recordName}}",
      "observation-details.comunicazione": "Comunicazione",
      "observation-details.dati-della-richiesta": "Dati della Richiesta",
      "observation-details.documenti": "Documenti",
      "observation-details.documento": "Documento",
      "observation-details.domanda": "Domanda",
      "observation-details.numero-istanza": "Numero Istanza",
      "observation-details.titolare": "Titolare",
      "observation.area-pubblica": "Area Pubblica",
      "observation.Cognome-titolare": "Cognome Titolare",
      "observation.data-invio": "Data invio",
      "observation.data-protocollo": "Data Protocollo",
      "observation.dati-del-procedimento": "Dati del Procedimento",
      "observation.domanda": "Domanda",
      "observation.domande-trovate-in-base-ai-filtri-di-ricerca": "domande trovate in base ai filtri di ricerca.",
      "observation.errore-durante-il-caricamento": "Si è verificato un errore durante il caricamento.",
      "observation.fine-osservazione": "Fine Osservazione",
      "observation.impossibile-caricare-elenco-area-pubblica": "Impossibile caricare l'elenco dell'Area Pubblica",
      "observation.inizio-osservazione": "Inizio Osservazione",
      "observation.numero-istanza": "Numero Istanza",
      "observation.numero-istanza-suffix": "Numero Istanza:",
      "observation.numero-procedimento": "Numero Procedimento",
      "observation.numero-procedimento-suffix": "Numero Procedimento:",
      "observation.numero-protocollo": "Numero Protocollo",
      "observation.nuova-osservazione": "Nuova Osservazione",
      "observation.oggetto": "Oggetto",
      "observation.oggetto-procedimento": "Oggetto Procedimento",
      "observation.osservabile": "Osservabile",
      "observation.periodo-osservazione": "Periodo osservazione",
      "observation.procedimento": "Procedimento",
      "observation.record-albo-trovati-in-base-ai-filtri-di-ricerca": "record trovati in base ai filtri di ricerca.",
      "observation.rimuovi-filtri": "Rimuovi filtri",
      "observation.stato": "Stato",
      "observation.titolare": "Titolare",
      "observation.titolo-domanda": "Titolo Domanda",
      "observation.ufficio-responsabile": "Ufficio Responsabile",
      "possibile-modificare-tutti-i-moduli-con-un-nuovo-delegato": "È possibile modificare tutti i moduli con un nuovo delegato",
      "pratica.dettaglio.domande-presentabili": "Domande presentabili",
      "pratica.dettaglio.richieste-presentate": "Richieste presentate",
      "pratiche.avvio-domande-secondarie.error-no-id": "Errore durante l'avvio della domanda. Riprovare",
      "pratiche.avvio-domande-secondarie.error-no-params": "Errore durante l'avvio della domanda. Parametri mancanti",
      "pratiche.avvio-domande-secondarie.success": "Domanda avviata con successo",
      "pratiche.dati": "Dati",
      "pratiche.dettaglio": "Dettaglio pratica",
      "pratiche.domanda-secondaria.tooltip-errore-avvio-end": "Domanda avviabile fino al {{endDate}}",
      "pratiche.domanda-secondaria.tooltip-errore-avvio-full": "Domanda avviabile dal {{startDate}} al {{endDate}}",
      "pratiche.domanda-secondaria.tooltip-errore-avvio-start": "Domanda avviabile dal {{startDate}}",
      "pratiche.domande.avvia-domanda-secondaria": "Vai alla Domanda",
      "pratiche.errore.network": "Errore durante il caricamento della pratica",
      "pratiche.errore.no-id": "Nessun ID trovato nella richiesta.",
      "pratiche.info": "Informazioni",
      "pratiche.permissions": "Permessi e Visibilità",
      "pratiche.pratiche": "Pratiche",
      "pratiche.submissions": "Richieste",
      "progressive-number-filter.anno": "Anno",
      "progressive-number-filter.numero-istanza": "Numero istanza",
      "register-records.menu": "Elenchi",
      "remove-submission-attorney-button.errore": "Si è verificato un errore. Riprovare.",
      "remove-submission-attorney-button.procuratore-rimosso-con-successo": "Procuratore rimosso con successo",
      "remove-submission-attorney-button.rimuovere-attuale-procuratore": "Rimuovere l'attuale procuratore?",
      "remove-submission-attorney-button.rimuovi-procuratore": "Rimuovi Procuratore",
      "richieste.firma.messaggio-errore-caricamento-file": "Errore durante il caricamento del file, riprovare",
      "richieste.firma.messaggio-successo-caricamento-file": "Il modulo firmato è stato caricato correttamente.",
      "richieste.firma.procedura-firma-modulo": "Procedura di Firma Modulo",
      "richieste.firma.scaricare-il-modulo-per-procedere-alla-firma": "Scaricare il modulo <title/>, procedere alla firma digitale e ricaricare il modulo firmato.",
      "scanner-qr.camera-error": "Si è verificato un errore durante l'accesso alla camera: {{error}}",
      "scanner-qr.permission-denied": "verificare di avere i permessi o che il dispositivo abbia una camera funzionante",
      "selected-modules-text.moduli-selezionati": "{{selectedRows}} moduli selezionati",
      "selected-modules-text.un-modulo-selezionato": "1 modulo selezionato",
      "signed-module.documento-modulo-firmato": "Documento Modulo Firmato",
      "signed-module.errore-in-download-file": "Si è verificato un problema durante il download del file. Riprovare.",
      "signed-module.file-non-trovato": "File non trovato",
      "submission-action-button.carica-documento-firmato-per-continuare": "Carica un documento firmato per continuare",
      "submission-action-button.compilazione-terminata": "Compilazione terminata",
      "submission-action-button.conferma-firma": " Conferma Firma",
      "submission-action-button.errore": "Si è verificato un errore: riprovare",
      "submission-action-button.firma-delegata": "La firma è delegata ad un altro utente.",
      "submission-action-button.in-attesa-compilazione-delegato": "In attesa della compilazione da parte del delegato.",
      "submission-action-button.modulo-compilato": "Il modulo è stato compilato.",
      "submission-action-button.modulo-compilato-e-firmato": "Il modulo è stato compilato e firmato. Riportando il modulo in compilazione, sarà necessario firmarlo nuovamente.",
      "submission-action-button.modulo-compilato-e-firmato-precedentemente": "Il modulo è già stato compilato e firmato.",
      "submission-action-button.modulo-compilato-precedentemente": "Il modulo è già stato compilato.",
      "submission-action-button.modulo-compilato-ritornare-in-compilazione-per-modificare": "Il modulo è stato compilato, puoi ritornare in compilazione se sono necessarie modifiche.",
      "submission-action-button.modulo-completato": "Modulo completato",
      "submission-action-button.modulo-non-valido": "Il modulo non è valido",
      "submission-action-button.modulo-nuovamente-compilabile": "Modulo nuovamente compilabile",
      "submission-action-button.modulo-pronto-per-la-firma": "Modulo pronto per la firma",
      "submission-action-button.per-procedere-alla-firma-segnare-come-pronto": "Per procedere alla firma segnare il modulo come Pronto per la firma.",
      "submission-action-button.pronto-per-la-firma": "Pronto per la firma",
      "submission-action-button.ritorna-in-compilazione": "Ritorna in compilazione",
      "submission-action-button.salva-modulo": "Salva il modulo per continuare",
      "submission-action-button.se-completato-il-modulo-premi-compilazione-terminata": "Se hai completato il modulo, premi il pulsante Compilazione terminata.",
      "submission-clone-button.chiudi": "Chiudi",
      "submission-clone-button.duplica": "Duplica",
      "submission-clone-button.duplica-richiesta": "Duplica la Richiesta",
      "submission-clone-button.errore-durante-la-duplicazione-della-richiesta": "Si è verificato un errore durante la duplicazione della richiesta.",
      "submission-clone-button.errore-nel-duplicare-la-richiesta": "Errore nel duplicare la richiesta",
      "submission-clone-button.la-richiesta-deve-essere-salvata-per-duplicare": "La richiesta deve essere salvata per poter essere duplicata.",
      "submission-clone-button.la-richiesta-verra-duplicata-senza-i-file-allegati": "La richiesta verrà duplicata senza i file allegati.",
      "submission-clone-button.richiesta-duplicata-con-successo": "Richiesta duplicata con successo.",
      "submission-clone-button.sei-sicuro-di-voler-duplicare-la-richiesta": "Sei sicuro di voler duplicare la richiesta?",
      "submission-columns.data-creazione": "Data creazione",
      "submission-columns.data-invio": "Data invio",
      "submission-columns.data-modifica": "Data modifica",
      "submission-columns.domanda": "Domanda",
      "submission-columns.fase": "Fase",
      "submission-columns.numero-istanza": "Numero Istanza",
      "submission-columns.numero-protocollo": "Numero Protocollo",
      "submission-columns.oggetto": "Oggetto",
      "submission-columns.richiedente": "Richiedente",
      "submission-columns.stato": "Stato",
      "submission-columns.titolare": "Titolare",
      "submission-columns.ufficio-responsabile": "Ufficio responsabile",
      "submission-delegation-drawer.abilita-compilazione-della-richiesta": "Abilita alla compilazione della richiesta",
      "submission-delegation-drawer.abilita-firma-della-richiesta": "Abilita alla firma della richiesta",
      "submission-delegation-drawer.abilita-invio-della-richiesta": "Abilita invio della richiesta",
      "submission-delegation-drawer.annulla": "Annulla",
      "submission-delegation-drawer.carica-documento-di-delega": "Carica Documento di Delega",
      "submission-delegation-drawer.codice-fiscale-partita-iva": "Codice Fiscale/Partita IVA",
      "submission-delegation-drawer.delega-inviata-con-successo": "Delega inviata con successo",
      "submission-delegation-drawer.delega-richiesta": "Delega Richiesta",
      "submission-delegation-drawer.documento-di-delega": "Documento di Delega",
      "submission-delete-delegation-button.codice-fiscale-delegato": "Delegato: {{delegateFiscalCode}}",
      "submission-delete-delegation-button.delega-rimossa-con-successo": "Delega rimossa con successo",
      "submission-delete-delegation-button.rimuovi-delega": "Rimuovi delega",
      "submission-delete-delegation-button.sicuro-di-voler-rimuovere-delega": "Sei sicuro di voler rimuovere questa delega?",
      "submission-details.comunicazioni": "Comunicazioni",
      "submission-details.integrazioni": "Integrazioni",
      "submission-details.la-mia-richiesta": "La mia richiesta",
      "submission-details.pagamenti": "Pagamenti",
      "submission-details.ricevuta-invio": "Ricevuta invio",
      "submission-filter-form-mobile.codice-fiscale-titolare": "Codice Fiscale Titolare",
      "submission-filter-form-mobile.cognome-titolare": "Cognome Titolare",
      "submission-filter-form-mobile.nome-titolare": "Nome Titolare",
      "submission-filter.categorie": "Categorie",
      "submission-filter.codice-fiscale-titolare": "Codice Fiscale Titolare",
      "submission-filter.cognome-titolare": "Cognome Titolare",
      "submission-filter.nome-titolare": "Nome Titolare",
      "submission-filter.ricerca-estesa": "Ricerca Estesa",
      "submission-filter.seleziona-le-categorie": "Seleziona le categorie",
      "submission-filter.stato-delega": "Stato Delega",
      "submission-form.compilazione-richiesta-incompleta": "Compilazione richiesta incompleta",
      "submission-form.errore-in-caricamento-domanda": "Si è verificato un errore durante il caricamento della domanda.",
      "submission-form.errore-in-caricamento-richiesta": "Si è verificato un errore durante il caricamento della richiesta.",
      "submission-form.errore-moduli-incompleti-per-poter-procedere": "Alcuni moduli risultano incompleti o presentano errori. È necessario compilare tutti i moduli per procedere all'invio della richiesta.",
      "submission-form.errore-oneri-non-pagati-per-poter-procedere": "Alcuni oneri risultano non pagati. È necessario pagare tutti gli oneri obbligatori per procedere all'invio della richiesta.",
      "submission-form.id-della-richiesta-non-valido": "ID della richiesta non valido",
      "submission-form.integrazione-di-un-altra-richiesta": "Questa è un'integrazione di un'altra richiesta.",
      "submission-form.inviare-per-procedere-al-pagamento": "Procedere all'invio della Richiesta per effettuare il pagamento degli oneri.",
      "submission-form.invio-in-corso": "Invio in corso...",
      "submission-form.stato-pagamenti-incompleto": "Stato pagamenti incompleto",
      "submission-integration-button.avvia": "Avvia",
      "submission-integration-button.integra-la-richiesta": "Integra la Richiesta",
      "submission-integration-button.sicuro-avviare-integrazione": "Sicuro di voler avviare l'integrazione?",
      "submission-linked-button.visualizza-richiesta": "Visualizza richiesta",
      "submission-list.annulla-richiesta": "Annulla la Richiesta",
      "submission-list.apri-pagina-compilazione-richiesta": "Apri la pagina di compilazione della richiesta",
      "submission-list.apri-pagina-dettaglio-richiesta": "Apri la pagina di dettaglio della richiesta",
      "submission-list.compilazione-richiesta": "Compila richiesta",
      "submission-list.domande-trovate-in-base-ai-filtri": "domande trovate in base ai filtri di ricerca.",
      "submission-list.duplica-richiesta": "Duplica richiesta",
      "submission-list.errore-eliminazione-richiesta": "Errore durante l'eliminazione della richiesta",
      "submission-list.impossibile-caricare-elenco-richieste": "Impossibile caricare l'elenco delle Richieste",
      "submission-list.richiesta-eliminata-con-successo": "Richiesta eliminata con successo",
      "submission-list.richieste": "Richieste",
      "submission-list.rimuovi-filtri": "Rimuovi filtri",
      "submission-list.submissions-list-title": "Elenco Richieste",
      "submission-list.visualizza-richiesta": "Visualizza richiesta",
      "submission-module.il-gestore": "il Gestore",
      "submission-module.il-procuratore": "il Procuratore",
      "submission-module.il-titolare": "il Titolare",
      "submission-module.modulo-completato": "Il modulo è completato.",
      "submission-module.modulo-disponibile-alla-firma-al-termine-della-compilazione": "Il modulo sarà disponibile per la firma al termine della compilazione.",
      "submission-module.necessario-compilare-il-modulo": "È necessario compilare il modulo.",
      "submission-module.necessario-firmare-il-modulo": "È necessario firmare il modulo.",
      "submission-module.permesso-utente-modulo": "Hai il permesso per <permissionsText/> questo\n          Modulo.",
      "submission-module.ruolo-utente-della-richiesta": "Sei <roleText/> della Richiesta.",
      "submission-module.stai-visualizzando-in-sola-lettura-il-modulo": "Stai visualizzando in sola lettura questo modulo.",
      "submission-module.un-delegato": "un Delegato",
      "submission-payment.annulla-pagamenti-e-ritorna-in-bozza": "Annulla pagamenti e ritorna in bozza",
      "submission-payment.conferma-a-procedere": "Si è sicuri di voler procedere?",
      "submission-payment.in-payment-banner-action": "Riporta in bozza",
      "submission-payment.in-payment-banner-title": "La tua richiesta è in pagamento. Una volta pagati i bolli è possibile inviarla, altrimenti è possibile riportarla in bozza per apportare modifiche.",
      "submission-payment.in-payment-banner-title-no-cancel": "La tua richiesta è in pagamento. Una volta pagati i bolli è possibile inviarla.",
      "submission-payment.rieffettuare-il-pagamento-a-seguito-di-riportare-in-bozza": "Riportando la richiesta in bozza, tutti <bold>i bolli pagati verranno invalidati</bold> e sarà necessario effettuare di nuovo il pagamento.",
      "submission-searchable-fields.anno-istanza": "Anno Istanza",
      "submission-searchable-fields.annullamento-in-corso": "Annullamento in corso",
      "submission-searchable-fields.annullata": "Annullata",
      "submission-searchable-fields.bozza": "Bozza",
      "submission-searchable-fields.categoria": "Categoria",
      "submission-searchable-fields.codice-fiscale-titolare": "Codice Fiscale Titolare",
      "submission-searchable-fields.cognome-titolare": "Cognome Titolare",
      "submission-searchable-fields.conclusa": "Conclusa",
      "submission-searchable-fields.data-avvio-compilazione-al": "Data avvio compilazione al",
      "submission-searchable-fields.data-avvio-compilazione-dal": "Data avvio compilazione dal",
      "submission-searchable-fields.data-creazione": "Data creazione",
      "submission-searchable-fields.data-invio": "Data invio",
      "submission-searchable-fields.data-invio-al": "Data invio al",
      "submission-searchable-fields.data-invio-dal": "Data invio dal",
      "submission-searchable-fields.integrata": "Integrata",
      "submission-searchable-fields.inviata": "Inviata",
      "submission-searchable-fields.nome-titolare": "Nome Titolare",
      "submission-searchable-fields.numero-istanza": "Numero Istanza",
      "submission-searchable-fields.oggetto": "Oggetto",
      "submission-searchable-fields.ricerca-estesa": "Ricerca Estesa",
      "submission-searchable-fields.ricevuta": "Ricevuta",
      "submission-searchable-fields.seleziona-le-categorie": "Seleziona le categorie",
      "submission-searchable-fields.soggetto-richiesta-nome-placeholder": "Impresa...",
      "submission-searchable-fields.stato-delega": "Stato Delega",
      "submission-searchable-fields.stato-richiesta": "Stato Richiesta",
      "submission-searchable-fields.titolare-codice-fiscale-impresa": "Titolare Impresa: Codice Fiscale",
      "submission-searchable-fields.titolare-codice-fiscale-impresa-placeholder": "Codice fiscale...",
      "submission-searchable-fields.titolare-codice-rea-impresa": "Titolare Impresa: Codice REA",
      "submission-searchable-fields.titolare-codice-rea-impresa-placeholder": "Codice REA...",
      "submission-searchable-fields.titolare-denominazione-impresa": "Titolare Impresa: Denominazione",
      "submission-searchable-fields.titolare-partita-iva-impresa": "Titolare Impresa: Partita IVA",
      "submission-searchable-fields.titolare-partita-iva-impresa-placeholder": "Partita IVA...",
      "submission-searchable-fields.titolo-tipo-domanda": "Titolo Tipo Domanda",
      "submission-sent-form.annullamento-in-corso": "È in corso l'annullamento della richiesta. Le operazioni di modifica, integrazione, delega e invio comunicazioni sono sospese fino alla conclusione.",
      "submission-sent-form.apri-integrazione-in-bozza": "Apri Integrazione in Bozza",
      "submission-sent-form.errore-in-caricamento-domanda": "Si è verificato un errore durante il caricamento della domanda.",
      "submission-sent-form.errore-in-caricamento-richiesta": "Si è verificato un errore durante il caricamento della richiesta.",
      "submission-sent-form.errore-in-integrazione-richiesta": "Si è verificato un errore durante l'integrazione della richiesta, si prega di riprovare.",
      "submission-sent-form.id-della-richiesta-non-valido": "ID della richiesta non valido",
      "submission-sent-form.integrazione-creata-con-successo": "Integrazione creata con successo",
      "submission-sent-form.integrazione-di-un-altra-richiesta": "Questa è un'integrazione di un'altra richiesta.",
      "submission-sent-form.integrazione-in-bozza": "È presente una bozza di integrazione per questa richiesta.",
      "submission-sent-form.integrazione-non-consentita-annullamento": "Operazione non consentita: è in corso l'annullamento della richiesta.",
      "submission-sent-form.procedimento": "Procedimento:",
      "submission-sent-form.richiesta-integrata": "Questa richiesta è stata integrata.",
      "submission-sent-form.richieste": "Richieste",
      "submission-sent-tab-communications.comunicazione-creata-con-successo": "Comunicazione creata con successo",
      "submission-sent-tab-communications.comunicazione-eliminata-con-successo": "Comunicazione eliminata con successo",
      "submission-sent-tab-communications.comunicazione-modificata-con-successo": "Comunicazione modificata con successo",
      "submission-sent-tab-communications.comunicazioni-trovate-in-base-ai-filtri": "comunicazioni trovate in base ai filtri di ricerca.",
      "submission-sent-tab-communications.errore-caricamento-allegato": "Impossibile caricare l'allegato",
      "submission-sent-tab-communications.errore-caricamento-comunicazioni": "Impossibile caricare le comunicazioni",
      "submission-sent-tab-communications.errore-creazione-comunicazione": "Impossibile creare la comunicazione",
      "submission-sent-tab-communications.errore-eliminazione-comunicazione": "Impossibile eliminare la comunicaizone",
      "submission-sent-tab-communications.errore-invio-no-id": "Errore durante l'invio: Nessun ID trovato per la richiesta.",
      "submission-sent-tab-communications.errore-modifica-comunicazione": "Impossibile modificare la comunicazione",
      "submission-sent-tab-communications.errore-segna-letta": "Impossibile segnare la comunicazione come letta",
      "submission-sent-tab-communications.errore-segna-letta-no-id": "Errore durante la presa lettura: Nessun ID trovato per la richiesta.",
      "submission-sent-tab-communications.errore-tab-comunicazioni": "Si è verificato un errore",
      "submission-sent-tab-communications.no-submission-id-error-message": "Errore durante il salvataggio: Nessun ID trovato per la richiesta.",
      "submission-sent-tab-communications.nuova-comunicazione": "Nuova Comunicazione",
      "submission-sent-tab-communications.rimuovi-filtri": "Rimuovi filtri",
      "submission-summary.riepilogo-richiesta": "Riepilogo della Richiesta",
      "submission-undo-button.annulla": "Annulla",
      "submission-undo-button.annulla-la-richiesta": "Annulla la Richiesta",
      "submission-undo-button.annullamento-inoltrato": "Richiesta di annullamento inoltrata. La richiesta resterà sospesa fino alla conferma dell'annullamento.",
      "submission-undo-button.chiudi": "Chiudi",
      "submission-undo-button.conferma-annullamento": "Sei sicuro di voler annullare la richiesta?",
      "submission-undo-button.errore-annullamento": "Errore nell'annullamento della richiesta",
      "submission-undo-button.richiesta-annullata": "Richiesta annullata con successo",
      "submission-undo-button.richiesta-non-annullabile": "La richiesta non è annullabile: il procedimento è concluso o è già in corso un annullamento.",
      "submission.codice-richiesta": "Codice richiesta:",
      "submission.data-invio": "Data invio:",
      "submission.data-protocollo": "Data protocollo:",
      "submission.delegation-banner.stai-commpilando-in-delega-la-richiesta": "Stai compilando in delega questa richiesta.",
      "submission.delegation-button": "Delega la Richiesta",
      "submission.documento-firmato": "Documento Firmato",
      "submission.fase-procedimento": "Fase del procedimento:",
      "submission.info.aria.titolare-e-procuratore": "Titolare e procuratore",
      "submission.info.titolare-e-procuratore": "Titolare e procuratore",
      "submission.numero-istanza": "Numero istanza:",
      "submission.numero-procedimento": "Numero procedimento:",
      "submission.numero-protocollo": "Numero protocollo:",
      "submission.oggetto-richiesta": "Oggetto:",
      "submission.procuratore": "Procuratore",
      "submission.responsabile-procedimento": "Responsabile procedimento:",
      "submission.richiesta-inviata-con-successo": "Richiesta inviata con successo!",
      "submission.richiesta-inviata-correttamente-da-prendere-in-carico": "La richiesta è stata inviata correttamente e sarà presa in carico a breve.",
      "submission.salva-modulo-per-caricare-file-firmato": "Salva il modulo per caricare il file firmato",
      "submission.seleziona-file-firmato": "Seleziona file firmato...",
      "submission.stato-richiesta": "Stato richiesta:",
      "submission.titolare": "Titolare",
      "submission.ufficio-responsabile-procedimento": "Ufficio responsabile:",
      "submission.vai-ai-pagamenti": "Vai alla sezione \"Pagamenti\" per visualizzare e gestire il preventivo",
      "tag-options.delegato": "Delegato",
      "tag-options.gestore": "Gestore",
      "tag-options.procuratore": "Procuratore",
      "tag-options.titolare": "Titolare",
      "tag-options.utente": "Utente",
      "ui.cerca": "Cerca",
      "ui.filtri-di-ricerca": "Filtri di ricerca",
      "ui.nessun-filtro-modificato": "Nessun filtro modificato",
      "ui.rimuovi-filtri": "Rimuovi Filtri",
      "update-delegation-data-schema.abilita-delega": "Abilita delega",
      "update-delegation-data-schema.conferma-modifica": "Conferma Modifica",
      "update-delegation-data-schema.delegato": "Delegato",
      "user-profile-nationality.EU": "Paesi eIDAS",
      "user-profile-nationality.extra-EU": "Altri Paesi",
      "user-profile-nationality.italy": "Italiana",
      "user-registration-form.divider-title": "Dati anagrafici",
      "user-registration-form.email": "Email",
      "user-registration-form.nationality": "Nazionalità",
      "user-registration-form.nationaly-eidas-help": "È possibile consultare <2>l'elenco dei paesi che supportano il Login eIDAS per l'Italia</2>.",
      "user-registration-form.password": "Password",
      "user-registration-form.password-confirm": "Conferma Password",
      "user-registration-form.profile.familyName": "Cognome",
      "user-registration-form.profile.name": "Nome",
      "user-registration-form.top-title": "Dati di accesso",
      "user-registration.back-to-login": "Ritorna al login",
      "user-registration.country.unkown": "Sconosciuto",
      "user-registration.form.submit-button": "Registrati",
      "user-registration.ue-citizen-message": "Sei un cittadino UE o italiano? Effettua il login con SPID o CIE.",
      "user.activation.breadcrumb": "Attivazione Utente",
      "user.activation.error.id": "Id attivazione non valido",
      "user.activation.error.token": "Token non valido",
      "user.activation.response.error.back-button": "Torna al Login",
      "user.activation.response.error.sub-title": "Non è stato possibile verificare l'email.",
      "user.activation.response.error.title": "Errore nella verifica dell'email",
      "user.activation.response.success.sub-title": "Effettua l'accesso con email e password inserite nel modulo di registrazione.",
      "user.activation.response.success.submit-button": "Vai al Login",
      "user.activation.response.success.title": "Registrazione completata!",
      "user.activation.submit-button": "Attiva Utente",
      "user.activation.text": "Premi sul pulsante di seguito per completare la verifica della tua E-Mail.",
      "user.activation.title": "Verifica E-Mail",
      "user.change-password": "Cambia Password",
      "user.conferma-password": "Conferma Password",
      "user.current-password": "Password Attuale",
      "user.errore-in-verifica-mail": "Errore nella verifica dell'email",
      "user.forgot-password.api-error-generic": "Si è verificato un errore durante il recupero della password. Riprovare",
      "user.forgot-password.breadcrumb": "Reimposta password",
      "user.forgot-password.button-text": "Inviami un'email",
      "user.forgot-password.text": "Inserisci l’email con cui ti sei registrato. Riceverai via email il link per reimpostare la password.",
      "user.forgot-password.title": "Hai dimenticato la password?",
      "user.le-password-non-coincidono": "Le password non coincidono.",
      "user.new-password": "Nuova Password",
      "user.password": "Password",
      "user.password-change.breadcrumb": "Cambia Password",
      "user.password-change.error.message": "Non è stato possibile cambiare la password.",
      "user.password-change.form.password-confirm": "Conferma Password",
      "user.password-change.form.password-repeat": "Ripeti Password",
      "user.password-change.form.submit-button": "Cambia Password",
      "user.password-change.response.error.sub-title": "Non è stato possibile reimpostare la password.",
      "user.password-change.response.error.title": "Errore nel cambio della password",
      "user.password-change.response.success.back-to-inquiry": "Torna alle Domande",
      "user.password-change.response.success.submit-button": "Torna al Profilo",
      "user.password-change.response.success.title": "Password modificata con successo",
      "user.password-change.success": "Password modificata",
      "user.password-change.text": "Inserisci la nuova password per l'utente",
      "user.password-change.title": "Modifica password",
      "user.password-reset-request.response.success.button-login": "Torna al Login",
      "user.password-reset-request.response.success.subtitle": "Controlla la tua casella e-mail. Ti abbiamo inviato un’email con le istruzioni per reimpostare la password.",
      "user.password-reset-request.response.success.title": "Richiesta modifica password inviata",
      "user.password-reset.breadcrumb": "Reimposta Password",
      "user.password-reset.error.id": "Id di verifica non valido",
      "user.password-reset.error.message": "Non è stato possibile reimpostare la password.",
      "user.password-reset.error.token": "Token non valido",
      "user.password-reset.form.password-confirm": "Ripeti Password",
      "user.password-reset.form.submit-button": "Reimposta Password",
      "user.password-reset.response.error.sub-title": "Non è stato possibile reimpostare la password.",
      "user.password-reset.response.error.title": "Errore nel reset della password",
      "user.password-reset.response.success.button-login": "Effettua il Login",
      "user.password-reset.response.success.submit-button": "Torna al Login",
      "user.password-reset.response.success.title": "Password reimpostata correttamente!",
      "user.password-reset.success": "Password reimpostata correttamente!",
      "user.password-reset.text": "Inserisci la nuova password per l'utente",
      "user.password-reset.title": "Reimposta password",
      "user.registration.breadcrumb": "Registrazione Utente",
      "user.registration.email-validation.message": "Ciao <1>{{fullName}}</1>, l’autenticazione è andata a buon fine. Inserisci la tua eMail per completare il profilo e procedere con l’accesso ai servizi online.",
      "user.registration.email-validation.response.success.sub-title-generic": "Per attivare l’utente segui le istruzioni che ti abbiamo inviato via email.",
      "user.registration.email-validation.response.success.title": "Registrazione effettuata con successo!",
      "user.registration.form.submit-button": "Registrati",
      "user.registration.form.top-title": "Dati di accesso",
      "user.registration.response.error.message": "Si è verificato un errore durante la registrazione",
      "user.registration.response.success.sub-title": "Ti abbiamo inviato una mail con le istruzioni per attivare il tuo account. Una volta attivato, potrai effetturare il login sul portale.",
      "user.registration.response.success.submit-button": "Torna alle Domande",
      "user.registration.response.success.title": "Registrazione completata!",
      "user.settings.app-io-channel": "Notifica su App IO",
      "user.settings.app-io-channel-description": "Ricevi un avviso su App IO quando è disponibile una nuova comunicazione",
      "user.settings.breadcrumb": "Impostazioni",
      "user.settings.channels-title": "Canali per le comunicazioni di cortesia",
      "user.settings.email-channel": "Notifica via e-mail",
      "user.settings.email-channel-description": "Ricevi un avviso via e-mail quando è disponibile una nuova comunicazione",
      "user.settings.notification-email": "Indirizzo e-mail",
      "user.settings.notification-email-help": "Indirizzo dedicato alle comunicazioni di cortesia, distinto dalle e-mail indicate nelle pratiche.",
      "user.settings.notification-email-placeholder": "nome@esempio.it",
      "user.settings.save-button": "Salva Impostazioni",
      "user.settings.save-error": "Si è verificato un errore durante il salvataggio delle impostazioni",
      "user.settings.save-success": "Impostazioni salvate con successo",
      "verifica-tesserino.breadcrumb": "Verifica Tesserini",
      "verifica-tesserino.cerca": "Cerca",
      "verifica-tesserino.codice": "Codice:",
      "verifica-tesserino.codice-tesserino-manualmente": "Codice tesserino (inserimento manuale)",
      "verifica-tesserino.data-emissione": "Data Inizio:",
      "verifica-tesserino.data-scadenza": "Data Fine:",
      "verifica-tesserino.description": "Inquadra il QR code del tesserino, oppure inserisci il codice del tesserino nel campo successivo.",
      "verifica-tesserino.numero": "Numero:",
      "verifica-tesserino.nuova-ricerca": "Nuova ricerca",
      "verifica-tesserino.result.error.errore": "Errore:",
      "verifica-tesserino.result.error.errore-caricamento": "Impossibile caricare le informazioni del tesserino",
      "verifica-tesserino.result.stato-tesserino": "{{stato}}",
      "verifica-tesserino.result.tesserino-attivo.description": "Visualizza le informazioni del tesserino nella tabella successiva.",
      "verifica-tesserino.result.tesserino-non-trovato": "Tesserino non trovato!",
      "verifica-tesserino.result.tesserino-non-trovato.description": "Tesserino non trovato nell'elenco dei tesserini attivi.",
      "verifica-tesserino.stato": "Stato:",
      "verifica-tesserino.tipo-tesserino": "Tipo Tesserino:",
      "verifica-tesserino.titolo": "Verifica Tesserini",
      "verifica-tesserino.torna-alla-ricerca": "Torna alla ricerca",
      "verification-labels.click-sul-pulsante-per-completare-l-verifica": "Per completare la verifica fare click sul pulsante",
      "verification-labels.click-sul-pulsante-per-completare-la-verifica": "Per completare la verifica dell'email fare click sul pulsante",
      "verification-labels.verifica": "Verifica",
      "verification-labels.verifica-email": "Verifica Email",
      "verification-page.errore-durante-la-verifica": "Si è verificato un problema durante la verifica",
      "verification-page.errore-in-verifica": "Errore durante la verifica",
      "verification-page.verifica": "Verifica",
      "verification-result-info.errore-in-verifica": "Errore in verifica",
      "verification-result-info.verifica-completata-con-successo": "Verifica completata con successo",
      "verification-result-info.verifica-completata-con-warning": "Verifica completata con warning",
      "collapse.search-collapse-container.header": "Pannello di Ricerca Estesa",
      "main-menu.loading.aria-label": "Caricamento",
      "procedure.empty.title": "Non ci sono dati da visualizzare per questo procedimento",
      "task-card.outcomes.title": "Esiti",
      "task.payment-type.taxable": "Imponibile",
      "task.payment-type.total": "Totale",
      "task.payment-type.vat": "IVA",
      "inquiry-type.save-button.copertina": "Salva Copertina",
      "inquiry-type.save-button.copertina-tooltip": "Salva la copertina della domanda",
      "inquiry-type.save-button.domanda": "Salva Domanda",
      "inquiry-type.save-button.domanda-tooltip": "Salva le modifiche effettuate sulla domanda",
      "inquiry-type.save-button.guida": "Salva Guida",
      "inquiry-type.save-button.guida-tooltip": "Salva la guida alla compilazione",
      "inquiry-type.save-button.moduli": "Salva Moduli",
      "inquiry-type.save-button.moduli-tooltip": "Salva i moduli associati alla domanda",
      "inquiry-type.save-button.modulo": "Salva Modulo",
      "inquiry-type.save-button.modulo-tooltip": "Salva il modulo: le modifiche ricadranno su tutte le domande che lo utilizzano",
      "inquiry-type.save-button.sezione": "Salva Sezione",
      "inquiry-type.save-button.sezione-tooltip": "Salva la sezione: le modifiche ricadranno su tutti i moduli che la utilizzano",
      "procedure.document.editor.classic": "Classic",
      "procedure.document.editor.light": "Light",
      "scope.ambito-modificato-con-successo": "Ambito modificato con successo",
      "scope.errore-in-modifica-ambito": "Si è verificato un errore durante la modifica dell'Ambito",
      "sequenza-progressivo.crea-sequenza": "Crea \"{{nome}}\"",
      "sequenza-progressivo.errore-creazione-sequenza": "Errore durante la creazione della sequenza",
      "sequenza-progressivo.formato-nome-sequenza": "Il nome della sequenza può contenere solo lettere maiuscole, numeri e underscore (max {{max}} caratteri)",
      "sequenza-progressivo.nessuna-sequenza-trovata": "Nessuna sequenza trovata",
      "sequenza-progressivo.sequenza-esistente": "La sequenza \"{{nome}}\" esiste già: selezionala dall'elenco",
      "front-header.logo.admin": "Admin",
      "front-header.logo.backoffice": "Back Office",
      "front-header.logo.domande": "Domande",
      "menu.area-pubblica": "Area Pubblica",
      "menu.area-pubblica.sr-title": "Vai a Area Pubblica",
      "menu.verifica-tesserini": "Verifica Tesserini",
      "menu.verifica-tesserini.sr-title": "Vai a Verifica Tesserini",
      "front-header.logout": "ESCI"
    }
  },
  "en": {
    "translation": {
      "array.max_one": "The field {{path}} must have at most {{count}} element",
      "array.max_other": "The field {{path}} must have at most {{count}} elements",
      "array.min_one": "The field {{path}} must have at least {{count}} element",
      "array.min_other": "The field {{path}} must have at least {{count}} elements",
      "mixed.default": "The field ${path} is not valid",
      "mixed.defined": "The field ${path} is required",
      "mixed.notNull": "The field ${path} cannot be empty",
      "mixed.notOneOf": "The field ${path} must not have any of the following values: ${values}",
      "mixed.oneOf": "The field ${path} must have one of the following values: ${values}",
      "mixed.required": "The field ${path} is required",
      "notType.default": "The field {{path}} is not valid",
      "notType.number": "The field {{path}} must be a number",
      "notType.string": "The field {{path}} must be a string",
      "number.integer": "The field ${path} must be an integer",
      "number.lessThan": "The field ${path} must be less than ${less}",
      "number.max": "The field ${path} must be less than or equal to ${max}",
      "number.min": "The field ${path} must be greater than or equal to ${min}",
      "number.moreThan": "The field ${path} must be greater than ${more}",
      "number.negative": "The field ${path} must be a negative number",
      "number.positive": "The field ${path} must be a positive number",
      "string.email": "The field ${path} must be a valid email",
      "string.length": "The field ${path} must be exactly ${length} characters long",
      "string.lowercase": "The field ${path} must contain only lowercase characters",
      "string.matches": "The field ${path} must match the following pattern: \"${regex}\"",
      "string.max": "The field ${path} must have at most ${max} characters",
      "string.min": "The field ${path} must have at least ${min} characters",
      "string.trim": "The field ${path} must be text without leading or trailing spaces",
      "string.uppercase": "The field ${path} must contain only uppercase characters",
      "string.url": "The field ${path} must be a valid URL",
      "advanced-search.collapse-form-messagge": "results found based on search filters.",
      "advanced-search.filtri": "Filters",
      "advanced-search.remove-filters": "Remove filters",
      "advanced-search.tag-semantici": "Other specialized fields",
      "alert.alert-error-body.message": "An error occurred in your request.",
      "alert.error-result-body.message": "An error occurred in your request.",
      "alert.error-result-body.title": "Network Error",
      "alert.forbidden-body.message": "You do not have permission to view the requested page.",
      "alert.forbidden-body.title": "403 Unauthorized",
      "alert.internal-error-body.subtitle": "An unexpected server error occurred. Please try again or contact support.",
      "alert.internal-error-body.title": "500 Internal Server Error",
      "alert.not-found-body.subtitle": "Page Not Found.",
      "alert.not-found-body.title": "404 Not Found",
      "button.button-delete-confirm.content": "Delete",
      "button.button-delete-confirm.icon-aria": "Delete item",
      "button.button-delete-confirm.ok": "Delete",
      "button.button-delete-confirm.title": "Are you sure you want to delete this item?",
      "button.button-delete-confirm.tooltip": "Delete item",
      "button.confirm-button.cancel": "Cancel",
      "button.confirm-button.confirm": "Confirm",
      "button.confirm-button.title": "Are you sure you want to continue with the operation?",
      "button.content-hover-add": "Add",
      "button.content-hover-config": "Configure",
      "button.content-hover-delete": "Delete",
      "button.content-hover-edit": "Edit",
      "button.content-hover-edit-info-aria-label": "Additional information",
      "button.content-hover-edit-info-dinamico": "This form is activated based on the completion of another form, in the configured order. It may not appear during Application submission.",
      "button.content-hover-edit-info-dinamico-title": "Dynamically activated form",
      "button.content-hover-edit-info-principale": "It is always required and is presented first during submission.",
      "button.content-hover-edit-info-principale-title": "Main form of the Application",
      "button.content-hover-edit-info-secondario": "It is presented after the main one, in the configured order.",
      "button.content-hover-edit-info-secondario-title": "Secondary form",
      "card.network-responsive-card.error": "Error",
      "collapse.collapsible-area.hidden-header": "Collapsible Area",
      "collapse.desktop-filter-panel.title": "Extended search filters",
      "collapse.filter-button.content": "Extended Search",
      "collapse.filter-button.tooltip": "Active search filters",
      "collapse.filter-button.tooltip-aria": "Active search filters",
      "collapse.filtri-di-ricerca": "Search Filters",
      "collapse.ghost-collapse.header": "Ghost Extend Collapse",
      "column-picker.add-extra-column-button.label": "Other specialized fields",
      "column-picker.boxed-switch-text": "BOXED",
      "column-picker.config-drawer-tooltip": "Change table width",
      "column-picker.drawer-title": "Column Configuration",
      "column-picker.full-switch-text": "FULL",
      "column-picker.remove-extra-column-button.aria-label": "Remove",
      "column-picker.remove-extra-column-button.tooltip": "Remove specialized field",
      "column-picker.show-in-expanded-row.tooltip": "Show in expanded row",
      "column-picker.switch-show-column.sr-only-text": "Field Visibility",
      "common.paginazione.aria-label": "Pagination",
      "common.paginazione.precedente": "Go to previous page",
      "common.paginazione.successiva": "Go to next page",
      "countdown-humanized.days": "days",
      "countdown-humanized.label": "Time remaining",
      "countdown-humanized.more-months": "More than two months",
      "countdown-humanized.more-years": "More than a year",
      "drawer.close-aria": "Close Panel",
      "dropdown.risultati-per-ricerca": "Results for \"{{search}}\"",
      "dropdown.search-dropdown.no-reseults": "No results found",
      "dropdown.search-dropdown.search": "Write to start searching",
      "filter-bar.add-filter-button": "Search Filters",
      "filter-bar.add-filter-chip": "Filter",
      "filter-bar.apply": "Apply",
      "filter-bar.back": "Back",
      "filter-bar.cancel": "Cancel",
      "filter-bar.clear": "Clear",
      "filter-bar.field-type.custom": "list",
      "filter-bar.field-type.date": "date",
      "filter-bar.field-type.date-range": "date range",
      "filter-bar.field-type.number": "number",
      "filter-bar.field-type.number-range": "number range",
      "filter-bar.field-type.radio": "list",
      "filter-bar.field-type.select": "list",
      "filter-bar.field-type.switch": "boolean",
      "filter-bar.field-type.text": "text",
      "filter-bar.filtered-results-message": "items found based on search filters.",
      "filter-bar.no": "No",
      "filter-bar.no-field-found": "No field found",
      "filter-bar.range-from": "From {{value}}",
      "filter-bar.range-from-num": "From {{value}}",
      "filter-bar.range-to": "To {{value}}",
      "filter-bar.range-to-num": "To {{value}}",
      "filter-bar.read-only-value": "—",
      "filter-bar.refresh": "Refresh",
      "filter-bar.remove-all": "Remove all",
      "filter-bar.remove-filter-aria": "Remove filter {{label}}",
      "filter-bar.search-field-placeholder": "Search field…",
      "filter-bar.selected-count_one": "{{count}} selected",
      "filter-bar.selected-count_other": "{{count}} selected",
      "filter-bar.sort.aria": "Sort by {{field}}, {{direction}}. Press to edit.",
      "filter-bar.sort.aria-empty": "Sort. Press to choose.",
      "filter-bar.sort.direction-label": "Sort direction",
      "filter-bar.sort.field-label": "Sort field",
      "filter-bar.sort.field-placeholder": "Select a field…",
      "filter-bar.sort.label": "Sort by:",
      "filter-bar.yes": "Yes",
      "layout.page-layout-base.top-bar-aria": "Go to page top",
      "layout.version-info.app": "Application {{version}}",
      "layout.version-info.frontend": "Frontend {{version}}",
      "loader.loader-spin.icon-aria": "Delete item",
      "message-filtered-list.invisible.sr-default-message": "No filters applied",
      "moddal.modal-confirm.delete": "Delete",
      "route-announcer.nav-to-page": "Navigated to {{title}}",
      "router.breadcrumbs.home-aria": "Home",
      "search.advanced-search.filter-add.label": "Add Filter",
      "search.advanced-search.filter-add.select-placeholder": "Add Filter",
      "search.component.advanced-search-field.date.placeholder-fallback": "DD/MM/YYYY",
      "search.component.order-row.remove-order-button.aria-label": "Change Sorting",
      "search.component.order-row.remove-order-button.tooltips": "Click to change Sorting",
      "search.component.order-row.select-direction.option.asc": "Ascending",
      "search.component.order-row.select-direction.option.desc": "Descending",
      "search.component.order-row.select-direction.placeholder": "Sorting direction...",
      "search.component.order-row.select-field.placeholder": "Select a field for sorting...",
      "search.component.search-actions.reset-button.text": "Remove filters",
      "search.component.search-actions.save-filter-button.arial-label": "Save Filter Selection",
      "search.component.search-actions.save-filter-button.tooltips": "Save Filter Selection",
      "search.component.search-actions.submit-button.pristine-message": "No filters selected",
      "search.component.search-actions.submit-button.text": "Search",
      "search.component.search-row.remove-filter-button.aria-label": "Remove Filter",
      "search.component.search-row.remove-filter-button.tooltips": "Remove Filter",
      "skip-links.open-menu": "Open Skip Link navigation menu",
      "table.copyable-id.copied": "ID {{id}} copied!",
      "table.copyable-id.copy": "Copy ID {{id}}",
      "table.copyable-id.no-id": "ID not present!",
      "table.filter-dropdown-search.reset": "Reset",
      "table.filter-dropdown-search.search": "Search",
      "table.table-column-filter-buttons.reset": "Reset",
      "table.table-column-filter-buttons.search": "Search",
      "table.table-column-filter.date-range-from-placeholder": "From: DD/MM/YYYY",
      "table.table-column-filter.date-range-to-placeholder": "To: DD/MM/YYYY",
      "table.table-column-filter.text-placeholder": "Search",
      "table.table-data-filter-panel.reset": "Reset",
      "table.table-data-filter-panel.search": "Search",
      "table.table-date-from.from": "From",
      "ui.ellipsis.collapse": "collapse",
      "ui.ellipsis.expand": "expand",
      "use-pagination-a11y.current-page-sr-message-total": "Current page {{page}} of {{total}}.",
      "async-value-widget.error-message": "An error occurred, please try again later",
      "divider-widget.new-divider-title": "New title divider",
      "info-widget.collapse": "Collapse",
      "info-widget.expand": "Expand",
      "info-widget.new-info-message": "New information message",
      "inputs.rich-text-advanced-link-node.screen-reader-content": "(Opens in a new window)",
      "paragraph-widget.new-paragraph": "New paragraph",
      "payment-row-widget.base-unit-amount": "Unit Price",
      "payment-row-widget.description": "Description",
      "payment-row-widget.discount": "Discount/Exemption",
      "payment-row-widget.quantity": "Quantity",
      "payment-row-widget.taxable-amount": "Taxable Amount",
      "payment-row-widget.title": "Include in payment",
      "payment-row-widget.total": "Total",
      "payment-row-widget.unit": "Unit of Measurement",
      "payment-row-widget.unit-amount": "Unit Price",
      "payment-row-widget.vat": "VAT",
      "payment-row-widget.vat-amount": "VAT",
      "required-rule.boolean-message": "The field ${label} is required",
      "rules.confirm-widget-required.error": "You must confirm or modify the displayed data.",
      "rules.date-range.max-date": "The date must be before {{to_date}}",
      "rules.date-range.min-date": "The date must be after {{from_date}}",
      "rules.fraction-digits.max": "The field ${label} cannot have more than {{max}} decimal digits",
      "rules.item-range.min": "The field ${label} must contain at least {{min}} elements",
      "rules.text-format.number": "The field ${label} is not a number.",
      "rules.text-format.phone": "The field ${label} is not a phone number.",
      "rules.total-digits.max": "The field ${label} cannot have more than {{max}} digits",
      "rules.unique-field-rule.error": "The combination of fields {{labels}} must be unique",
      "rules.value-range.max": "The field ${label} must be less than or equal to {{max}}",
      "rules.value-range.max-exclusive": "The field ${label} must be less than {{max}}",
      "rules.value-range.min": "The field ${label} must be greater than or equal to {{min}}",
      "rules.value-range.min-exclusive": "The field ${label} must be greater than {{min}}",
      "subsection.drawer.button.back": "Back",
      "ui.info-icon.content": "Additional information text",
      "widgets.add-row-buttton.add": "Add",
      "widgets.add-row-buttton.max-options-reached": "Maximum number of options reached",
      "widgets.advanced-multi-select.modal-select-option-title": "Select Options",
      "widgets.advanced-multi-select.selection-counter": "{{selectedCount}} selected / {{totalCount}} total",
      "widgets.advanced-select.cancel-changes-button": "Cancel",
      "widgets.advanced-select.cancel-changes-confirm-cancel": "Continue",
      "widgets.advanced-select.cancel-changes-confirm-content": "The selection will be restored to its value before the popup was opened.",
      "widgets.advanced-select.cancel-changes-confirm-ok": "Discard changes",
      "widgets.advanced-select.cancel-changes-confirm-title": "Discard changes?",
      "widgets.advanced-select.confirm-button-text": "Confirm",
      "widgets.advanced-select.delete-selection": "Clear",
      "widgets.advanced-select.delete-selection-confirm-cancel": "Back",
      "widgets.advanced-select.delete-selection-confirm-content": "The current selection will be removed.",
      "widgets.advanced-select.delete-selection-confirm-ok": "Clear",
      "widgets.advanced-select.delete-selection-confirm-title": "Clear the selection?",
      "widgets.advanced-select.search-label": "Search",
      "widgets.advanced-select.search-placeholder": "Search...",
      "widgets.advanced-select.show-only-selected": "Show only selected",
      "widgets.advanced-select.validation.invalid-option": "The option is not valid for the field ${path}",
      "widgets.advanced-single-select.change-button-text": "Change",
      "widgets.advanced-single-select.modal-select-option-title": "Select Option",
      "widgets.advanced-single-select.select-button-text": "Choose",
      "widgets.async-select-widget-component.invalid-data-format": "The \"{{service}}\" service returned data in an invalid format.",
      "widgets.async-select-widget-component.invalid-data-format-no-service": "The service returned data in an invalid format.",
      "widgets.async-select-widget-component.not-found": "No items found.",
      "widgets.async-select-widget-component.service-not-responding": "Unable to retrieve data from {{service}} service. Please try again later.",
      "widgets.async-select-widget-component.type-to-search": "Type to start searching",
      "widgets.async-select.select-text": "Choose",
      "widgets.confirm-widget-layout-component.cancel": "Cancel Changes",
      "widgets.confirm-widget-layout-component.confirm": "Confirmed",
      "widgets.confirm-widget-layout-component.edit": "Edit",
      "widgets.multi-select-select-component.placeholder": "Placeholder",
      "widgets.remove-row-buttton.min-options-reached": "Minimum number of options reached",
      "widgets.repeatable-content.alert-sr.added": "Item {{index}} added to the list {{labelText}}.",
      "widgets.repeatable-content.alert-sr.removed": "Item {{index}} removed from the list {{labelText}}. Subsequent items have been reordered.",
      "widgets.select-widget.select-text": "Choose",
      "widgets.subsection-drawer-component.expand-aria": "Expand",
      "widgets.subsection-drawer-component.open": "Open",
      "widgets.use-exec-async-service-action.error-during-loading": "An error occurred while executing the asynchronous service",
      "widgets.use-exec-async-service-action.no-handle-function": "An error occurred while executing the asynchronous service, retry.",
      "widgets.use-repeat-controller-confirm-modal.cancel": "Cancel",
      "widgets.use-repeat-controller-confirm-modal.content": "By reducing the number of elements, you will remove excess rows from the list. Continue?",
      "widgets.use-repeat-controller-confirm-modal.continue": "Continue",
      "widgets.use-repeat-controller-confirm-modal.title": "Remove items from list?",
      "address-book.already-selected": "Selected",
      "address-book.button.apri-rubrica": "Open Contacts",
      "address-book.columns.codice-fiscale": "Fiscal Code",
      "address-book.columns.cognome": "Surname",
      "address-book.columns.nome": "Name",
      "address-book.columns.nome-completo": "Full Name",
      "address-book.columns.pec": "PEC",
      "address-book.company.company-name": "Company Name",
      "address-book.company.detail.business-name": "Business Name",
      "address-book.company.detail.fiscal-code": "Fiscal Code",
      "address-book.company.detail.fiscal-code-invalid": "Fiscal Code or VAT number is invalid.",
      "address-book.company.detail.legal-headquarters-address": "Registered Office Address",
      "address-book.company.detail.legal-headquarters-hamlet": "Registered Office Hamlet",
      "address-book.company.detail.legal-headquarters-municipality": "Registered Office Municipality",
      "address-book.company.detail.legal-headquarters-number": "Registered Office Street Number",
      "address-book.company.detail.legal-headquarters-province": "Registered Office Province",
      "address-book.company.detail.legal-headquarters-zip": "Registered Office CAP",
      "address-book.company.detail.legal-headquarters-zip-validation": "Registered Office CAP must be exactly 5 characters",
      "address-book.company.detail.operational-headquarters-address": "Operational Headquarters Address",
      "address-book.company.detail.operational-headquarters-fraction": "Operational Headquarters Hamlet",
      "address-book.company.detail.operational-headquarters-municipality": "Operational Headquarters Municipality",
      "address-book.company.detail.operational-headquarters-number": "Operational Headquarters Street Number",
      "address-book.company.detail.operational-headquarters-province": "Operational Headquarters Province",
      "address-book.company.detail.operational-headquarters-same": "Operational Headquarters is the same as Registered Office",
      "address-book.company.detail.operational-headquarters-zip": "Operational Headquarters CAP",
      "address-book.company.detail.operational-headquarters-zip-validation": "Operational Headquarters CAP must be exactly 5 characters",
      "address-book.company.detail.pec": "PEC",
      "address-book.company.detail.pec-invalid": "Please enter a valid PEC address",
      "address-book.company.detail.vat": "VAT",
      "address-book.company.fiscal-code": "Fiscal Code",
      "address-book.company.pec": "PEC",
      "address-book.company.searchable-fields.fiscal-code": "Fiscal Code",
      "address-book.company.searchable-fields.fiscal-code-placeholder": "Fiscal Code...",
      "address-book.company.searchable-fields.ragione-sociale": "Company Name",
      "address-book.company.searchable-fields.ragione-sociale-placeholder": "Company Name...",
      "address-book.company.searchable-fields.vat": "VAT",
      "address-book.company.searchable-fields.vat-placeholder": "VAT...",
      "address-book.company.vat": "VAT",
      "address-book.duplicate-modal.alert-description": "Choose whether to update the most recent, create a new one, or select from the contact list.",
      "address-book.duplicate-modal.alert-description-single": "Choose whether to update the existing contact or create a new one.",
      "address-book.duplicate-modal.alert-message-company-many_one": "There is already {{count}} contact with the same VAT number {{value}}.",
      "address-book.duplicate-modal.alert-message-company-many_other": "There are already {{count}} contacts with the same VAT number {{value}}.",
      "address-book.duplicate-modal.alert-message-company-one": "There is already a contact with the same VAT number {{value}}.",
      "address-book.duplicate-modal.alert-message-person-many_one": "There is already {{count}} contact with the same Fiscal Code {{value}}.",
      "address-book.duplicate-modal.alert-message-person-many_other": "There are already {{count}} contacts with the same Fiscal Code {{value}}.",
      "address-book.duplicate-modal.alert-message-person-one": "There is already a contact with the same Fiscal Code {{value}}.",
      "address-book.duplicate-modal.create-new": "Create new",
      "address-book.duplicate-modal.diff-table.compare-info": "Compare the data entered in the form with the data in the address book to select the contact to overwrite. Fields highlighted in yellow will be overwritten.",
      "address-book.duplicate-modal.diff-table.contact-value": "Address book data",
      "address-book.duplicate-modal.diff-table.field": "Field",
      "address-book.duplicate-modal.diff-table.form-value": "Form data",
      "address-book.duplicate-modal.diff-table.group-legal-representative": "Legal Representative",
      "address-book.duplicate-modal.diff-table.group-main-company": "Legal Entity",
      "address-book.duplicate-modal.diff-table.group-main-person": "Natural Person",
      "address-book.duplicate-modal.diff-table.no-differences": "No differences",
      "address-book.duplicate-modal.diff-table.select-placeholder": "Select a contact",
      "address-book.duplicate-modal.diff-table.show-all-values": "Show all values",
      "address-book.duplicate-modal.diff-table.show-only-differences": "Show only values that will be overwritten",
      "address-book.duplicate-modal.hide-comparison-table": "Hide comparison table",
      "address-book.duplicate-modal.select-contact-hint": "Select a contact to update",
      "address-book.duplicate-modal.show-comparison-table": "Show comparison table",
      "address-book.duplicate-modal.title": "Add contact to address book",
      "address-book.duplicate-modal.update-contact": "Update Contact",
      "address-book.duplicate-modal.update-most-recent": "Update most recent",
      "address-book.import-modal.certificato-warning.cancel": "Cancel",
      "address-book.import-modal.certificato-warning.content": "The data of this legal entity is not certified. Do you want to proceed with the import?",
      "address-book.import-modal.certificato-warning.ok": "Proceed",
      "address-book.import-modal.certificato-warning.title": "Data not certified",
      "address-book.import-modal.error": "An error occurred while loading the address book",
      "address-book.import-modal.select": "Select",
      "address-book.import-modal.title.persona-fisica": "Select natural person",
      "address-book.import-modal.title.persona-giuridica": "Select legal entity",
      "address-book.modal.empty-list.description1.nessuna-persona-vai-alla": "No natural person found, go to the",
      "address-book.modal.empty-list.description2.link.rubrica": "Contacts",
      "address-book.modal.empty-list.description3.per-aggiungerne-di-nuovi": "to add new ones.",
      "address-book.modal.empty-list.message.rubrica-vuota": "Empty Contacts",
      "address-book.modal.error.errore-caricamento-rubrica": "An error occurred while loading Contacts",
      "address-book.modal.title.seleziona-persona-fisica": "Select natural person",
      "address-book.person.detail.address": "Address",
      "address-book.person.detail.born-in-italy": "Born in Italy",
      "address-book.person.detail.cap": "CAP",
      "address-book.person.detail.cap.validation": "CAP must be exactly 5 characters",
      "address-book.person.detail.date-of-birth": "Date of Birth",
      "address-book.person.detail.date-of-registration": "Date of Registration",
      "address-book.person.detail.email": "Email",
      "address-book.person.detail.entered-in-register": "Entered in Register",
      "address-book.person.detail.fiscal-code": "Fiscal Code",
      "address-book.person.detail.fixed-phone": "Fixed Phone",
      "address-book.person.detail.foreign-address": "Foreign Address",
      "address-book.person.detail.foreign-municipality-of-residence": "Foreign Municipality of Residence",
      "address-book.person.detail.gender": "Gender",
      "address-book.person.detail.mobile-phone": "Mobile Phone",
      "address-book.person.detail.municipality-of-birth": "Municipality of Birth",
      "address-book.person.detail.municipality-of-registration": "Municipality of Registration",
      "address-book.person.detail.municipality-of-residence": "Municipality of Residence",
      "address-book.person.detail.name": "Name",
      "address-book.person.detail.other-information": "Other Information",
      "address-book.person.detail.pec": "PEC",
      "address-book.person.detail.profession": "Profession",
      "address-book.person.detail.province-of-birth": "Province of Birth",
      "address-book.person.detail.province-of-registration": "Province of Registration",
      "address-book.person.detail.province-of-residence": "Province of Residence",
      "address-book.person.detail.register": "Register",
      "address-book.person.detail.residence-state": "Residence State",
      "address-book.person.detail.resident-in-italy": "Resident in Italy",
      "address-book.person.detail.state-of-birth": "State of Birth",
      "address-book.person.detail.surname": "Surname",
      "address-book.person.input.fiscal-code.aria-label": "Search Fiscal Code",
      "address-book.person.input.fiscal-code.placeholder": "Fiscal Code",
      "address-book.person.input.surname.aria-label": "Search by other fields.",
      "address-book.person.input.surname.placeholder": "Surname...",
      "address-book.person.searchable-fields.cognome": "Surname",
      "address-book.person.searchable-fields.cognome-placeholder": "Surname...",
      "address-book.person.searchable-fields.fiscal-code": "Fiscal Code",
      "address-book.person.searchable-fields.fiscal-code-placeholder": "Fiscal Code...",
      "address-book.person.searchable-fields.nome": "Name",
      "address-book.person.searchable-fields.nome-placeholder": "Name...",
      "address-book.save.error": "Error while saving",
      "address-book.save.success-created": "Contact created in address book",
      "address-book.save.success-updated": "Contact updated in address book",
      "address-book.save.tooltip-more-errors_one": "...and {{count}} other error",
      "address-book.save.tooltip-more-errors_other": "...and {{count}} other errors",
      "address-book.save.validation-error": "An error occurred during validation and duplicate check.",
      "address-book.select": "Select",
      "cmmunication-state-tag.default": "N/A",
      "cmmunication-state-tag.error": "Sending Failed",
      "cmmunication-state-tag.processing": "In Processing",
      "cmmunication-state-tag.success": "Sent",
      "common.cancel": "Cancel",
      "communication-attachment-group-editor.download-after-save": "The download of newly uploaded attachments will be available after saving the communication.",
      "communication-attachment-group-editor.title-generic-fallback": "Attachment",
      "communication-attachment-group-editor.upload-file": "Upload file {{maxCount}}",
      "communication-attachments.attachments": "Attachments",
      "communication-attachments.error-attachment-group": "Error: attachment group not found",
      "communication-attachments.error-type": "Error: communication type not found",
      "communication-attachments.title": "Attachments",
      "communication-button.edit-comm": "Edit Communication",
      "communication-button.load-comm": "Load Communication",
      "communication-button.new-comm": "New Communication",
      "communication-details.receiver": "Recipients",
      "communication-details.sender": "Sender",
      "communication-error.upload-no-id": "Error: Attachment created without ID.",
      "communication-extend-search-form.communication-type": "Communication Type",
      "communication-extend-search-form.creation-date": "Creation Date",
      "communication-extend-search-form.last-modification": "Last Modification",
      "communication-extend-search-form.message": "Message",
      "communication-extend-search-form.read-state": "***Lettura",
      "communication-extend-search-form.read-state-read": "***Lette",
      "communication-extend-search-form.read-state-unread": "***Non lette",
      "communication-extend-search-form.recipient": "Recipient",
      "communication-extend-search-form.recipient-type": "Recipient Type",
      "communication-extend-search-form.recipient-type-altro-ufficio": "Other Office",
      "communication-extend-search-form.recipient-type-delegati-compilazione": "Delegates for Compilation",
      "communication-extend-search-form.recipient-type-delegati-firma": "Delegates for Signature",
      "communication-extend-search-form.recipient-type-endoprocedimento-primo-livello": "First Level Subprocedure",
      "communication-extend-search-form.recipient-type-impresa-titolare": "Company Holder",
      "communication-extend-search-form.recipient-type-procuratore": "Prosecutor",
      "communication-extend-search-form.recipient-type-responsabile-procedimento": "Responsible for Procedure",
      "communication-extend-search-form.recipient-type-richiedente": "Applicant",
      "communication-extend-search-form.recipient-type-titolare": "Holder",
      "communication-extend-search-form.search-in-message": "Search in message...",
      "communication-extend-search-form.search-recipient": "Recipient Name...",
      "communication-extend-search-form.search-sender": "Sender Name...",
      "communication-extend-search-form.send-date": "Send Date",
      "communication-extend-search-form.sender": "Sender",
      "communication-extend-search-form.sender-type": "Sender Type",
      "communication-extend-search-form.sender-type-altro-ufficio": "Other Office",
      "communication-extend-search-form.sender-type-endoprocedimento-primo-livello": "First Level Subprocedure",
      "communication-extend-search-form.sender-type-responsabile-procedimento": "Responsible for Procedure",
      "communication-extend-search-form.sender-type-richiedente": "Applicant",
      "communication-extend-search-form.sender-type-titolare": "Holder",
      "communication-extend-search-form.sent": "Sent on",
      "communication-extend-search-form.sent-after": "Sent after",
      "communication-extend-search-form.sent-before": "Sent before",
      "communication-extend-search-form.subject": "Subject",
      "communication-extend-search-form.subprocedure": "Subprocedure",
      "communication-extend-search-form.write-or-select-date": "Write or select date...",
      "communication-forward.title": "Forwarded Communication",
      "communication-header.receivers": "Recipients",
      "communication-header.sender": "Sender",
      "communication-item.edit": "Edit",
      "communication-item.edit-and-send": "Edit and Send",
      "communication-item.forward": "Forward",
      "communication-item.forward.error": "Error: unable to forward communication",
      "communication-item.mark-as-read": "***Segna come letta",
      "communication-item.mark-as-read-error": "***Impossibile segnare la comunicazione come letta",
      "communication-item.signature-book-detail": "Signature Book Detail",
      "communication-list.no-comms-to-show": "No communications to show",
      "communication-procedure-attachment.error-loading-files": "An error occurred while loading the procedure file list",
      "communication-procedure-attachment.error-no-attachment-group-id": "Error: attachment group not found",
      "communication-procedure-attachment.error-no-communication-id": "Error: communication not found",
      "communication-procedure-attachment.error-no-file-selected": "Error: no file selected",
      "communication-procedure-attachment.error-no-result": "Error: an error occurred while uploading the file",
      "communication-receiver-input.error-loading-subprocedures": "Error loading subprocedures",
      "communication-receiver-input.receiver-description": "Include at least one third party among the recipients",
      "communication-recipient.protocol-number": "Protocol",
      "communication-recipient.read": "***Letta",
      "communication-recipient.registration-date": "Protocol date",
      "communication-recipient.send-date": "Date sent",
      "communication-recipient.unread": "***Non letta",
      "communication-request-schema.attachment": "Attachment",
      "communication-request-schema.attachment-id": "Attachment ID",
      "communication-request-schema.attachment-name": "Attachment Name",
      "communication-request-schema.attachment-type": "Attachment Type",
      "communication-request-schema.dataProtocollo": "Protocol Date",
      "communication-request-schema.destinatari": "Recipients",
      "communication-request-schema.destinatario": "Recipient",
      "communication-request-schema.destinatario-required": "At least one recipient must be selected",
      "communication-request-schema.flMessaggioModificato": "Message Modified",
      "communication-request-schema.flOggettoModificato": "Subject Modified",
      "communication-request-schema.idComunicazione": "Communication ID",
      "communication-request-schema.idDestinatario": "Recipient Type",
      "communication-request-schema.idEndoprocedimento": "Subprocedure",
      "communication-request-schema.idProcedimentoMittente": "Sender Subprocedure",
      "communication-request-schema.idTipoComunicazione": "Communication Type",
      "communication-request-schema.inoltro.allegati": "Forwarded Communication Attachments",
      "communication-request-schema.inoltro.idComunicazione": "Communication ID",
      "communication-request-schema.inoltro.messaggio": "Message",
      "communication-request-schema.message-required": "At least one of message or subject must be filled in",
      "communication-request-schema.messaggio": "Message",
      "communication-request-schema.noteAddizionali": "Additional Notes",
      "communication-request-schema.numeroProtocollo": "Protocol Number",
      "communication-request-schema.oggetto": "Subject",
      "communication-search-schema.sent-after": "Sent after",
      "communication-search-schema.sent-before": "Sent before",
      "communication-searchable.search-by-type": "Search by type...",
      "communication-tag-option-holder": "HOLDER",
      "communication-tag-option.applicant": "APPLICANT",
      "communication-tag-option.company-holder": "COMPANY HOLDER",
      "communication-tag-option.delegate-for-comp": "DELEGATE FOR COMPILATION",
      "communication-tag-option.delegate-for-sign": "DELEGATE FOR SIGNATURE",
      "communication-tag-option.legal-subject": "LEGAL SUBJECT",
      "communication-tag-option.manager": "MANAGER",
      "communication-tag-option.no-type": "N/A",
      "communication-tag-option.other-variable-office": "OTHER VARIABLE OFFICE",
      "communication-tag-option.prosecutor": "PROSECUTOR",
      "communication-tag-option.requesting-office": "REQUESTING OFFICE",
      "communication-tag-option.responsible-office": "RESPONSIBLE OFFICE",
      "communication-tag-option.secondary-competence-office": "SECONDARY COMPETENCE OFFICE",
      "communication-tag-option.system": "***SISTEMA",
      "communication-tag-option.third-organization": "THIRD ORGANIZATION",
      "communication-type.receivers": "Recipients",
      "communication-type.sender": "Sender",
      "communication-type.subprocedure-sender": "Subprocedure Sender",
      "communication-type.subprocedure-sender.placeholder": "Select Subprocedure Sender...",
      "communication.draft": "DRAFT",
      "communication.sent": "SENT",
      "communication.unread-count_one": "***{{count}} comunicazione non letta",
      "communication.unread-count_other": "***{{count}} comunicazioni non lette",
      "communications-sender-protocol.protocol-date": "Protocol Date",
      "communications-sender-protocol.protocol-number": "Protocol Number",
      "communications-sender-protocol.tag.errore": "ERROR",
      "communications-sender-protocol.tag.processing": "PROCESSING",
      "communications-sender-protocol.tooltip-title.error-protocolling": "Error in communication registration",
      "communications-sender-protocol.tooltip-title.processing-protocolling": "Protocolling in progress",
      "communications.additional-notes": "Additional notes",
      "communications.additional-notes-placeholder": "Additional notes to the communication",
      "communications.communication-title": "Communication",
      "communications.error-in-communication": "Error in communication",
      "communications.error-in-sending-communication": "Error in sending the communication",
      "communications.error-protocolling-communication": "Error in protocol registration operations",
      "communications.error-saving-communication-on-send": "An error occurred while sending the communication",
      "communications.error-sending-communication": "An error occurred while sending the communication",
      "communications.forward.input.attachments.help": "Select attachments to forward",
      "communications.forward.input.attachments.label": "Attachments of the forwarded communication",
      "communications.forward.input.message.label": "Forwarded Communication",
      "communications.forward.input.message.placeholder": "Forwarded communication",
      "communications.hydrate-error": "An error occurred while retrieving the communication preview. Please try again.",
      "communications.in-working": "Communication in progress",
      "communications.message": "Message",
      "communications.message-placeholder": "Communication message",
      "communications.protocol-date": "Protocol Date",
      "communications.protocol-number": "Protocol Number",
      "communications.protocol-row-label": "Protocol",
      "communications.receiver-label": "Recipients",
      "communications.select": "Selection...",
      "communications.select-receiver-subprocedure": "Select recipient subprocedure",
      "communications.sent-successfully": "Communication sent successfully",
      "communications.subject": "Subject",
      "communications.subject-placeholder": "Communication subject",
      "communications.type-label": "Communication Type",
      "communications.type-row": "Communication Type",
      "communications.type-title": "Type of Communication",
      "competence-widget.error-fetching-competences": "Unable to retrieve Competence data. Please try again later.",
      "competence-widget.no-element-found": "No items found.",
      "comunicazioni.invia": "Send",
      "confirm-update-modal.added-new-module-activation": "A new module activation has been added:",
      "confirm-update-modal.added-new-multiple-modules-activation": "{{length}} new module activations have been added:",
      "confirm-update-modal.changes-will-be-applied-to-inquiries": "Changes will be made to {{inquiriesLength}} request{oneOrMore}:",
      "confirm-update-modal.removed-module-activation": "A module activation has been removed:",
      "confirm-update-modal.removed-multiple-modules-activation": "{{length}} module activations have been removed:",
      "domanda.copertina.categorie": "Categories",
      "domanda.copertina.destinatari": "Recipients",
      "domanda.copertina.scadenza": "Expiration",
      "dossier-searchable.a-data-avvio": "To Start Date",
      "dossier-searchable.anno-richiesta": "Request Year",
      "dossier-searchable.anno-richiesta-placeholder": "Request year...",
      "dossier-searchable.da-data-avvio": "From Start Date",
      "dossier-searchable.data-avvio": "Start Date",
      "dossier-searchable.data-protocollo-documento": "Document Protocol Date",
      "dossier-searchable.data-protocollo-richiesta": "Request Protocol Date",
      "dossier-searchable.numero": "Number",
      "dossier-searchable.numero-placeholder": "Number...",
      "dossier-searchable.numero-protocollo-documento": "Document Protocol Number",
      "dossier-searchable.numero-protocollo-richiesta": "Request Protocol Number",
      "dossier-searchable.numero-richiesta": "Request Number",
      "dossier-searchable.numero-richiesta-placeholder": "Request number...",
      "dossier-searchable.oggetto": "Subject",
      "dossier-searchable.oggetto-placeholder": "Subject...",
      "dossier-searchable.proc-avvio-a-data-invio": "To Sending Date",
      "dossier-searchable.proc-avvio-da-data-invio": "From Sending Date",
      "dossier-searchable.procedimento-avvio-data-invio": "Start Procedure: Sending Date",
      "dossier-searchable.procedimento-avvio-denominazione": "Start Procedure: Name",
      "dossier-searchable.procedimento-avvio-denominazione-placeholder": "Start procedure name...",
      "dossier-searchable.ricerca-estesa": "Extended Search",
      "dossier-searchable.ricerca-estesa-placeholder": "Extended search...",
      "dossier-searchable.richiesta-avvio-a-data-invio": "Request Start: To Sending Date",
      "dossier-searchable.richiesta-avvio-da-data-invio": "Request Start: From Sending Date",
      "dossier-searchable.richiesta-avvio-data-invio": "Request Start: Sending Date",
      "dossier-searchable.richiesta-avvio-numero-richiesta": "Request Start: Number",
      "dossier-searchable.richiesta-avvio-numero-richiesta-placeholder": "Number...",
      "dossier-searchable.richiesta-avvio-tipo-domanda": "Request Start: Type",
      "dossier-searchable.soggetto-richiesta-codice-fiscale": "Request Subject: Tax Code",
      "dossier-searchable.soggetto-richiesta-codice-fiscale-placeholder": "Tax code...",
      "dossier-searchable.soggetto-richiesta-cognome": "Request Subject: Surname",
      "dossier-searchable.soggetto-richiesta-cognome-placeholder": "Surname...",
      "dossier-searchable.soggetto-richiesta-nome": "Request Subject: Name",
      "dossier-searchable.soggetto-richiesta-nome-placeholder": "Name...",
      "dossier-searchable.stato-pratica": "Case Status",
      "dossier-searchable.tipo-pratica": "Case Type",
      "dossier-searchable.titolare-principale-codice-fiscale": "Main Holder: Tax Code",
      "dossier-searchable.titolare-principale-codice-fiscale-impresa": "Main Holder Company: Tax Code",
      "dossier-searchable.titolare-principale-codice-fiscale-impresa-placeholder": "Tax code...",
      "dossier-searchable.titolare-principale-codice-fiscale-placeholder": "Tax code...",
      "dossier-searchable.titolare-principale-codice-rea-impresa": "Main Holder Company: REA Code",
      "dossier-searchable.titolare-principale-codice-rea-impresa-placeholder": "REA code...",
      "dossier-searchable.titolare-principale-cognome": "Main Holder: Surname",
      "dossier-searchable.titolare-principale-cognome-placeholder": "Surname...",
      "dossier-searchable.titolare-principale-denominazione-impresa": "Main Holder Company: Name",
      "dossier-searchable.titolare-principale-denominazione-impresa-placeholder": "Company name...",
      "dossier-searchable.titolare-principale-nome": "Main Holder: Name",
      "dossier-searchable.titolare-principale-nome-placeholder": "Name...",
      "dossier-searchable.titolare-principale-partita-iva": "Main Holder Company: VAT Number",
      "dossier-searchable.titolare-principale-partita-iva-placeholder": "VAT number...",
      "download-file-button.error-download-file": "There was a problem downloading the file",
      "download-file.error-downloading-file": "There was a problem downloading the file",
      "download-file.no-filename-from-header": "Document",
      "download-file.p7m-extraction-failed": "Unable to extract content from the signed file. Please use the download feature.",
      "download-file.p7m-not-pdf": "The signed file does not contain a PDF. Please use the download feature.",
      "download-widget.error": "There was a problem downloading the file. Try again.",
      "download-widget.file-not-found": "File not found",
      "email-verification-rule.message": "You need to verify your email to continue",
      "email-verification-widget.check-mail-box-to-confirm": "A verification email has been sent to your mailbox. Please check your email to confirm your email address.",
      "email-verification-widget.confirm-reception": "Confirm Receipt",
      "email-verification-widget.error-in-sending-verification-mail": "Error sending verification email",
      "email-verification-widget.invalid-email": "Invalid E-mail",
      "email-verification-widget.verified": "Verified",
      "email-verification-widget.verify-email": "Verify Email",
      "engine.async-services.load-error": "An error occurred while loading external services. Please try again.",
      "error": "Error",
      "error-while-resetting-notification-flag": "Error resetting notification flag",
      "export-field-select.max-selectable-fields": "You can select up to {{max}} fields.",
      "export-field-select.require-fields-warning": "Select at least one field to export.",
      "export-field-select.select-fields-to-export": "Select fields to export",
      "export-field-select.select-fields-to-export-title.line-a": "Select the fields to export.",
      "export-field-select.select-fields-to-export-title.line-b": "If no fields are specified, the export will contain all data.",
      "export-file-button.cancel-text": "Cancel",
      "export-file-button.confirm-export-final-text": "You are about to export the data found by the currently active search filters. Depending on the filters used, this operation may take some time. Continue?",
      "export-file-button.download-current-page-checkbox": "Download only items present on the current page (pag. {{page}}) (max. {{pageSize}} {{entity}})",
      "export-file-button.error.export": "An error occurred while exporting the file. Please try again.",
      "export-file-button.error.save-template": "An error occurred while saving the template.",
      "export-file-button.export-entity": "Export {{typeTitle}} {{entityTitle}}",
      "export-file-button.export-title": "Export {{typeTitle}}",
      "export-file-button.max-selectable-exceeded": "The maximum limit has changed. Only the first {{max}} fields have been kept.",
      "export-file-button.ok-text": "Export",
      "export-file-button.remember-fields": "Remember fields for next export",
      "export-file-button.save-action-select.aggiorna-template": "Update Template",
      "export-file-button.save-action-select.input-nuovo-template.placeholder": "Name of the new Template",
      "export-file-button.save-action-select.non-salvare-template": "Do not save the Template",
      "export-file-button.save-action-select.placeholder.update-template-to-export": "Updating Template",
      "export-file-button.save-action-select.salva-nuovo-template": "Save as new Template",
      "export-template-modal-button.chiudi": "Close",
      "export-template-modal-button.elimina": "Delete",
      "export-template-modal-button.elimina-il-template": "Delete this Template",
      "export-template-modal-button.error.errore-nel-eliminazione-del-template": "An error occurred while deleting the template.",
      "export-template-modal-button.errore-nel-eliminazione-del-template": "Error deleting the template",
      "export-template-modal-button.sei-sicuro-di-voler-eliminare-il-template": "Are you sure you want to delete the template?",
      "export-template-modal-button.template-eliminato-correttamente": "Template deleted successfully.",
      "export-template-modal-button.unsaved-template-miss-id": "The template must be saved before it can be deleted.",
      "export-template-select.select-template-to-export": "Load fields from Template",
      "export.default-errore": "An error occurred while downloading the file. Please try again.",
      "export.file-non-trovato": "File not found",
      "interazioni.annulla": "Cancel",
      "interazioni.salva": "Save",
      "loading": "Loading...",
      "map-catalog.merge.cadastral-skipped_one": "{{count}} cadastral preset skipped (only one is allowed)",
      "map-catalog.merge.cadastral-skipped_other": "{{count}} cadastral presets skipped (only one is allowed)",
      "map-catalog.merge.groups-added_one": "{{count}} group added",
      "map-catalog.merge.groups-added_other": "{{count}} groups added",
      "map-catalog.merge.groups-skipped_one": "{{count}} duplicate group skipped",
      "map-catalog.merge.groups-skipped_other": "{{count}} duplicate groups skipped",
      "map-catalog.merge.layers-added_one": "{{count}} layer added",
      "map-catalog.merge.layers-added_other": "{{count}} layers added",
      "map-catalog.merge.no-entries": "No entries to import",
      "map-catalog.merge.replaced": "Catalog replaced successfully",
      "map-restore-default.aria": "Restore original value",
      "map-restore-default.cancel": "Cancel",
      "map-restore-default.description": "The current map changes will be replaced with the original value.",
      "map-restore-default.ok": "Restore",
      "map-restore-default.title": "Restore original value",
      "map-restore-default.tooltip": "Restore the original value",
      "map-upload-geometries.chiudi": "Close",
      "map-widget.competence-not-attributed-warning": "The competence could not be automatically attributed for one or more selected areas.",
      "map-widget.draw.shape.aria-label": "Geometry type to draw",
      "map-widget.draw.shape.line.label": "Line",
      "map-widget.draw.shape.point.label": "Point",
      "map-widget.draw.shape.polygon.label": "Polygon",
      "map-widget.drawn-geometries": "Drawn geometries",
      "map-widget.extended-view.close": "Reduce map",
      "map-widget.extended-view.open": "Extended view",
      "map-widget.extended-view.placeholder": "Map open in extended view",
      "map-widget.extended-view.title": "Map",
      "map-widget.geometries.go-to-geometry": "Go to geometry",
      "map-widget.geometries.measure-column": "Measure",
      "map-widget.geometries.type-column": "Type",
      "map-widget.geometries.type.line": "Line",
      "map-widget.geometries.type.point": "Point",
      "map-widget.geometries.type.polygon": "Polygon",
      "map-widget.intersections-truncated-error": "{{found}} intersections were found but at most {{max}} can be shown. The exceeding ones will not be displayed: reduce the drawn area.",
      "map-widget.no-geometries": "No geometries present",
      "map-widget.search-address.aria-label": "Search address",
      "map-widget.search-address.load-address-error-mpe-002": "Error loading address (MPE-002)",
      "map-widget.search-address.no-result-found-no-extent-mpe-0001": "No results found for selected address (MPE-0001)",
      "map-widget.search-address.not-found-text.loading": "Loading...",
      "map-widget.search-address.not-found-text.no-result": "No results",
      "map-widget.search-address.not-found-text.write-to-search": "Write to search",
      "map-widget.search-address.placeholder": "Search address...",
      "map-widget.title": "Center map on geometry data",
      "map-widget.upload-warning-message": "No geometry data present in the file.",
      "map-widget.zoom-level": "Zoom: {{zoom}}",
      "mappa.controlli.cerca-particella.modale.form-button.cerca": "Search",
      "mappa.controlli.cerca-particella.modale.form-button.seleziona": "Select",
      "mappa.controlli.cerca-particella.modale.form-label.allegato-catastale": "Attachment",
      "mappa.controlli.cerca-particella.modale.form-label.comune": "Municipality",
      "mappa.controlli.cerca-particella.modale.form-label.foglio-catastale": "Sheet",
      "mappa.controlli.cerca-particella.modale.form-label.particella-catastale": "Parcel",
      "mappa.controlli.cerca-particella.modale.form-label.provincia": "Province",
      "mappa.controlli.cerca-particella.modale.form-label.sezione-catastale": "Section",
      "mappa.controlli.cerca-particella.modale.form-label.sviluppo-catastale": "Development",
      "mappa.controlli.cerca-particella.modale.form.errore.durante-la-ricerca": "An error occurred while searching",
      "mappa.controlli.cerca-particella.modale.form.errore.nessun-risultato": "No results found",
      "mappa.controlli.cerca-particella.modale.form.errore.nessuna-geometria-valida": "Error while searching. No valid geometry data found",
      "mappa.controlli.cerca-particella.modale.titolo": "Search by cadastral parcel",
      "mappa.controlli.cerca-particella.pulsante.testo": "Parcel",
      "mappa.controlli.disegna": "Draw",
      "mappa.controlli.elimina": "Delete",
      "mappa.controlli.interroga": "Identify",
      "mappa.controlli.visualizza": "View",
      "mappa.identify.annuncio-risultati_one": "Identify complete: {{count}} result found",
      "mappa.identify.annuncio-risultati_other": "Identify complete: {{count}} results found",
      "mappa.identify.nessun-risultato": "No results found",
      "mappa.identify.poligono": "Polygon",
      "mappa.identify.punto": "Point",
      "mappa.identify.rettangolo": "Rectangle",
      "mappa.identify.risultati": "Identify results",
      "mappa.identify.risultati-trovati_one": "{{count}} result found",
      "mappa.identify.risultati-trovati_other": "{{count}} results found",
      "mappa.livelli.gruppo.altri": "Others",
      "mappa.livelli.popover.form-item-label.visibilita-livelli": "Layer visibility",
      "mappa.livelli.popover.pulsante-chiudi": "Close",
      "mappa.livelli.popover.titolo.visibilita-dei-livelli": "Layer Visibility",
      "mappa.livelli.pulsante": "Layers",
      "mappa.suggerimenti.disegna-linea": "Click to add points · double-click to finish the line.",
      "mappa.suggerimenti.disegna-modifica": "Drag a vertex to edit it, or the whole geometry to move it.",
      "mappa.suggerimenti.disegna-poligono": "Click to add points · double-click to close the area.",
      "mappa.suggerimenti.disegna-punto": "Click on the map to place a point.",
      "mappa.suggerimenti.disegna-punto-sposta": "Drag an existing point to move it.",
      "mappa.suggerimenti.elimina": "Click a geometry to delete it.",
      "mappa.suggerimenti.interroga-poligono": "Click to add points · double-click to close the area to query.",
      "mappa.suggerimenti.interroga-punto": "Click on the map to query the layers at that point.",
      "mappa.suggerimenti.interroga-rettangolo": "Click and drag to define the area to query.",
      "notification-drawer.priority-tag.alta": "HIGH",
      "notification-drawer.priority-tag.bassa": "LOW",
      "notification-drawer.priority-tag.normale": "NORMAL",
      "notification-drawer.priority-tag.priorita": "Priority:",
      "notification-drawer.priority-tag.urgente": "URGENT",
      "notification-drawer.title": "Notifications",
      "notification-filter-switch.all": "All",
      "notification-filter-switch.to-read": "Unread",
      "notification-type-icon.warning": "Warning",
      "notification.error": "An error occurred please try again.",
      "notifiche-campo-data-lettura": "Read Date",
      "notifiche-campo-data-lettura-a": "Read Date To",
      "notifiche-campo-data-lettura-da": "Read Date From",
      "notifiche-campo-data-notifica": "Notification Date",
      "notifiche-campo-data-notifica-a": "To Notification Date",
      "notifiche-campo-data-notifica-da": "From Notification Date",
      "notifiche-campo-letta": "Read",
      "notifiche-campo-non-letta": "Unread",
      "notifiche-campo-numero-istanza": "Request Number",
      "notifiche-campo-oggetto": "Subject",
      "notifiche-campo-priorita": "Priority",
      "notifiche-campo-tipo-domanda": "Inquiry Type",
      "notifiche-campo-tipo-domanda-placeholder": "Inquiry Type...",
      "notifiche-titolo-colonna.data-lettura": "Read Date",
      "notifiche-titolo-colonna.data-notifica": "Notification Date",
      "notifiche-titolo-colonna.letta": "Read",
      "notifiche-titolo-colonna.messaggio": "Message",
      "notifiche-titolo-colonna.oggetto": "Subject",
      "notifiche-titolo-colonna.priorita": "Priority",
      "notifiche.alt-image-notifica-da-leggere ": "Notification Unread",
      "notifiche.alt-image-notifica-letta": "Notification Read",
      "notifiche.da-leggere ": "Unread",
      "notifiche.letta": "Read",
      "notifiche.letta-il": "Read on",
      "notifiche.nessuna-notifica-da-leggere": "No notifications to read",
      "notifiche.non-letta": "Unread",
      "notifiche.segna-come-letta": "Mark as read",
      "notifiche.segna-tutte-come-lette": "Mark all as read",
      "province-widget-schema.mun-belfiore.code": "Municipality Belfiore Code",
      "province-widget-schema.mun-cap": "Municipality CAP",
      "province-widget-schema.mun-istat": "Municipality ISTAT Code",
      "province-widget-schema.mun-lat": "Municipality Latitude",
      "province-widget-schema.mun-lng": "Municipality Longitude",
      "province-widget-schema.mun-name": "Municipality Name",
      "province-widget-schema.mun-province": "Municipality Province",
      "province-widget-schema.mun-region": "Municipality Region",
      "province-widget-schema.prov-belfiore-code": "Belfiore Code",
      "province-widget-schema.prov-lat": "Province Latitude",
      "province-widget-schema.prov-lng": "Province Longitude",
      "province-widget-schema.prov-name": "Province Name",
      "province-widget-schema.prov-region": "Province Region",
      "province-widget.error": "Error",
      "province-widget.error-description": "Error loading province data. Please try again later.",
      "recipient-type.dipendente": "Employee",
      "recipient-type.ente-pubblico": "Public Entity",
      "recipient-type.persona-fisica": "Natural Person",
      "recipient-type.persona-giuridica": "Legal Entity",
      "rules.map-calculation-up-to-date.error": "The map intersection calculation is not complete: wait for it to finish or remove and re-add the geometries.",
      "semantic-tag-searchable-field.from": "From",
      "semantic-tag-searchable-field.to": "TO",
      "stato.pratica.aperta": "OPEN",
      "stato.pratica.chiusa": "CLOSED",
      "stato.tipo-domanda.annullata": "CANCELED",
      "stato.tipo-domanda.aperta": "OPEN",
      "stato.tipo-domanda.bozza": "DRAFT",
      "stato.tipo-domanda.chiusa": "CLOSED",
      "stato.tipo-domanda.collaudo": "TESTING",
      "stato.tipo-domanda.in-corso": "IN PROGRESS",
      "stato.tipo-domanda.pronta": "READY",
      "stato.tipo-domanda.pubblicata": "PUBLISHED",
      "stato.tipo-domanda.sola-lettura": "READ ONLY",
      "stato.tipo-domanda.sospesa": "SUSPENDED",
      "submission-searchable-fields.tipo-domanda": "Type of Request",
      "submission.altri-titolari": "Other Holders",
      "triggerable-modules-confirm-update.generic-error": "A generic error occurred please try again later",
      "upload-widget.file-must-be-uploaded": "The file ${label} must be loaded",
      "upload-widget.public-doc": "Public document",
      "user.login.external-user-email": "E-mail",
      "user.login.external-user-password": "Password",
      "user.login.login-button": "Log in",
      "user.login.password-forgot-link": "Reset Password",
      "user.login.password-forgot-question": "Forgot Password?",
      "user.login.sign-in-link": "Go to Registration Form",
      "user.login.sign-in-question": "Not Registered on the Portal Yet?",
      "burden-payment-state-tag.attesa-pagamento": "Waiting for Payment",
      "burden-payment-state-tag.da-pagare": "To Pay",
      "burden-payment-state-tag.pagato": "Paid",
      "burden-payment-state-tag.pagato-parzialmente": "Partially Paid",
      "burden-selection-table.errore-in-creazione-pagamento": "An error occurred while creating the payment. Try again.",
      "burden-selection-table.seleziona-onere": "Select fee",
      "burden-selection-table.seleziona-oneri": "Select all fees",
      "burden-table.crea-pagamento": "Create Payment",
      "burden-table.totale": "Total",
      "burdens-columns.da-pagare-dopo-invio": "To be paid after sending",
      "burdens-columns.descrizione": "Description",
      "burdens-columns.facoltativo": "Optional",
      "burdens-columns.importo": "Amount",
      "burdens-columns.obbligatorio": "Required",
      "burdens-columns.stato-onere": "Fee Status",
      "burdens-columns.tipo": "Type",
      "download-receipt.errore-in-download": "A problem occurred while downloading the file",
      "error-submit-module-form.error-saving": "Error while saving",
      "error-submit-module-form.errore-salvataggio-modulo": "Error while saving, Form ID not present",
      "error-submit-module-form.errore-salvataggio-richiesta": "Error while saving, Request ID not present",
      "fillable-form.sezione-della-compilazione": "Compilation section",
      "form.applicazione-marca-da-bollo": "By applying the stamp duty, the request will be frozen and no changes will be possible.",
      "form.avanti": "Next",
      "form.avviso-non-ancora-disponibile": "Document not yet available, please try again in a few minutes",
      "form.back-to-inquiries": "Cancel",
      "form.button.paga-il-bollo": "Stamp duty payment",
      "form.conferma": "Confirm",
      "form.conferma-di-procedere": "Do you confirm you want to proceed?",
      "form.elenco-pagamenti": "Payments List",
      "form.errore-in-download": "A problem occurred while downloading the file",
      "form.indietro": "Back",
      "form.non-ci-sono-modifiche": "There are no changes to save",
      "form.oneri-della-domanda": "Request Fees",
      "form.procedi-al-pagamento": "Proceed to payment",
      "form.procedi-al-pagamento-bollo": "Proceed to stamp duty payment",
      "form.procedi-al-pagamento-link-esterno": "Proceed to payment (opens external link)",
      "form.salva": "Save",
      "form.salva-modulo-download-pdf": "Save the form at least once to download the PDF document",
      "form.scarica-avviso": "Download Notice",
      "form.scarica-ricevuta": "Download Receipt",
      "form.seleziona-gli-oneri": "Select fees to proceed with payment",
      "menu-items.guida-alla-compilazione": "Compilation guide",
      "menu-items.pagamenti": "Payments",
      "menu-items.riepilogo": "Summary",
      "menu-items.riepilogo-e-invio": "Summary and Submission",
      "module-attachments.anchor": "Module attachments",
      "module-attachments.conteggio-file_one": "{{count}} file",
      "module-attachments.conteggio-file_other": "{{count}} files",
      "module-attachments.titolo": "Module Attachments Summary",
      "module-form.avviso-rimozione-moduli": "Please note that once removed the data filled in on the forms will be lost. If reactivated later you will need to refill the forms.",
      "module-form.confermare-le-modifiche-ai-moduli": "Confirm form changes?",
      "module-form.moduli-da-compilare-in-aggiunta": "{{length}} new forms to fill out will be added:",
      "module-form.rimozione-del-modulo-corrente": "The following form will be removed:",
      "module-form.rimozione-moduli": "{{length}} forms will be removed:",
      "module-form.salvando-le-richieste-verranno-apportate-le-modifiche": "Saving the request will make the following changes:",
      "module-form.un-modulo-da-compilare-in-aggiunta": "The following form to fill out will be added:",
      "module-title.altro-modulo": "Other Form",
      "module-tooltip-text.completato": "Completed",
      "module-tooltip-text.in-attesa-della-firma": "Awaiting signature",
      "module-tooltip-text.in-fase-di-compilazione": "In compilation",
      "module-tooltip-text.modulo-non-valido": "Invalid form",
      "module-validation-state-text.compila": "Fill out",
      "module-validation-state-text.completato": "Completed",
      "module-validation-state-text.firma": "Sign",
      "module.state-progress-bar.stato-del-modulo": "Module State",
      "payment-burden-type-tag.bollo": "Stamp duty",
      "payment-burden-type-tag.modello-1": "Spontaneous online payment (Model 1)",
      "payment-burden-type-tag.modello-3": "Deferred payment notice (Model 3)",
      "payment-columns.codice": "Code",
      "payment-columns.importo": "Amount",
      "payment-columns.stato-pagamento": "Payment Status",
      "payment-state-tag.completato": "COMPLETED",
      "payment-state-tag.da-pagare": "TO PAY",
      "payment-state-tag.errore-pagamento": "PAYMENT ERROR",
      "payment-state-tag.pendente": "PENDING",
      "payment-table.azioni": "Actions",
      "payment-table.tipi": "Type",
      "payment.da-pagare-dopo-invio": "To be paid after submission",
      "quote-columns.data": "Date",
      "quote-columns.descrizione": "Description",
      "quote-columns.imponibile": "Taxable Amount",
      "quote-columns.importo": "Amount",
      "quote-columns.iva": "VAT",
      "quote-columns.numero": "Number",
      "quote-columns.stato": "Status",
      "quote-state-tag.attesa-approvazione": "Awaiting Approval",
      "quote-state-tag.attesa-pagamento": "Payment Pending",
      "quote-state-tag.pagato": "Paid",
      "quote-state-tag.rifiutato": "Rejected",
      "quote-table.azioni": "Actions",
      "quote-table.azioni.button-confirm.accept.message.accetta-preventivo-prima-riga": "Confirm that you have downloaded and read the quote in its entirety.",
      "quote-table.azioni.button-confirm.accept.message.accetta-preventivo-seconda-riga": "Do you confirm you want to accept the quote?",
      "quote-table.azioni.button-confirm.accept.text": "ACCEPT",
      "quote-table.azioni.button-confirm.refuse.message.rifiuto-preventivo": "Are you sure you want to reject the quote?",
      "quote-table.azioni.button-confirm.refuse.text": "REFUSE",
      "quote-table.azioni.button.aria-label.scarica-preventivo": "Download Quote",
      "quote-table.azioni.button.tooltips.scarica-preventivo": "Download Quote",
      "quote-table.errore-in-accettazione-preventivo": "A problem occurred while accepting the quote",
      "quote-table.errore-in-download-file": "A problem occurred while downloading the file",
      "riepilogo-firmato.annulla-e-ricarica-file-firmato": "Cancel and Re-upload Signed File",
      "riepilogo-firmato.documento-firmato": "Signed Summary",
      "riepilogo-firmato.download-riepilogo-richiesta": "Download Request Summary",
      "riepilogo-firmato.errore-in-upload": "A problem occurred while uploading the signed summary",
      "riepilogo-firmato.errore-verifica-firmato": "It was not possible to verify the presence of the signed summary. Reload the page to try again.",
      "riepilogo-firmato.procedura-firma-riepilogo": "Request Summary Signing Procedure",
      "riepilogo-firmato.riepilogo-firmato-caricato": "The request summary has been signed and uploaded.",
      "riepilogo-firmato.scarica-firma-ricarica-desc": "Download the Request Summary document, proceed with the digital signature and re-upload the signed document.",
      "riepilogo-firmato.scarica-pdf-firmato": "Download Signed Summary",
      "riepilogo-firmato.scarica-pdf-riepilogo": "Download Summary",
      "riepilogo-firmato.scarica-riepilogo-desc": "You can download the Request Summary document.",
      "riepilogo-firmato.upload-completato": "Signed summary uploaded successfully",
      "riepilogo-firmato.visualizza-pdf-firmato": "View Signed Summary",
      "riepilogo-firmato.visualizza-pdf-riepilogo": "View Summary",
      "shared-section.editable-label": "SHARED DATA SECTION",
      "shared-section.editable-tooltip": "This section is shared with other forms of the application. By modifying the data in this section, you will also modify the data of the other forms, invalidating them if they have already been completed or signed.",
      "shared-section.info-tooltip": "Information about the shared section",
      "shared-section.navigate-to-source": "Edit in the source form",
      "shared-section.readonly-label": "SHARED DATA SECTION — READ ONLY",
      "shared-section.readonly-tooltip": "This section comes from another form and cannot be modified here.",
      "signer.carica-e-completa": "Upload and Complete",
      "signer.certificato": "Certificate",
      "signer.certificato-in-validita": "Valid",
      "signer.certificato-non-ancora-valido": "Not yet valid",
      "signer.certificato-non-disponibile": "N/A",
      "signer.certificato-scaduto": "Expired",
      "signer.data-firma": "Signature date",
      "signer.ente-cert": "Cert. authority",
      "signer.firma-autografa": "Handwritten signature",
      "signer.firma-autografa-info": "Handwritten signature — certificate and timestamp data are not available.",
      "signer.firma-digitale": "Digital signature",
      "signer.firmatario-sconosciuto": "Unknown signer",
      "signer.formato-file-non-valido": "Invalid file format. Accepted extensions: {{extensions}}",
      "signer.modifica-file-firmato": "Change signed file...",
      "signer.nessun-file-selezionato": "No file selected",
      "signer.seleziona-file-firmato": "Select signed file...",
      "signer.seriale": "Serial",
      "signer.validita": "Validity",
      "signer.verifica-firma": "Signature Verification",
      "stamp-duty-payment.avvio-pagamento": "Starting payment...",
      "stamp-duty-payment.errore-avvio-pagamento": "An error occurred while starting the payment",
      "stamp-duty-payment.errore-modifica-stato-pagamento": "An error occurred while modifying the payment status",
      "start-payment-button.avvio-pagamento": "Starting payment...",
      "start-payment-button.errore-avvio-pagamento": "An error occurred while starting the payment",
      "submission-confirm-update.conferma-aggiornamento-modulo": "Do you confirm you want to update the form?",
      "submission-confirm-update.conferma-modifiche": "Confirm form activation changes",
      "submission-list.unknown-applicant": "Unknown applicant",
      "submission-menu-item.bolli": "Stamp Duties",
      "submission-menu-item.pagamenti": "Payments",
      "submission-menu-item.preventivi": "Quotes",
      "submission-menu-item.scheda-domanda": "Application Form",
      "submission-menu-item.sezione-disabilitata": "Section disabled",
      "submission-menu-items.altro-modulo": "Other Form",
      "submission-menu-items.modulo-principale": "Main Form",
      "submission-menu-items.sezione": "Section {{index}}",
      "submission-menu-label.aria-label.name-prefix": "Section",
      "submission-menu.count-badge.aria_one": "{{count}} attachment",
      "submission-menu.count-badge.aria_other": "{{count}} attachments",
      "submission-menu.navigazione-richiesta": "request navigation",
      "submission-menu.section.dirty-badge.dirty.sezione-da-salvare": "Section to save",
      "submission-menu.section.dirty-badge.error.sezione-non-valida": "Invalid section",
      "submission-menu.selezionato": "selected",
      "submission-module-button.errore-in-download": "A problem occurred while downloading the file",
      "submission-module-button.richiesta-non-pubblica": "Unable to download PDF with redactions: the request is not public",
      "submission-module-button.scarica-pdf": "Download PDF",
      "submission-module-button.scarica-pdf-firmato": "Download PDF",
      "submission-module-button.scarica-pdf-omissis": "Download redacted PDF",
      "submission-module-button.visualizza-pdf": "View PDF",
      "submission-module-button.visualizza-pdf-omissis": "View redacted PDF",
      "submission-payment-form.errore-richiesta": "An error occurred while loading the request. The request is not defined.",
      "submission-payment-form.errore-richiesta-titolo": "Request not defined",
      "submission-payment-form.oneri-bolli-da-pagare-dopo-invio": "Below you will find the payments to be made following submission",
      "submission-payment-form.pagamento-annullato": "Payment cancelled",
      "submission-payment-form.pagamento-completato": "The payment has been completed successfully",
      "submission-payment-form.pagamento-completato-con-successo": "Payment completed successfully",
      "submission-payment-form.pagamento-errore": "An error occurred during the payment",
      "submission-payment-form.seleziona-bolli": "Select stamp duties to proceed with payment",
      "submission-payment-form.seleziona-oneri": "Select fees to proceed with payment",
      "submission-state-tag.annullamento-in-corso": "CANCELLATION IN PROGRESS",
      "submission-state-tag.annullata": "ANNULLED",
      "submission-state-tag.bozza": "DRAFT",
      "submission-state-tag.cancellata": "CANCELLED",
      "submission-state-tag.conclusa": "CONCLUDED",
      "submission-state-tag.creata": "CREATED",
      "submission-state-tag.in-invio": "SUBMITTING",
      "submission-state-tag.integrata": "INTEGRATED",
      "submission-state-tag.integrata-dopo-richiesta-integrazione": "Integrated after integration request",
      "submission-state-tag.inviata": "SUBMITTED",
      "submission-state-tag.pagamento": "IN PAYMENT",
      "submission-state-tag.ricevuta": "RECEIVED",
      "submission-state-tag.richiesta-accettazione-preventivo": "Quote acceptance is required",
      "submission-state-tag.richiesta-integrazione": "Integration is required",
      "submission-state-tag.richiesta-pagamento-preventivo": "Quote payment is required",
      "submission-state-tag.sono-presenti-preventivi": "Quotes are present",
      "submission-summary.allegato-non-disponibile": "File not available",
      "submission-summary.azioni": "Actions",
      "submission-summary.cf-piva": "Fiscal Code / VAT Number",
      "submission-summary.codice": "Code",
      "submission-summary.comune-prevalente": "Main municipality",
      "submission-summary.copia-json": "Copy JSON",
      "submission-summary.dati-anagrafici": "Applicant Data",
      "submission-summary.dati-generali": "General Data",
      "submission-summary.delegato": "Delegate",
      "submission-summary.descrizione": "Description",
      "submission-summary.elenco-allegati": "Attachments List",
      "submission-summary.elenco-moduli": "Modules List",
      "submission-summary.email": "Email",
      "submission-summary.email-aria": "Send email to {{email}}",
      "submission-summary.errore-download-allegato": "An error occurred while downloading the file. Please try again.",
      "submission-summary.fattispecie": "Use case",
      "submission-summary.json-copiato": "JSON copied!",
      "submission-summary.modulo-json-errore": "An error occurred while loading the module data",
      "submission-summary.modulo-json-vuoto": "The module contains no filled-in data",
      "submission-summary.nome-file": "File name",
      "submission-summary.nome-modulo": "Module",
      "submission-summary.oggetto-richiesta": "Request subject",
      "submission-summary.pec": "PEC",
      "submission-summary.pec-aria": "Send certified email (PEC) to {{pec}}",
      "submission-summary.responsabile-procedimento": "Responsible for Procedure",
      "submission-summary.scarica": "Download",
      "submission-summary.stato": "Status",
      "submission-summary.stato-oneri": "Fee Status",
      "submission-summary.tag-altro-soggetto": "Other Party",
      "submission-summary.tag-legale-rappresentante": "Legal Representative",
      "submission-summary.tag-procuratore": "Attorney",
      "submission-summary.tag-supporto": "Support",
      "submission-summary.tag-titolare": "Owner",
      "submission-summary.tipo-domanda": "Inquiry type",
      "submission-summary.tipologia": "Type",
      "submission-summary.titolo": "Title",
      "submission-summary.type-persona-fisica": "Natural Person",
      "submission-summary.type-persona-giuridica": "Legal Entity",
      "submission-summary.ufficio-competente": "Office",
      "submission-summary.vai-al-modulo": "Go to module",
      "submission-summary.versione-pubblica-omissis": "Public version with Omissis",
      "submission-summary.visualizza": "View",
      "submission-summary.visualizza-json": "View JSON",
      "submission.richiesta": "Request",
      "summary-payments.allegato": "Attachment",
      "summary-payments.azioni": "Actions",
      "summary-payments.data-creazione": "Creation Date",
      "summary-payments.data-pagamento": "Payment Date",
      "summary-payments.importo": "Amount",
      "summary-payments.onere": "Fee",
      "summary-payments.oneri": "Fees",
      "summary-payments.pagamenti": "Payments",
      "summary-payments.tipo": "Type",
      "summary-payments.totale": "Total",
      "summary-payments.ufficio-destinatario": "Recipient Office",
      "summary-payments.vincolo": "Constraint",
      "alert-message.error.close-icon-label": "Close",
      "filter-bar.value-selected": "Value selected",
      "form.alert-message.content": "There are compilation errors ({{errors_count}})",
      "form.error-list.hide": "Hide {{errorCount}} errors",
      "form.error-list.hide_one": "Hide 1 error",
      "form.error-list.show-more": "Show more {{errorCount}} errors",
      "form.error-list.show-more_one": "Show 1 more error",
      "form.prevent-navigation.prompt": "Are you sure you want to leave the page? All unsaved changes will be lost",
      "form.reset-button.cancel": "Reset",
      "form.reset-button.tooltip-not-dirty": "There are no changes to reset",
      "form.submit-button.save": "Save",
      "form.submit-button.tooltip-not-dirty": "There are no changes to save",
      "inputs.async-select-input-meta.content": "Showing {{shown}} of {{total}}.",
      "inputs.async-select-input-meta.filter": "Type to filter and improve the results.",
      "inputs.async-select.caricamento-opzioni": "Loading...",
      "inputs.async-select.errore-caricamento-opzioni": "Error loading data",
      "inputs.async-select.nessun-risultato": "No results found",
      "inputs.date-input.clear-button": "Clear field",
      "inputs.date-input.error": "The entered date is not valid",
      "inputs.dragger-input-body.title": "Click or drag file to this area to upload",
      "inputs.dragger-input.info": "Allowed formats: {{formats}}",
      "inputs.dragger-input.title": "Click or drag file to this area to upload",
      "inputs.file-extension-select-input.placeholder": "Type and press enter to add a new format",
      "inputs.info-icon-row": "Click on the {{content}} preview icon",
      "inputs.rich-text-link-button.label": "URL",
      "inputs.rich-text-link-button.placeholder": "Enter link URL",
      "inputs.rich-text-menu-bar.align-center": "Align to center",
      "inputs.rich-text-menu-bar.align-left": "Align left",
      "inputs.rich-text-menu-bar.align-right": "Align right",
      "inputs.rich-text-menu-bar.bold": "Bold",
      "inputs.rich-text-menu-bar.color": "Color",
      "inputs.rich-text-menu-bar.hard-break": "Line break",
      "inputs.rich-text-menu-bar.heading-1": "H1",
      "inputs.rich-text-menu-bar.heading-2": "H2",
      "inputs.rich-text-menu-bar.heading-3": "H3",
      "inputs.rich-text-menu-bar.heading-4": "H4",
      "inputs.rich-text-menu-bar.heading-5": "H5",
      "inputs.rich-text-menu-bar.heading-6": "H6",
      "inputs.rich-text-menu-bar.heading-group": "Headings",
      "inputs.rich-text-menu-bar.italic": "Italic",
      "inputs.rich-text-menu-bar.justify-text": "Justify text",
      "inputs.rich-text-menu-bar.omissis": "Omissis",
      "inputs.rich-text-menu-bar.ordered-list": "Ordered list",
      "inputs.rich-text-menu-bar.strikethrough": "Strikethrough",
      "inputs.rich-text-menu-bar.text-extra-small": "Very small",
      "inputs.rich-text-menu-bar.text-large": "Large",
      "inputs.rich-text-menu-bar.text-normal": "Normal",
      "inputs.rich-text-menu-bar.text-sizes": "Text sizes",
      "inputs.rich-text-menu-bar.text-small": "Small",
      "inputs.rich-text-menu-bar.title": "Title",
      "inputs.rich-text-menu-bar.underline": "Underline",
      "inputs.rich-text-menu-bar.unordered-list": "List",
      "inputs.select.nessuna-opzione-disponibile": "(No available options)",
      "inputs.upload-input.aria": "Upload",
      "inputs.upload-input.title": "Upload file",
      "utils.decorate-with-form.submit": "Submit",
      "actor-permission-icon.permesso-firmare-modulo": "{{canSign}} sign the form.",
      "actor-permission-icons.can": "You can",
      "actor-permission-icons.cannot": "You cannot",
      "actor-permission-icons.permesso-compilare-modulo": "{{canCompile}} compilare il modulo.",
      "actor-permission-icons.permesso-visualizzazione-modulo": "{{canView}} view the form.",
      "actor-role-tag.tipo-utente-delegato": "You are {{tagOption}} of the Request.",
      "address-book.action.delete.success": "Contact deleted successfully.",
      "address-book.company.action.delete": "Delete Contact",
      "address-book.company.action.edit": "Edit Company",
      "address-book.company.action.view": "View Company",
      "address-book.company.certification.certified": "Data Certified by the Registro Imprese",
      "address-book.company.certification.certified-desc": "The company data has been imported and certified. Editing them manually will revoke the certification.",
      "address-book.company.certification.certified-desc-fallback": "Updating from the Registro Imprese will overwrite any manual changes.",
      "address-book.company.certification.enable-edit-button": "Edit manually",
      "address-book.company.certification.not-certified": "The entered data is not certified.",
      "address-book.company.certification.not-certified-fallback": "Update from the Registro Imprese to certify them - any manual changes will be overwritten.",
      "address-book.company.certification.not-certified-title": "Data not certified",
      "address-book.company.certification.update-button": "Update from Registro Imprese",
      "address-book.company.certification.update-error": "Update failed. Please try again later.",
      "address-book.company.create.import-info.description": "Enter the Fiscal Code to automatically import the data.",
      "address-book.company.create.import-info.description-fallback": "If the import is not successful, you will be able to fill in the fields manually.",
      "address-book.company.create.import-info.title": "Import data from the Registro Imprese",
      "address-book.company.detail.address": "Address",
      "address-book.company.detail.cap": "CAP Code",
      "address-book.company.detail.duplicate-fiscal-code-vat.body": "The combination of fiscal code and VAT number is already present in the system.",
      "address-book.company.detail.duplicate-fiscal-code-vat.title": "Warning: duplicate fiscal code and VAT number",
      "address-book.company.detail.fraction": "Fraction",
      "address-book.company.detail.house-number": "House Number",
      "address-book.company.detail.operational-legal-headquarters-same": "Operational Headquarters is the same as Registered Office",
      "address-book.company.detail.operational-legal-headquarters-same.false": "No",
      "address-book.company.detail.operational-legal-headquarters-same.true": "Yes",
      "address-book.company.import-button.import-error": "An error occurred during import. Please try again later.",
      "address-book.company.import-button.import-from-registry": "Import from Registro Imprese",
      "address-book.company.import-button.import-success": "Import successful",
      "address-book.company.import-button.tooltip-disabled": "Enter a Fiscal Code to enable search",
      "address-book.company.import-button.tooltip-enabled": "Import from Registro Imprese",
      "address-book.company.import-button.update-success": "Update successful",
      "address-book.company.import-company-failed.body.line1": "Import from the Registro Imprese failed.",
      "address-book.company.import-company-failed.body.line2": "It was not possible to retrieve the data at this time.",
      "address-book.company.import-company-failed.body.line3": "You can proceed with manually filling in the form and retry the automatic import later to certify the data.",
      "address-book.company.import-company-failed.title": "Import Failed",
      "address-book.company.list.errors.unable-to-load": "Unable to load the list of companies.",
      "address-book.company.list.persone-giuridiche-trovate-in-base-ai-filtri": "Companies found based on search filters.",
      "address-book.company.list.rimuovi-filtri": "Remove filters",
      "address-book.company.page.company-data": "Company Data",
      "address-book.company.page.legal-headquarters": "Legal Headquarters Data",
      "address-book.company.page.legal-representative": "Legal Representative Data",
      "address-book.company.page.legal-representative.error": "Error retrieving legal representative data: {{errorMessage}}",
      "address-book.company.page.legal-representative.select-legal-representative": "Select a legal representative",
      "address-book.company.page.legal-representative.use-legal-representative-data": "Retrieve data from an existing physical entity for the legal representative",
      "address-book.company.page.operational-headquarters": "Operational Headquarters Data",
      "address-book.country.unknown": "Unknown",
      "address-book.menu": "Contacts",
      "address-book.navigation-button.cancel-edit": "Cancel Edit",
      "address-book.navigation-button.edit": "Edit",
      "address-book.navigation-button.exit-edit": "Exit Edit Mode",
      "address-book.new-company": "New Company",
      "address-book.new-contact": "New Contact",
      "address-book.new-contact.company": "Company",
      "address-book.new-contact.person": "Person",
      "address-book.page.errors.unable-to-load": "Unable to load the contacts page. Please try again.",
      "address-book.pagina.briciole.rubrica": "Contacts",
      "address-book.pagina.tab.company": "Company",
      "address-book.pagina.tab.person": "Persons",
      "address-book.pagina.titolo": "Contacts",
      "address-book.person.action.delete": "Delete Contact",
      "address-book.person.action.edit": "Edit Person",
      "address-book.person.action.view": "View Person",
      "address-book.person.detail.born-in-italy.false": "Born abroad",
      "address-book.person.detail.born-in-italy.true": "Born in Italy",
      "address-book.person.detail.country": "Country",
      "address-book.person.detail.duplicate-fiscal-code": "Warning: Inserted Fiscal Code is already present in the system.",
      "address-book.person.detail.entered-in-register.no": "No",
      "address-book.person.detail.entered-in-register.yes": "Yes",
      "address-book.person.detail.fraction": "Fraction",
      "address-book.person.detail.gender.female": "Female",
      "address-book.person.detail.gender.male": "Male",
      "address-book.person.detail.resident-in-italy.false": "Resident abroad",
      "address-book.person.detail.resident-in-italy.true": "Resident in Italy",
      "address-book.person.detail.telephone": "Fixed Phone",
      "address-book.person.list.errors.unable-to-load": "Unable to load the list of persons.",
      "address-book.person.list.found": "Persons found based on search filters.",
      "address-book.person.list.remove-filter": "Remove filter",
      "address-book.person.page.anagraphic-data": "Anagraphic Data",
      "address-book.person.page.birth-data": "Birth Data",
      "address-book.person.page.contact-data": "Contact Data",
      "address-book.person.page.register-data": "Registration Data",
      "address-book.person.page.residence-data": "Residence Data",
      "advanced-search.data-deve-essere-successiva": "The date must be later than the field ${path}",
      "alert-message.warning.close-icon-label": "Close",
      "annulla-modifiche": "Cancel changes",
      "change-submission-manager-button.help-description.gestore": "The manager can fill in forms and delegate their editing and viewing. Submission is reserved for the holder or the attorney on their behalf. By removing yourself from the manager role, you may lose access to the request.",
      "change-submission-manager-button.help-description.procuratore": "The attorney can view the request, delegate individual forms, and change its manager, acting on behalf of the holder. Only if permission is granted, will they also be able to submit the request.",
      "change-submission-manager-button.input.can-submit.checkbox-text.assegna-procuratore-come-gestore": "Do you want to designate the Attorney as the Request Manager?",
      "change-submission-manager-button.input.can-submit.checkbox-text.permesso-di-invio": "Permission to Submit",
      "change-submission-manager-button.input.can-submit.help.assegna-come-gestore-help": "The Attorney will be able to fill in the request, assign delegates, or submit it if enabled. This can also be changed later.",
      "change-submission-manager-button.input.can-submit.help.permetti-al-procuratore-indicato-di-inviare-la-richiesta": "Allow the designated attorney to submit the request",
      "change-submission-manager-button.input.can-submit.label.assegna-come-gestore": "Assign as Manager",
      "change-submission-manager-button.input.can-submit.label.cognome": "Last Name",
      "change-submission-manager-button.input.can-submit.label.email": "E-mail",
      "change-submission-manager-button.input.can-submit.label.invio-richiesta": "Request Submission",
      "change-submission-manager-button.input.can-submit.label.nome": "First Name",
      "change-submission-manager-button.input.file.label.documento-di-delega": "Delegation Document",
      "change-submission-manager-button.input.file.upload-button.icon-aria-label.carica": "Upload",
      "change-submission-manager-button.input.file.upload-button.title.carica-documento-di-delega": "Upload Delegation Document",
      "change-submission-manager-button.input.fiscal-code.label.codice-fiscale": "Fiscal Code or Email",
      "change-submission-manager-button.input.fiscal-code.placeholder.codice-fiscale": "Fiscal Code or Email",
      "change-submission-manager-button.message.error.nessun-id-della-richiesta-trovato": "No request ID found",
      "change-submission-manager-button.message.error.si-e-verificato-un-errore-riprovare": "An error occurred. Please try again.",
      "change-submission-manager-button.message.success.aggiornato-con-successo": "successfully updated",
      "change-submission-manager-button.subject-name.gestore": "Manager",
      "change-submission-manager-button.subject-name.procuratore": "Attorney",
      "change-submission-manager-button.title-prexix.assegna-un": "Assign",
      "change-submission-manager-button.title-prexix.cambia": "Change",
      "change-submission-manager.conferma-cambio-gestore": "Confirm Manager change",
      "change-submission-manager.sicuro-di-voler-sostituire-il-gestore": "Are you sure you want to replace the request Manager? Once the operation is completed, you might lose the ability to access the request.",
      "common.annulla": "Cancel",
      "compilation-guide.avvia": "Start",
      "compilation-guide.domanda-non-trovata-in-archivio": "Request not found in archive id {{submissionId}}",
      "compilation-guide.impossibile-caricare-la-guida-alla-compilazione": "Unable to load the Request Guide",
      "compilation-module.impossibile-caricare-i-moduli": "Unable to load the Request Forms",
      "compilation-module.modulo-salvato-con-successo": "Form saved successfully",
      "create-request-button.error": "Error creating request",
      "delegate-username.nessuno": "None",
      "delegati-differenti-o-mancanti": "The forms have different or missing delegates",
      "delegation-column-base.delegati": "Delegates",
      "delegation-column-base.lettura": "Reading",
      "delegation-column-base.moduli": "Forms",
      "delegation-data-schema.abilita-compilazione": "Enable Compilation",
      "delegation-data-schema.abilita-firma": "Enable Signature",
      "delegation-data-schema.abilita-invio": "Enable Submission",
      "delegation-data-schema.codice-fiscale": "ID Code",
      "delegation-page.attorney": "Attorney",
      "delegation-page.azioni": "Actions",
      "delegation-page.manager": "Manager",
      "delegation-page.title": "Delegation Management",
      "delegation-page.torna-alla-richiesta": "Back to Request",
      "delegation-schema.documento-di-delega": "Delegation Document",
      "delegation.errore": "An error occurred. Try again.",
      "delegation.modifica-deleghe-moduli-drawer.delega-di-compilazione": "Compilation Delegation",
      "delegation.modifica-deleghe-moduli-drawer.delega-di-firma": "Signature Delegation",
      "delegation.modifica-deleghe-moduli-drawer.delegati": "Delegates",
      "delegation.modifica-deleghe-moduli-drawer.deleghe-aggiornate": "Delegations updated successfully",
      "delegation.modifica-deleghe-moduli-drawer.deleghe-di-visualizzazione": "View Delegations",
      "delegation.modifica-deleghe-moduli-drawer.moduli-selezionati": "Selected Forms",
      "delegation.modifica-deleghe-moduli-drawer.titolo": "Form Delegation Management",
      "delegation.page.breadcrumb.gestione-deleghe": "Delegation",
      "delegation.page.breadcrumb.richieste": "Requests",
      "delegation.page.button.gestisci-selezionati": "Manage Selected",
      "delegation.page.delegation-table.button.gestisci": "Manage",
      "delegation.page.delegation-table.checkbox.seleziona-modulo": "Select Form",
      "delegation.page.delegation-table.checkbox.seleziona-tutti-i-moduli": "Select All Forms",
      "delegation.page.divider-title.deleghe-dei-moduli": "Form Delegations",
      "delegation.page.error.impossibile-caricare-le-deleghe-della-richiesta": "Unable to load request delegations",
      "domanda-copertina.accedi": "Access",
      "domanda.bottone-compilare-una-richiesta-per-titolare": "Only one request can be compiled per holder for this application",
      "domanda.bottone-crea-richiesta.vai-alla-compilazione": "Go to compilation",
      "domanda.bottone-crea-richiesta.visualizza-anteprima": "View preview",
      "domande-secondarie.lista.elemento.etichetta.avviabile-dal": "Startable from",
      "domande-secondarie.lista.elemento.etichetta.scadenza-invio": "Submission deadline",
      "domande.lista.elemento.alt-immagine.copertina-domanda": "Request Cover",
      "domande.lista.elemento.etichetta.scadenza": "Expiration",
      "domande.lista.elemento.pulsante.vai-alla-domanda": "Go to Request",
      "domande.lista.pulsante.rimuovi-filtri": "Remove filters",
      "dossier-card-cover.dossier-link-button": "Go to Dossier",
      "dossier-page.errore-caricamento-pratica": "An error occurred while loading your Request.",
      "dossier-permission.delete-confirm-description": "Once removed, the subject will no longer have access to the request.",
      "dossier-permission.delete-confirm-title": "Remove permission?",
      "dossier-permission.gestione-permessi-creazione.errore": "Error while saving",
      "dossier-permission.gestione-permessi-creazione.successo": "Permission created successfully",
      "dossier-permission.gestione-permessi-drawer.titolo": "Add new subject",
      "dossier-permission.ruolo.editor": "Intermediary",
      "dossier-permission.ruolo.titolare": "Holder",
      "dossier-permission.ruolo.viewer": "Viewer",
      "dossier-permissions.get-list.generic-error": "An error occurred. Please try again.",
      "dossier-permissions.remove.error": "An error occurred while removing the subject",
      "dossier-permissions.remove.success": "Permission removed successfully",
      "dossier.list.errors.unable-to-load": "Unable to load the list of requests",
      "dossiers-list.dossierss-list-title": "List of requests",
      "dossiers-list.richieste": "Requests",
      "edit-modules-delegation-schema.delegati-alla-visualizzazione": "Delegates for viewing",
      "edit-modules-delegation-schema.delegato-alla-compilazione": "Delegate for compilation",
      "edit-modules-delegation-schema.delegato-alla-firma": "Delegate for signature",
      "errors-default.403.messaggio.non-autorizzato": "You do not have permissions to view the requested page.",
      "errors-default.403.titolo.non-autorizzato": "403 Not Authorized",
      "errors-default.404.messaggio.non-trovata": "Page Not Found.",
      "errors-default.404.titolo.non-trovato": "404 Not Found",
      "errors-default.500.messaggio.errore-interno-server": "An unexpected server error occurred. Please try again or contact support.",
      "errors-default.500.titolo.errore-interno-server": "500 Internal Server Error",
      "errors-default.generico.messaggio.errore-network": "An error occurred in the request.",
      "errors-default.generico.titolo.errore-network": "Network Error",
      "export.file": "Requests_{{data}}.{{fileExtension}}",
      "extended-filters-schema.categorie": "Categories",
      "extended-filters-schema.codice-fiscale-titolare": "Holder ID Code",
      "extended-filters-schema.cognome-titolare": "Holder Surname",
      "extended-filters-schema.data-avvio-compilazione-a": "Compilation Start Date To",
      "extended-filters-schema.data-avvio-compilazione-da": "Compilation Start Date From",
      "extended-filters-schema.data-invio-compilazione-a": "Compilation Submission Date To",
      "extended-filters-schema.data-invio-compilazione-da": "Compilation Submission Date From",
      "extended-filters-schema.email-titolare": "Holder Email",
      "extended-filters-schema.nome-titolare": "Holder Name",
      "extended-filters-schema.stato-delega": "Delegation Status",
      "extended-filters-schema.stato-richiesta": "Request Status",
      "extended-filters-schema.stato-tipo-domanda": "Request Type Status",
      "extended-filters-schema.tipo-domanda": "Request Type",
      "extended-filters-schema.titolo-tipo-domanda": "Request Type Title",
      "extended-filters-schema.valori-ricerca-estesa": "Extended Search Values",
      "folder.data": "Date",
      "folder.data-documento": "Document Date",
      "folder.descrizione": "Description",
      "folder.nome": "Name",
      "folder.protocollo": "Protocol",
      "folder.tipo": "Type",
      "form.alert-message.summary.content": "There are errors in the formal validation of the request submission ({{errors_count}})",
      "form.disable-submit-tooltip": "Submission is enabled only for the holder or attorney.",
      "form.errore-durante-invio": "An error occurred while sending",
      "form.errore-durante-validazione": "An error occurred during validation",
      "form.form-cannot-send-as-delegate-tooltip": "You cannot submit this request as the delegation does not allow submission",
      "form.form-not-completed-tooltip": "Incomplete compilation",
      "form.form-not-payed-tooltip": "Missing payments",
      "form.invia-la-domanda": "Submit Request",
      "form.invio-con-violazioni-avviso-annulla": "Cancel",
      "form.invio-con-violazioni-avviso-ok": "Submit anyway",
      "form.invio-con-violazioni-avviso-titolo": "Warning",
      "form.invio-effettuato-con-successo": "Submission completed successfully",
      "form.valida-istanza": "Validate request",
      "form.validazione-agid-errore-titolo": "Validation Errors",
      "form.validazione-card-descrizione": "Click the dedicated button to start the formal validation of the request.",
      "form.validazione-card-titolo": "Formal validation procedure of the request",
      "form.validazione-errore-sconosciuto": "Unknown Error",
      "form.validazione-successo-titolo": "Request validation completed successfully",
      "frontoffice.menu.profile.label": "Profile",
      "frontoffice.menu.profile.title": "Access Profile",
      "frontoffice.menu.settings.label": "***Impostazioni",
      "frontoffice.menu.settings.title": "***Accedi alle Impostazioni",
      "handle-modules-delegation-submit.id-richiesta-non-valido": "Invalid request ID. Try again.",
      "inquiry-cover.errore-caricamento-copertina-domanda": "Unable to load introduction page",
      "inquiry-cover.titolo-non-presente": "Title not present",
      "inquiry.ambito": "Scope",
      "inquiry.area-filter": "Administration",
      "inquiry.categorie": "Categories",
      "inquiry.cerca": "Search",
      "inquiry.competenza-territoriale": "Territorial Competence",
      "inquiry.destinatari": "Recipients",
      "inquiry.filtri": "Filters",
      "inquiry.filtri-di-ricerca": "Search filters",
      "inquiry.in-collaudo": "In testing",
      "inquiry.lista.briciole.domanda": "Request",
      "inquiry.lista.briciole.domande": "Requests",
      "inquiry.lista.errori.impossibile-caricare-la-sezione": "Unable to load the list of requests",
      "inquiry.lista.filtri-applicati.domande-mostrate-in-base-ai-filtri-di-ricerca": "requests found based on search filters.",
      "inquiry.lista.vuota.nessuna-domanda-da-mostrare": "No requests to show.",
      "inquiry.pubblicata": "Published",
      "inquiry.solo-attive": "Only Active",
      "inquiry.sotto-ambito": "Sub-Scope",
      "inquiry.stato": "Status",
      "inquiry.stato.aperta": "Open",
      "inquiry.stato.chiusa": "Closed",
      "inquiry.stato.in_corso": "In progress",
      "inquiry.stato.pubblicata": "Published",
      "inquiry.tipo-pubblicazione": "Publication Type",
      "inquiry.tipo-pubblicazione-filtro": "Publication",
      "inquiry.titolo": "Title",
      "inquiry.tutte-le-domande": "All Requests",
      "inserisci-cf-or-email-delegato": "Enter ID Code or Email for foreign user",
      "inserisci-codici-fiscali-o-email-delegati": "Enter ID Codes or Emails for foreign users",
      "integration-rows.nessuna-richiesta-attiva": "No active requests",
      "integration-rows.nessuna-richiesta-precedente": "No previous requests",
      "integration-rows.richieste-integrate": "Integrated Requests (list of previous requests)",
      "integration-rows.ultima-integrazione-della-richiesta": "Last request integration",
      "integration.data-creazione": "Creation Date:",
      "integration.data-invio": "Submission Date:",
      "integration.stato": "Status:",
      "integration.vai-alla-richiesta": "Go to request",
      "integration.vai-alla-richiesta-originale": "Go to the original request",
      "integration.vai-elenco-integrazioni": "Go to the list of integrations",
      "layout.footer.vai-all-inizio-pagina": "Go to the top of the page",
      "layout.header.menu-di.scelta-lingua": "Language selection menu",
      "layout.header.pulsante-notifiche_one": "{{count}} unread notification",
      "layout.header.pulsante-notifiche_other": "{{count}} unread notifications",
      "layout.skip-links.vai-al-contenuto-principale": "Go to main content",
      "layout.skip-links.vai-al-footer": "Go to Footer",
      "layout.skip-links.vai-al-menu-principale": "Go to main menu",
      "login-button.accedi": "Access",
      "main-menu.mobile.aria-label": "Main Menu",
      "main-menu.mobile.loading.aria-label": "Loading",
      "menu.le-mie-pratiche": "My Practices",
      "menu.le-mie-pratiche.sr-title": "Go to My Practices",
      "menu.le-mie-richieste": "My Requests",
      "menu.le-mie-richieste.sr-title": "Go to My Requests",
      "menu.notifiche": "Notifications",
      "menu.notifiche.sr-title": "Go to Notifications",
      "menu.principal-menu": "Main Menu",
      "menu.tutte-le-domande": "All Requests",
      "menu.tutte-le-domande.sr-title": "Go to All Requests",
      "modifica-tutti": "Edit all",
      "module-listname.da-firmare": "To be signed",
      "modules-delegations.view.abilita-deleghe": "Enable delegations",
      "modules-previous-delegations-summary.delegati-precedenti": "Previous delegates:",
      "notification-drawer.button.badge": "Notifications to read",
      "notification-list.pagina.titolo": "Notification List",
      "notifiche-titolo-colonna.azioni": "Actions",
      "notifiche-titolo-colonna.numero-istanza": "Instance Number",
      "observation-details.allegato-del-procedimento": "Procedure attachment",
      "observation-details.allegato-della-richiesta": "Request attachment",
      "observation-details.altri-titolari": "Other holders",
      "observation-details.apri-cartella": "Open folder {{recordName}}",
      "observation-details.apri-documento": "Open Document {{record}}",
      "observation-details.azioni": "Actions",
      "observation-details.chiudi-cartella": "Close folder {{recordName}}",
      "observation-details.comunicazione": "Communication",
      "observation-details.dati-della-richiesta": "Request Data",
      "observation-details.documenti": "Documents",
      "observation-details.documento": "Document",
      "observation-details.domanda": "Request",
      "observation-details.numero-istanza": "Instance Number",
      "observation-details.titolare": "Holder",
      "observation.area-pubblica": "Public Area",
      "observation.Cognome-titolare": "Holder Surname",
      "observation.data-invio": "Submission Date",
      "observation.data-protocollo": "Protocol Date",
      "observation.dati-del-procedimento": "Procedure Data",
      "observation.domanda": "Request",
      "observation.domande-trovate-in-base-ai-filtri-di-ricerca": "requests found based on search filters.",
      "observation.errore-durante-il-caricamento": "An error occurred while loading.",
      "observation.fine-osservazione": "Observation End",
      "observation.impossibile-caricare-elenco-area-pubblica": "Unable to load the Public Area list",
      "observation.inizio-osservazione": "Observation Start",
      "observation.numero-istanza": "Application Number",
      "observation.numero-istanza-suffix": "Application Number:",
      "observation.numero-procedimento": "Procedure Number",
      "observation.numero-procedimento-suffix": "Procedure Number:",
      "observation.numero-protocollo": "Protocol Number",
      "observation.nuova-osservazione": "New Observation",
      "observation.oggetto": "Subject",
      "observation.oggetto-procedimento": "Request Subject",
      "observation.osservabile": "Observable",
      "observation.periodo-osservazione": "Observation period",
      "observation.procedimento": "Procedure",
      "observation.record-albo-trovati-in-base-ai-filtri-di-ricerca": "records found based on search filters.",
      "observation.rimuovi-filtri": "Remove filters",
      "observation.stato": "Status",
      "observation.titolare": "Holder",
      "observation.titolo-domanda": "Request Title",
      "observation.ufficio-responsabile": "Responsible Office",
      "possibile-modificare-tutti-i-moduli-con-un-nuovo-delegato": "You can edit all forms with a new delegate",
      "pratica.dettaglio.domande-presentabili": "Submittable inquiries",
      "pratica.dettaglio.richieste-presentate": "Submitted requests",
      "pratiche.avvio-domande-secondarie.error-no-id": "Error while starting the request. Please try again.",
      "pratiche.avvio-domande-secondarie.error-no-params": "Error while starting the request. Missing parameters.",
      "pratiche.avvio-domande-secondarie.success": "Request started successfully",
      "pratiche.dati": "Data",
      "pratiche.dettaglio": "Practice detail",
      "pratiche.domanda-secondaria.tooltip-errore-avvio-end": "Request can be started until {{endDate}}",
      "pratiche.domanda-secondaria.tooltip-errore-avvio-full": "Request can be started from {{startDate}} to {{endDate}}",
      "pratiche.domanda-secondaria.tooltip-errore-avvio-start": "Request can be started from {{startDate}}",
      "pratiche.domande.avvia-domanda-secondaria": "Go to Request",
      "pratiche.errore.network": "Error while loading the practice",
      "pratiche.errore.no-id": "No ID found in the request.",
      "pratiche.info": "Information",
      "pratiche.permissions": "Permissions and Visibility",
      "pratiche.pratiche": "Practices",
      "pratiche.submissions": "Requests",
      "progressive-number-filter.anno": "Year",
      "progressive-number-filter.numero-istanza": "Instance number",
      "register-records.menu": "Register Records",
      "remove-submission-attorney-button.errore": "An error occurred. Try again.",
      "remove-submission-attorney-button.procuratore-rimosso-con-successo": "Attorney successfully removed",
      "remove-submission-attorney-button.rimuovere-attuale-procuratore": "Remove current Attorney?",
      "remove-submission-attorney-button.rimuovi-procuratore": "Remove Attorney",
      "richieste.firma.messaggio-errore-caricamento-file": "Error during file upload, please retry",
      "richieste.firma.messaggio-successo-caricamento-file": "The signed file has been uploaded correctly.",
      "richieste.firma.procedura-firma-modulo": "Form signing procedure",
      "richieste.firma.scaricare-il-modulo-per-procedere-alla-firma": "Download the <title/> as PDF file, then add your digital signature to it and reload the signed file.",
      "scanner-qr.camera-error": "An error occurred while accessing the camera: {{error}}",
      "scanner-qr.permission-denied": "Please make sure you have granted the necessary permissions or that your device has a working camera.",
      "selected-modules-text.moduli-selezionati": "{{selectedRows}} forms selected",
      "selected-modules-text.un-modulo-selezionato": "1 form selected",
      "signed-module.documento-modulo-firmato": "Request form signed",
      "signed-module.errore-in-download-file": "There was a problem downloading the file. Try again.",
      "signed-module.file-non-trovato": "File not found",
      "submission-action-button.carica-documento-firmato-per-continuare": "Upload a signed document to continue",
      "submission-action-button.compilazione-terminata": "Filling completed",
      "submission-action-button.conferma-firma": "Confirm signature",
      "submission-action-button.errore": "An error occurred please try again",
      "submission-action-button.firma-delegata": "The signature is delegated to another user.",
      "submission-action-button.in-attesa-compilazione-delegato": "Awaiting filling by the delegate.",
      "submission-action-button.modulo-compilato": "The form has been filled out.",
      "submission-action-button.modulo-compilato-e-firmato": "The form has been filled out and signed. By returning to modify the form you will need to sign it again.",
      "submission-action-button.modulo-compilato-e-firmato-precedentemente": "The form has already been filled out and signed.",
      "submission-action-button.modulo-compilato-precedentemente": "The form has already been filled out.",
      "submission-action-button.modulo-compilato-ritornare-in-compilazione-per-modificare": "The form has been filled out you can return to editing it out if changes are necessary.",
      "submission-action-button.modulo-completato": "Completed form",
      "submission-action-button.modulo-non-valido": "The form is not valid",
      "submission-action-button.modulo-nuovamente-compilabile": "Form etitable again",
      "submission-action-button.modulo-pronto-per-la-firma": "Form ready for signature",
      "submission-action-button.per-procedere-alla-firma-segnare-come-pronto": "To proceed with digital signature mark the form as Ready for signature.",
      "submission-action-button.pronto-per-la-firma": "Ready for signature",
      "submission-action-button.ritorna-in-compilazione": "Return to compilation",
      "submission-action-button.salva-modulo": "Save the form to continue",
      "submission-action-button.se-completato-il-modulo-premi-compilazione-terminata": "If you have completed the form press the Completed button.",
      "submission-clone-button.chiudi": "Close",
      "submission-clone-button.duplica": "Duplicate",
      "submission-clone-button.duplica-richiesta": "Duplicate Request",
      "submission-clone-button.errore-durante-la-duplicazione-della-richiesta": "An error occurred while duplicating the request.",
      "submission-clone-button.errore-nel-duplicare-la-richiesta": "Error duplicating the request",
      "submission-clone-button.la-richiesta-deve-essere-salvata-per-duplicare": "The request must be saved to be duplicated.",
      "submission-clone-button.la-richiesta-verra-duplicata-senza-i-file-allegati": "The request will be duplicated without attached files.",
      "submission-clone-button.richiesta-duplicata-con-successo": "Request duplicated successfully.",
      "submission-clone-button.sei-sicuro-di-voler-duplicare-la-richiesta": "Are you sure you want to duplicate the request?",
      "submission-columns.data-creazione": "Creation date",
      "submission-columns.data-invio": "Submission date",
      "submission-columns.data-modifica": "Modification date",
      "submission-columns.domanda": "Request",
      "submission-columns.fase": "Phase",
      "submission-columns.numero-istanza": "Instance Number",
      "submission-columns.numero-protocollo": "Protocol Number",
      "submission-columns.oggetto": "Subject",
      "submission-columns.richiedente": "Submitter",
      "submission-columns.stato": "Status",
      "submission-columns.titolare": "Holder",
      "submission-columns.ufficio-responsabile": "Responsible Office",
      "submission-delegation-drawer.abilita-compilazione-della-richiesta": "Enable to edit request",
      "submission-delegation-drawer.abilita-firma-della-richiesta": "Enable to sign request",
      "submission-delegation-drawer.abilita-invio-della-richiesta": "Enable to submit request",
      "submission-delegation-drawer.annulla": "Cancel",
      "submission-delegation-drawer.carica-documento-di-delega": "Upload Delegation Document",
      "submission-delegation-drawer.codice-fiscale-partita-iva": "Tax code/VAT number",
      "submission-delegation-drawer.delega-inviata-con-successo": "Delegation sent successfully",
      "submission-delegation-drawer.delega-richiesta": "Delegate request",
      "submission-delegation-drawer.documento-di-delega": "Delegation document",
      "submission-delete-delegation-button.codice-fiscale-delegato": "Delegate {{delegateFiscalCode}}",
      "submission-delete-delegation-button.delega-rimossa-con-successo": "Delegation removed successfully ",
      "submission-delete-delegation-button.rimuovi-delega": "Remove delegation",
      "submission-delete-delegation-button.sicuro-di-voler-rimuovere-delega": "Are you sure you want to remove this delegation?",
      "submission-details.comunicazioni": "Communications",
      "submission-details.integrazioni": "Integrations",
      "submission-details.la-mia-richiesta": "My request",
      "submission-details.pagamenti": "Payments",
      "submission-details.ricevuta-invio": "Submission receipt",
      "submission-filter-form-mobile.codice-fiscale-titolare": "Holder Tax Code",
      "submission-filter-form-mobile.cognome-titolare": "Holder Surname",
      "submission-filter-form-mobile.nome-titolare": "Holder Name",
      "submission-filter.categorie": "Categories",
      "submission-filter.codice-fiscale-titolare": "Holder Tax Code",
      "submission-filter.cognome-titolare": "Holder Surname",
      "submission-filter.nome-titolare": "Holder Name",
      "submission-filter.ricerca-estesa": "Extended Search",
      "submission-filter.seleziona-le-categorie": "Select categories",
      "submission-filter.stato-delega": "Delegation Status",
      "submission-form.compilazione-richiesta-incompleta": "Request Compilation Incomplete",
      "submission-form.errore-in-caricamento-domanda": "An error occurred during request loading.",
      "submission-form.errore-in-caricamento-richiesta": "An error occurred during request loading.",
      "submission-form.errore-moduli-incompleti-per-poter-procedere": "Some forms are incomplete or have errors. All forms must be compiled to proceed with submission.",
      "submission-form.errore-oneri-non-pagati-per-poter-procedere": "Some charges are unpaid. All mandatory charges must be paid in order to proceed with the submission.",
      "submission-form.id-della-richiesta-non-valido": "Invalid request ID",
      "submission-form.integrazione-di-un-altra-richiesta": "This is an integration of another request.",
      "submission-form.inviare-per-procedere-al-pagamento": "Proceed with Request Submission to make charge payments.",
      "submission-form.invio-in-corso": "Submission in progress...",
      "submission-form.stato-pagamenti-incompleto": "Payment status incomplete",
      "submission-integration-button.avvia": "Start",
      "submission-integration-button.integra-la-richiesta": "Integrate the Request",
      "submission-integration-button.sicuro-avviare-integrazione": "Are you sure you want to start the integration?",
      "submission-linked-button.visualizza-richiesta": "View request",
      "submission-list.annulla-richiesta": "Undo Request",
      "submission-list.apri-pagina-compilazione-richiesta": "Open the request compilation page",
      "submission-list.apri-pagina-dettaglio-richiesta": "Open the request detail page",
      "submission-list.compilazione-richiesta": "Fill request",
      "submission-list.domande-trovate-in-base-ai-filtri": "requests found based on search filters.",
      "submission-list.duplica-richiesta": "Duplicate request",
      "submission-list.errore-eliminazione-richiesta": "Error deleting request",
      "submission-list.impossibile-caricare-elenco-richieste": "Unable to load request list",
      "submission-list.richiesta-eliminata-con-successo": "Request deleted successfully ",
      "submission-list.richieste": "Requests",
      "submission-list.rimuovi-filtri": "Remove filters",
      "submission-list.submissions-list-title": "Request List",
      "submission-list.visualizza-richiesta": "View request",
      "submission-module.il-gestore": "the Manager",
      "submission-module.il-procuratore": "the Attorney",
      "submission-module.il-titolare": "the Holder",
      "submission-module.modulo-completato": "The form is completed.",
      "submission-module.modulo-disponibile-alla-firma-al-termine-della-compilazione": "The form will be available for signature after compilation.",
      "submission-module.necessario-compilare-il-modulo": "The form must be compiled.",
      "submission-module.necessario-firmare-il-modulo": "The form must be signed.",
      "submission-module.permesso-utente-modulo": "You have permission to <permissionsText/> this Form.",
      "submission-module.ruolo-utente-della-richiesta": "You are the <roleText/> of the Request.",
      "submission-module.stai-visualizzando-in-sola-lettura-il-modulo": "You are viewing this form in read-only mode.",
      "submission-module.un-delegato": "a Delegate",
      "submission-payment.annulla-pagamenti-e-ritorna-in-bozza": "Cancel payments and return to draft",
      "submission-payment.conferma-a-procedere": "Are you sure you want to proceed?",
      "submission-payment.in-payment-banner-action": "Return to draft",
      "submission-payment.in-payment-banner-title": "Your request is being processed for payment. Once the stamp duties are paid, you can submit it, otherwise you can return it to draft to make changes.",
      "submission-payment.in-payment-banner-title-no-cancel": "Your request is being processed for payment. Once the stamp duties are paid, you can submit it.",
      "submission-payment.rieffettuare-il-pagamento-a-seguito-di-riportare-in-bozza": "Bringing the request back to draft will invalidate <bold>all paid stamps</bold> and require re-payment.",
      "submission-searchable-fields.anno-istanza": "Instance Year ",
      "submission-searchable-fields.annullamento-in-corso": "Cancellation in progress",
      "submission-searchable-fields.annullata": "Cancelled",
      "submission-searchable-fields.bozza": "Draft",
      "submission-searchable-fields.categoria": "Category",
      "submission-searchable-fields.codice-fiscale-titolare": "Holder ID Code",
      "submission-searchable-fields.cognome-titolare": "Holder Surname",
      "submission-searchable-fields.conclusa": "Concluded",
      "submission-searchable-fields.data-avvio-compilazione-al": "Compilation Start Date To",
      "submission-searchable-fields.data-avvio-compilazione-dal": "Compilation start date from",
      "submission-searchable-fields.data-creazione": "Creation date",
      "submission-searchable-fields.data-invio": "Submission Date",
      "submission-searchable-fields.data-invio-al": "Submission Date To",
      "submission-searchable-fields.data-invio-dal": "Submission Date From",
      "submission-searchable-fields.integrata": "Integrated",
      "submission-searchable-fields.inviata": "Submitted",
      "submission-searchable-fields.nome-titolare": "Holder Name",
      "submission-searchable-fields.numero-istanza": "Instance Number",
      "submission-searchable-fields.oggetto": "Subject",
      "submission-searchable-fields.ricerca-estesa": "Extended Search",
      "submission-searchable-fields.ricevuta": "Receipt",
      "submission-searchable-fields.seleziona-le-categorie": "Select categories",
      "submission-searchable-fields.soggetto-richiesta-nome-placeholder": "Company...",
      "submission-searchable-fields.stato-delega": "Delegation Status",
      "submission-searchable-fields.stato-richiesta": "Request Status",
      "submission-searchable-fields.titolare-codice-fiscale-impresa": "Business Owner: Tax Code",
      "submission-searchable-fields.titolare-codice-fiscale-impresa-placeholder": "Tax Code...",
      "submission-searchable-fields.titolare-codice-rea-impresa": "Business Owner: REA Code",
      "submission-searchable-fields.titolare-codice-rea-impresa-placeholder": "REA Code...",
      "submission-searchable-fields.titolare-denominazione-impresa": "Business Owner: Name",
      "submission-searchable-fields.titolare-partita-iva-impresa": "Business Owner: VAT Number",
      "submission-searchable-fields.titolare-partita-iva-impresa-placeholder": "VAT Number...",
      "submission-searchable-fields.titolo-tipo-domanda": "Request Type Title",
      "submission-sent-form.annullamento-in-corso": "The cancellation of the request is in progress. Editing, integration, delegation and sending of communications are suspended until it is completed.",
      "submission-sent-form.apri-integrazione-in-bozza": "Open Draft Integration",
      "submission-sent-form.errore-in-caricamento-domanda": "An error occurred while loading the question.",
      "submission-sent-form.errore-in-caricamento-richiesta": "An error occurred while loading the request.",
      "submission-sent-form.errore-in-integrazione-richiesta": "An error occurred while integrating your request please try again.",
      "submission-sent-form.id-della-richiesta-non-valido": "Invalid request ID",
      "submission-sent-form.integrazione-creata-con-successo": "Integration created successfully",
      "submission-sent-form.integrazione-di-un-altra-richiesta": "This is an integration of another request.",
      "submission-sent-form.integrazione-in-bozza": "A draft integration for this request exists.",
      "submission-sent-form.integrazione-non-consentita-annullamento": "Operation not allowed: a cancellation of the request is in progress.",
      "submission-sent-form.procedimento": "Procedure:",
      "submission-sent-form.richiesta-integrata": "This request has been integrated.",
      "submission-sent-form.richieste": "Requests",
      "submission-sent-tab-communications.comunicazione-creata-con-successo": "Communication created successfully ",
      "submission-sent-tab-communications.comunicazione-eliminata-con-successo": "Communication deleted successfully ",
      "submission-sent-tab-communications.comunicazione-modificata-con-successo": "Communication modified successfully ",
      "submission-sent-tab-communications.comunicazioni-trovate-in-base-ai-filtri": "communications found based on search filters.",
      "submission-sent-tab-communications.errore-caricamento-allegato": "Unable to load attachment",
      "submission-sent-tab-communications.errore-caricamento-comunicazioni": "Unable to load communications",
      "submission-sent-tab-communications.errore-creazione-comunicazione": "Unable to create communication",
      "submission-sent-tab-communications.errore-eliminazione-comunicazione": "Unable to delete communication",
      "submission-sent-tab-communications.errore-invio-no-id": "Error during submission: No request ID found.",
      "submission-sent-tab-communications.errore-modifica-comunicazione": "Unable to modify communication",
      "submission-sent-tab-communications.errore-segna-letta": "***Impossibile segnare la comunicazione come letta",
      "submission-sent-tab-communications.errore-segna-letta-no-id": "***Errore durante la presa lettura: Nessun ID trovato per la richiesta.",
      "submission-sent-tab-communications.errore-tab-comunicazioni": "An error occurred",
      "submission-sent-tab-communications.no-submission-id-error-message": "Error during saving: No request ID found.",
      "submission-sent-tab-communications.nuova-comunicazione": "New Communication",
      "submission-sent-tab-communications.rimuovi-filtri": "Remove filters",
      "submission-summary.riepilogo-richiesta": "Request Summary",
      "submission-undo-button.annulla": "Cancel Request",
      "submission-undo-button.annulla-la-richiesta": "Cancel the Request",
      "submission-undo-button.annullamento-inoltrato": "Cancellation request submitted. The request will remain suspended until the cancellation is confirmed.",
      "submission-undo-button.chiudi": "Close",
      "submission-undo-button.conferma-annullamento": "Are you sure you want to cancel the request?",
      "submission-undo-button.errore-annullamento": "Error while cancelling the request",
      "submission-undo-button.richiesta-annullata": "Request successfully cancelled",
      "submission-undo-button.richiesta-non-annullabile": "The request cannot be cancelled: the procedure has been concluded or a cancellation is already in progress.",
      "submission.codice-richiesta": "Request code:",
      "submission.data-invio": "Submission Date:",
      "submission.data-protocollo": "Protocol date:",
      "submission.delegation-banner.stai-commpilando-in-delega-la-richiesta": "You are compiling this request on delegation.",
      "submission.delegation-button": "Delegate the Request",
      "submission.documento-firmato": "Signed Document",
      "submission.fase-procedimento": "Procedure phase:",
      "submission.info.aria.titolare-e-procuratore": "Owner and attorney",
      "submission.info.titolare-e-procuratore": "Owner and attorney",
      "submission.numero-istanza": "Instance number:",
      "submission.numero-procedimento": "Procedure Number:",
      "submission.numero-protocollo": "Protocol number:",
      "submission.oggetto-richiesta": "Subject:",
      "submission.procuratore": "Attorney",
      "submission.responsabile-procedimento": "Procedure manager:",
      "submission.richiesta-inviata-con-successo": "Request submitted successfully!",
      "submission.richiesta-inviata-correttamente-da-prendere-in-carico": "The request has been correctly submitted and will be processed shortly.",
      "submission.salva-modulo-per-caricare-file-firmato": "Save the form to upload the signed file",
      "submission.seleziona-file-firmato": "Select signed file...",
      "submission.stato-richiesta": "Request status:",
      "submission.titolare": "Owner",
      "submission.ufficio-responsabile-procedimento": "Responsible office:",
      "submission.vai-ai-pagamenti": "Go to the Payments section to view and manage the quote",
      "tag-options.delegato": "Delegate",
      "tag-options.gestore": "Manager",
      "tag-options.procuratore": "Attorney",
      "tag-options.titolare": "Holder",
      "tag-options.utente": "User",
      "ui.cerca": "Search",
      "ui.filtri-di-ricerca": "Search filters",
      "ui.nessun-filtro-modificato": "No filters changed",
      "ui.rimuovi-filtri": "Remove Filters",
      "update-delegation-data-schema.abilita-delega": "Enable delegation",
      "update-delegation-data-schema.conferma-modifica": "Confirm change",
      "update-delegation-data-schema.delegato": "Delegate",
      "user-profile-nationality.EU": "eIDAS countries",
      "user-profile-nationality.extra-EU": "Other countries",
      "user-profile-nationality.italy": "Italian",
      "user-registration-form.divider-title": "Personal data",
      "user-registration-form.email": "E-mail",
      "user-registration-form.nationality": "Nationality",
      "user-registration-form.nationaly-eidas-help": "You can consult <2>the list of countries that support eIDAS Login for Italy</2>.",
      "user-registration-form.password": "Password",
      "user-registration-form.password-confirm": "Confirm Password",
      "user-registration-form.profile.familyName": "Surname",
      "user-registration-form.profile.name": "Name",
      "user-registration-form.top-title": "Access Data",
      "user-registration.back-to-login": "Return to login",
      "user-registration.country.unkown": "Unknown",
      "user-registration.form.submit-button": "Register",
      "user-registration.ue-citizen-message": "Are you a EU or Italian citizen? Log in with SPID or CIE.",
      "user.activation.breadcrumb": "User Activation",
      "user.activation.error.id": "Activation ID not valid",
      "user.activation.error.token": "Invalid token",
      "user.activation.response.error.back-button": "Back to Login",
      "user.activation.response.error.sub-title": "Email verification failed.",
      "user.activation.response.error.title": "Email verification error",
      "user.activation.response.success.sub-title": "Log in with the email and password entered in the registration form.",
      "user.activation.response.success.submit-button": "Go to Login",
      "user.activation.response.success.title": "Registration Completed!",
      "user.activation.submit-button": "Activate User",
      "user.activation.text": "Click the button below to complete your Email Verification.",
      "user.activation.title": "Verify Email",
      "user.change-password": "Change Password",
      "user.conferma-password": "Confirm Password",
      "user.current-password": "Current Password",
      "user.errore-in-verifica-mail": "Email verification error",
      "user.forgot-password.api-error-generic": "An error occurred during password recovery. Please retry.",
      "user.forgot-password.breadcrumb": "Reset password",
      "user.forgot-password.button-text": "Send me an email",
      "user.forgot-password.text": "Enter the email you registered with. You will receive a link to reset your password via email.",
      "user.forgot-password.title": "Forgot Password?",
      "user.le-password-non-coincidono": "Passwords do not match.",
      "user.new-password": "New Password",
      "user.password": "Password",
      "user.password-change.breadcrumb": "Change Password",
      "user.password-change.error.message": "Unable to change password.",
      "user.password-change.form.password-confirm": "Confirm Password",
      "user.password-change.form.password-repeat": "Repeat Password",
      "user.password-change.form.submit-button": "Change Password",
      "user.password-change.response.error.sub-title": "Unable to reset password.",
      "user.password-change.response.error.title": "Password Change Error",
      "user.password-change.response.success.back-to-inquiry": "Back to Requests",
      "user.password-change.response.success.submit-button": "Back to Profile",
      "user.password-change.response.success.title": "Password changed successfully",
      "user.password-change.success": "Password Modified",
      "user.password-change.text": "Enter the new password for the user",
      "user.password-change.title": "Modify Password",
      "user.password-reset-request.response.success.button-login": "Back to Login",
      "user.password-reset-request.response.success.subtitle": "Check your email inbox. We sent you an email with instructions to reset your password.",
      "user.password-reset-request.response.success.title": "Password change request sent",
      "user.password-reset.breadcrumb": "Reset Password",
      "user.password-reset.error.id": "Verification ID not valid",
      "user.password-reset.error.message": "Unable to reset the password.",
      "user.password-reset.error.token": "Invalid token",
      "user.password-reset.form.password-confirm": "Repeat Password",
      "user.password-reset.form.submit-button": "Reset Password",
      "user.password-reset.response.error.sub-title": "Unable to reset the password.",
      "user.password-reset.response.error.title": "Password Reset Error",
      "user.password-reset.response.success.button-login": "Log in",
      "user.password-reset.response.success.submit-button": "Back to Login",
      "user.password-reset.response.success.title": "Password reset successfully!",
      "user.password-reset.success": "Password reset successfully!",
      "user.password-reset.text": "Enter the new password for the user",
      "user.password-reset.title": "Reset password",
      "user.registration.breadcrumb": "User Registration",
      "user.registration.email-validation.message": "Hello <1>{{fullName}}</1>, authentication was successful. Enter your email to complete your profile and proceed with online services access.",
      "user.registration.email-validation.response.success.sub-title-generic": "To activate the user, follow the instructions we sent via email.",
      "user.registration.email-validation.response.success.title": "Registration Completed Successfully!",
      "user.registration.form.submit-button": "Register",
      "user.registration.form.top-title": "Access Data",
      "user.registration.response.error.message": "An error occurred during registration",
      "user.registration.response.success.sub-title": "We sent you an email with instructions to activate your account. Once activated, you can log in to the portal.",
      "user.registration.response.success.submit-button": "Back to Requests",
      "user.registration.response.success.title": "Registration Completed!",
      "user.settings.app-io-channel": "***Notifica su App IO",
      "user.settings.app-io-channel-description": "***Ricevi un avviso su App IO quando è disponibile una nuova comunicazione",
      "user.settings.breadcrumb": "***Impostazioni",
      "user.settings.channels-title": "***Canali per le comunicazioni di cortesia",
      "user.settings.email-channel": "***Notifica via e-mail",
      "user.settings.email-channel-description": "***Ricevi un avviso via e-mail quando è disponibile una nuova comunicazione",
      "user.settings.notification-email": "***Indirizzo e-mail",
      "user.settings.notification-email-help": "***Indirizzo dedicato alle comunicazioni di cortesia, distinto dalle e-mail indicate nelle pratiche.",
      "user.settings.notification-email-placeholder": "***nome@esempio.it",
      "user.settings.save-button": "***Salva Impostazioni",
      "user.settings.save-error": "***Si è verificato un errore durante il salvataggio delle impostazioni",
      "user.settings.save-success": "***Impostazioni salvate con successo",
      "verifica-tesserino.breadcrumb": "Card Verification",
      "verifica-tesserino.cerca": "Search",
      "verifica-tesserino.codice": "Code:",
      "verifica-tesserino.codice-tesserino-manualmente": "Card code (manual entry)",
      "verifica-tesserino.data-emissione": "Issue Date:",
      "verifica-tesserino.data-scadenza": "Expiry Date:",
      "verifica-tesserino.description": "Scan the card QR code, or enter the card code in the field below.",
      "verifica-tesserino.numero": "Number:",
      "verifica-tesserino.nuova-ricerca": "New search",
      "verifica-tesserino.result.error.errore": "Error:",
      "verifica-tesserino.result.error.errore-caricamento": "Unable to load card information",
      "verifica-tesserino.result.stato-tesserino": "{{stato}}",
      "verifica-tesserino.result.tesserino-attivo.description": "View the card information in the table below.",
      "verifica-tesserino.result.tesserino-non-trovato": "Card not found!",
      "verifica-tesserino.result.tesserino-non-trovato.description": "Card not found in the list of active cards.",
      "verifica-tesserino.stato": "Status:",
      "verifica-tesserino.tipo-tesserino": "Card Type:",
      "verifica-tesserino.titolo": "Card Verification",
      "verifica-tesserino.torna-alla-ricerca": "Back to search",
      "verification-labels.click-sul-pulsante-per-completare-l-verifica": "To complete verification click the button",
      "verification-labels.click-sul-pulsante-per-completare-la-verifica": "To complete email verification click the button",
      "verification-labels.verifica": "Verify",
      "verification-labels.verifica-email": "Verify Email",
      "verification-page.errore-durante-la-verifica": "A problem occurred during verification",
      "verification-page.errore-in-verifica": "Verification Error",
      "verification-page.verifica": "Verify",
      "verification-result-info.errore-in-verifica": "Verification Error",
      "verification-result-info.verifica-completata-con-successo": "Verification completed successfully",
      "verification-result-info.verifica-completata-con-warning": "Verification completed with warning",
      "collapse.search-collapse-container.header": "Extended Search Panel",
      "main-menu.loading.aria-label": "Loading",
      "procedure.empty.title": "There is no data to display for this procedure",
      "task-card.outcomes.title": "Results",
      "task.payment-type.taxable": "Taxable Amount",
      "task.payment-type.total": "Total",
      "task.payment-type.vat": "VAT",
      "inquiry-type.save-button.copertina": "Save Cover",
      "inquiry-type.save-button.copertina-tooltip": "Save the inquiry cover",
      "inquiry-type.save-button.domanda": "Save Inquiry",
      "inquiry-type.save-button.domanda-tooltip": "Save the changes made to the inquiry",
      "inquiry-type.save-button.guida": "Save Guide",
      "inquiry-type.save-button.guida-tooltip": "Save the compilation guide",
      "inquiry-type.save-button.moduli": "Save Modules",
      "inquiry-type.save-button.moduli-tooltip": "Save the modules associated with the inquiry",
      "inquiry-type.save-button.modulo": "Save Module",
      "inquiry-type.save-button.modulo-tooltip": "Save the module; the changes will affect all inquiries that use it",
      "inquiry-type.save-button.sezione": "Save Section",
      "inquiry-type.save-button.sezione-tooltip": "Save the section; the changes will affect all modules that use it",
      "procedure.document.editor.classic": "Classic",
      "procedure.document.editor.light": "Light",
      "scope.ambito-modificato-con-successo": "Scope modified successfully",
      "scope.errore-in-modifica-ambito": "An error occurred while modifying the Scope",
      "sequenza-progressivo.crea-sequenza": "Create \"{{nome}}\"",
      "sequenza-progressivo.errore-creazione-sequenza": "An error occurred while creating the sequence",
      "sequenza-progressivo.formato-nome-sequenza": "The sequence name can only contain uppercase letters, numbers and underscores (max {{max}} characters)",
      "sequenza-progressivo.nessuna-sequenza-trovata": "No sequence found",
      "sequenza-progressivo.sequenza-esistente": "The sequence \"{{nome}}\" already exists: select it from the list",
      "front-header.logo.admin": "Admin",
      "front-header.logo.backoffice": "Back Office",
      "front-header.logo.domande": "Requests",
      "menu.area-pubblica": "Public Area",
      "menu.area-pubblica.sr-title": "Go to Public Area",
      "menu.verifica-tesserini": "Verify Cards",
      "menu.verifica-tesserini.sr-title": "Go to Verify Cards",
      "front-header.logout": "LOGOUT"
    }
  }
} as const;

export const i18nNamespaces = ["translation"] as const
